export default {
  nav: {
    home: '首页',
    articles: '文章',
    tech: '技术',
    software: '软件',
    tutorial: '教程',
    resource: '资源',
    news: '资讯',
    tools: '工具箱',
    about: '关于',
    sponsor: '会员',
    copyright: '版权声明'
  },
  header: {
    searchPlaceholder: '搜索文章...',
    searchMobilePlaceholder: '搜索文章、工具...',
    search: '搜索',
    navLabel: '导航',
    drawerHint: '滑动浏览 · 点按导航',
    openMenu: '打开菜单',
    closeMenu: '关闭菜单',
    langZh: '中文',
    langEn: 'EN'
  },
  footer: {
    nav: '导航',
    about: '关于',
    copyright: '版权声明',
    feedback: '反馈建议',
    followUs: '关注我们',
    channelsHint: '悬停或点击二维码可放大扫码',
    allRights: '版权所有',
    contactEmail: '联系邮箱',
    qrAlt: '{label}二维码',
    qrEnlarge: '{label}放大二维码',
    close: '关闭',
    wechatScan: '打开微信扫一扫',
    filingHint: '当前域名备案：{label}',
    filingHintEmpty: '当前域名备案'
  },
  home: {
    readMore: '阅读全文',
    noCarousel: '暂无轮播文章',
    noCarouselHint: '在后台文章管理中开启「首页轮播展示」',
    latest: '最新',
    featured: '精华',
    views: '阅读',
    softwareTitle: '软件推荐',
    softwareSubtitle: '精选实用软件，小工具、办公、开发应有尽有',
    tutorialTitle: '教程文章',
    tutorialSubtitle: '从入门到实战，系统化学习路径',
    resourceTitle: '资源分享',
    resourceSubtitle: '学习路线、开源项目、书籍推荐',
    techTitle: '技术文章',
    techSubtitle: '前端开发、工程化与性能优化',
    all: '全部',
    viewMore: '查看更多',
    techCatTitle: '{cat}技术文章',
    emptyCategory: '该分类暂无文章',
    seoIndex: '全站文章索引'
  },
  articles: {
    count: '共 {n} 篇文章',
    searchPrefix: '搜索：{q}',
    all: '全部',
    tech: '技术',
    software: '软件',
    tutorial: '教程',
    resource: '资源',
    news: '资讯',
    titleAll: '全部文章',
    titleTech: '技术文章',
    titleSoftware: '软件推荐',
    titleTutorial: '教程文章',
    titleResource: '资源分享',
    titleNews: '资讯动态',
    subCategory: '子分类',
    softwareCats: '软件分类',
    tutorialCats: '教程分类',
    resourceCats: '资源分类',
    techCats: '技术分类',
    tags: '标签',
    empty: '没有找到相关文章',
    featured: '精华'
  },
  article: {
    home: '首页',
    body: '正文',
    back: '返回',
    repostFrom: '转载自：',
    readMinutes: '约 {n} 分钟',
    readAbout: '读完约',
    views: '阅读',
    copyLink: '复制链接',
    loadingBody: '正在加载正文…',
    thanks: '感谢阅读',
    moreType: '更多{type}',
    related: '相关推荐',
    loading: '正在加载文章…',
    notFound: '文章不存在',
    backToList: '返回文章列表',
    translationFallback: '暂无英文译文，显示中文原文',
    original: '原创',
    repost: '转载',
    publishedAt: '发布于 {date}',
    updatedAt: '更新于 {date}',
    publish: '发布',
    update: '更新',
    copied: '链接已复制',
    copyFailed: '复制失败',
    uncategorized: '未分类',
    authorDefault: '博主',
    recommend: '推荐文章',
    hotTags: '热门标签',
    thisArticle: '本文信息',
    category: '分类',
    authorBio: '专注技术分享与内容创作',
    updatedShort: '更',
    list: '文章列表',
    copyright: {
      sectionLabel: '版权声明',
      badgeTitle: '文章版权声明',
      thisSite: '本站',
      prefixSiteName: '本网站名称：',
      prefixSiteUrl: '本站永久网址：',
      itemNetwork: '本网站的文章部分内容来源于网络，仅用于学习和交流，如有侵权请联系我们删除。',
      itemStance: '本网站所发布的资源，不代表本站立场，本站不对其真实性、合法性负责。',
      itemIllegal: '本网站不允许任何非法信息以及言论，如有发现，请立即联系我们进行删除处理。',
      itemLinks: '本网站资源部分存储于网盘，如发现链接失效，请留言告知，我们会尽快处理。',
      itemRights: '文章版权归作者所有，未经允许请勿转载。本站文章仅供学习交流，若涉及侵权，请在下方留言，我们会及时处理。'
    }
  },
  friendLinks: {
    title: '友情链接',
    subtitle: '与优秀站点互联互通'
  },
  share: {
    label: '分享',
    copyTo: '复制链接分享到{name}',
    preview: '卡片预览',
    collapse: '收起预览',
    copied: '已复制',
    copyLink: '复制链接',
    previewTip: '粘贴到微信、QQ 等平台时将显示以上卡片样式',
    wechat: '微信',
    qq: 'QQ',
    weibo: '微博'
  },
  lock: {
    login: '登录可见',
    member: '会员专享',
    paid: '付费内容',
    public: '公开',
    loginMsg: '登录后即可阅读本节内容',
    memberMsg: '开通会员后可阅读会员专享内容',
    paidMsg: '使用 {n} {name} 解锁本节内容',
    paidMsgPlain: '使用{name}解锁本节内容',
    myPoints: '我的{name}：',
    insufficient: '（不足 {n}）',
    loginRead: '立即登录阅读',
    openMember: '开通赞助会员',
    unlock: '{n} {name} 解锁',
    getPoints: '获取{name}',
    loginFirst: '先登录'
  },
  sharePage: {
    common: {
      loading: '加载中…',
      cannotOpen: '无法打开',
      cannotAccess: '无法访问',
      loadFail: '加载失败',
      copied: '已复制',
      copyFail: '复制失败',
      print: '打印',
      export: '下载导出',
      banned: '已封禁',
      closed: '已关闭',
      notFound: '无法打开',
      popup: '请允许弹出窗口后重试',
      printFail: '打印失败，请稍后重试',
      printOk: '已调起系统打印，可选择打印机或「存储为 PDF」',
      printWx: '若未出现打印面板，请点右上角⋯「在浏览器打开」后再打印',
      exportOk: '已调起导出，请在打印面板中选择「存储为 PDF」或分享',
      exportWx: '若未出现导出面板，请点右上角⋯「在浏览器打开」后选择存储为 PDF',
      brandMark: '青',
      brandName: '青苹果',
      learn: '了解',
      providedBy: '本页面由 wyqii.cn 提供',
      providedBySystem: '系统由 wyqii.cn 提供'
    },
    nav: {
      title: '选择导航',
      close: '关闭',
      opening: '正在打开…',
      open: '打开',
      copyAddr: '复制地址',
      cancel: '取消',
      hintWx: '微信内请优先用「微信地图导航」，可在地图页再选高德/腾讯 App',
      hintApp: '将直接唤起已安装的地图 App，不会跳转下载页',
      wechat: '微信地图导航',
      wechatDesc: '推荐 · 可在微信内直接选高德/腾讯导航',
      amap: '高德地图',
      amapDesc: '直接打开高德 App 导航',
      amapWx: '尝试唤起高德（微信内可能受限）',
      amapAddr: '按地址打开高德',
      tencent: '腾讯地图',
      tencentDesc: '直接打开腾讯地图 App',
      tencentWx: '通过腾讯地图链接打开',
      tencentAddr: '按地址打开腾讯地图',
      apple: '苹果地图',
      appleDesc: '系统地图导航',
      failWx: '未能打开{name}，请改用上方「微信地图导航」',
      failApp: '未能打开{name}，请确认已安装该 App',
      openFail: '打开失败',
      addrCopied: '地址已复制',
      destination: '目的地'
    },
    doc: {
      altH5: '访问二维码',
      altMini: '小程序码',
      altVerify: '验真',
      verifyTip: '扫码核验是否为本站开具',
      scanVerify: '扫码验真',
      siteIssued: '本站开具',
      siteIssuedNo: '本站开具 · No. 核验',
      sealMark: '（盖章）',
      amountLower: '金额（小写）',
      amountUpper: '金额（大写）',
      orgInfo: '单位信息',
      noLines: '暂无明细',
      amountCn: '大写',
      idNoOf: '证件号：{v}',
      emptyBody: '（暂无正文）',
      clauseLabel: '条款',
      bothSigned: '双方已签署',
      signA: '甲方签署',
      signB: '乙方签署',
      altSignA: '甲方签名',
      altSignB: '乙方签名',
      operatorOf: '经办人：{name}',
      issueDateOf: '开具日期：{d}',
      contactOf: '联系方式：{v}',
      addressOf: '地址：{v}',
      signPlaceOf: '签订地点：{v}',
      signerOf: '签署人：{name}',
      dateOf: '日期：{d}'
    },
    wifi: {
      cannotOpen: '无法打开分享',
      goMake: '去制作 WiFi 链接',
      eyebrow: '扫码即连',
      desc: '使用微信扫一扫下方小程序码，确认后即可连接该网络',
      altQr: 'WiFi 小程序码',
      qrUnavailable: '小程序码暂不可用',
      copyOpen: '复制打开链接',
      copyText: '复制分享文案',
      dlQr: '下载小程序码',
      tip: '推荐把「打开链接」发给好友；对方用浏览器或微信打开本页后，扫码即可进入小程序连接页。',
      providedByPrefix: '当前页面由',
      providedBySuffix: '提供',
      needCode: '缺少分享码',
      missing: '分享不存在',
      linkCopied: '打开链接已复制',
      textCopied: '分享文案已复制'
    },
    receipt: {
      badge: '电子收据',
      blockedTitle: '已停止加载',
      blockMsg: '检测到开发者工具或异常调试环境，已禁止加载收据内容。请关闭控制台后刷新页面。',
      titleRestricted: '访问受限',
      notFoundDesc: '收据不存在或已删除',
      bannedDesc: '该收据已被管理员封禁',
      closedDesc: '创建者已关闭访问'
    },
    quote: {
      badge: '电子报价单',
      verify: '编号验真',
      notFoundDesc: '报价单不存在或已删除',
      bannedDesc: '该报价单已被管理员封禁',
      closedDesc: '创建者已关闭访问'
    },
    contract: {
      badge: '电子合同',
      goSign: '去签署',
      signTitle: '手写签署',
      signLead: '请选择身份，填写姓名并在下方区域签名后提交',
      partyA: '甲方 · {name}',
      partyB: '乙方 · {name}',
      pending: '待签署',
      signerName: '签署人姓名',
      phName: '请输入真实姓名',
      canvasHint: '请在此区域手写签名',
      clear: '清除',
      submitting: '提交中…',
      confirmSign: '确认签署',
      bothDone: '双方均已签署完成',
      needName: '请填写签署人姓名',
      needInk: '请先手写签名',
      signOk: '签署成功',
      signFail: '签署失败',
      notFoundDesc: '合同不存在或已删除',
      bannedDesc: '该合同已被管理员封禁',
      closedDesc: '创建者已关闭访问',
      pendingReview: '审核中',
      pendingReviewDesc: '合同正在审核，请稍后再试'
    },
    card: {
      make: '制作名片',
      unavailable: '名片不可用',
      goMake: '去制作电子名片',
      altMap: '位置地图',
      locBadge: '位置',
      mapNav: '地图导航',
      goNav: '去导航',
      brandDefault: '青苹果电子名片',
      brandSub: '免费制作同款',
      coordSet: '已设置坐标',
      needCode: '缺少名片码',
      missing: '名片不存在',
      titleSuffix: '{name} · 青苹果',
      defaultTitle: '电子名片',
      wechatCopied: '微信号已复制',
      scanWechat: '请长按名片中的二维码添加微信',
      wechatLine: '微信 {id}',
      infoCopied: '名片信息已复制',
      actCall: '打电话',
      actSms: '发短信',
      actWechat: '加微信',
      actMap: '导航',
      actEmail: '发邮件',
      actCopy: '复制',
      actWebsite: '官网',
      phName: '姓名',
      scanAdd: '扫码添加微信',
      altWechatQr: '微信二维码',
      initial: '名'
    },
    comment: {
      opening: '正在打开评语…',
      unavailable: '评语不可用',
      dear: '亲爱的同学',
      student: '同学',
      insight: '老师眼中的你',
      bodyOf: '{type}正文',
      empty: '老师尚未填写评语，请稍后再看。',
      typeLabel: '评语类型',
      date: '日期',
      regards: '此致',
      teacher: '班主任',
      wishLabel: '寄语',
      typeFinal: '期末评语',
      typeMid: '期中评语',
      typeTerm: '学期评语',
      typeDaily: '日常评语',
      commentWord: '评语',
      titleFallback: '学生评语',
      initial: '同',
      missing: '评语不存在或已关闭分享',
      wishFinal: '把这学期的闪光点带回家',
      hintFinal: '学期将尽，把收获带回家，把期待留给新学期。',
      wishMid: '后半学期，继续发光',
      hintMid: '学期过半，继续保持，后半程会更出色。',
      wishTerm: '这一学期的成长都被看见',
      hintTerm: '整学期的成长，都值得被看见。',
      wishDaily: '日常里的每一点进步',
      hintDaily: '日常里的每一点进步，老师都看在眼里。'
    },
    receiptCheck: {
      badge: '本站开具 · 扫码验真',
      title: '收据真伪核验',
      lead: '输入收据上的编号（No.），核对是否由本站系统开出。',
      receiptNo: '收据编号',
      phNo: '如 R20260731XXXXXX',
      checking: '核验中…',
      checkNow: '立即核验',
      issuer: '收款单位',
      payer: '交款人',
      amount: '金额',
      date: '开具日期',
      purpose: '收款事由',
      provider: '开具系统',
      needNo: '请输入收据编号',
      failLabel: '核验失败',
      retry: '请稍后重试'
    },
    quoteCheck: {
      badge: '本站开具 · 扫码验真',
      title: '报价单真伪核验',
      lead: '输入报价单上的编号，核对是否由本站系统开出。',
      quoteNo: '报价编号',
      quoteNoField: '报价单编号',
      phNo: '如 Q20260804XXXXXX',
      checking: '核验中…',
      checkNow: '立即核验',
      summary: '核验摘要',
      defaultTitle: '报价单',
      total: '合计',
      seller: '报价方',
      buyer: '客户',
      quoteDate: '报价日期',
      validUntil: '有效期至',
      itemCount: '明细条数',
      amountCn: '金额大写',
      provider: '开具系统',
      footTip: '核验仅证明编号对应的开具记录；请同时核对纸质/电子件上的金额、客户与报价方信息是否一致。',
      needNo: '请输入报价单编号',
      failLabel: '核验失败',
      retry: '请稍后重试'
    },
    gift: {
      readonly: '只读查看',
      make: '制作礼薄',
      unavailable: '分享不可用',
      goMake: '去制作礼薄',
      protected: '受保护的礼薄',
      defaultTitle: '礼薄分享',
      pwdLead: '输入访问密码后即可查看，无需登录。内容只读，不可修改。',
      phPwd: '访问密码',
      pwdHint: '验证通过后，本机 24 小时内无需重复输入',
      viewBook: '查看礼薄',
      backList: '返回礼薄列表',
      readonlyOf: '只读 · {title}',
      stats: '{n} 笔 · 合计 ¥{amt}',
      asc: '正序',
      desc: '倒序',
      phSearch: '搜索姓名 / 备注',
      search: '搜索',
      moreFilter: '更多筛选',
      amountMin: '金额≥',
      amountMax: '金额≤',
      clear: '清空',
      apply: '应用',
      colName: '姓名',
      colAmt: '金额',
      colRemark: '备注',
      empty: '暂无匹配记录',
      crossSearch: '跨礼薄搜索 · 只读',
      matchN: '匹配 {n} 笔',
      hitBooks: '涉及 {n} 本',
      phSearchMore: '继续搜索姓名 / 备注',
      heroEyebrow: '人情往来 · 清晰可查',
      booksN: '共 {n} 本',
      entriesN: '{n} 笔',
      total: '合计 ¥{amt}',
      listHint: '可直接搜索全部礼薄，或点击某一本查看明细。内容只读不可编辑。',
      phSearchAll: '搜索全部礼薄：姓名 / 备注',
      openMini: '在小程序中打开',
      openMiniTip: '微信内可直达小程序；也可扫码进入同一分享。',
      openMiniBtn: '打开小程序',
      copyPage: '复制网页链接',
      pageCopied: '网页链接已复制',
      altQr: '小程序码',
      wechatScan: '微信扫一扫',
      bookStats: '{n} 笔 · ¥{amt}',
      needKeyword: '请输入搜索关键词',
      badPwd: '访问密码不正确',
      searchFail: '搜索失败',
      missing: '分享不存在或已失效',
      noBook: '未找到该礼薄'
    },
    order: {
      loading: '加载菜单…',
      tableOrder: '{name} · 专用点餐',
      eMenu: '电子菜单',
      myOrders: '我的订单',
      cannotOrder: '当前不可点餐',
      dineIn: '堂食',
      takeaway: '外卖',
      pickTable: '选择桌台',
      noTables: '暂无桌台，请联系商家',
      addrTitle: '收货信息',
      collapse: '收起',
      edit: '修改',
      fill: '填写',
      phContact: '联系人',
      phPhone: '手机号',
      phAddr: '收货地址',
      phDetail: '门牌号等（可选）',
      saveAddr: '保存地址',
      cart: '{n} 件 · ¥{amt}',
      phRemark: '备注（可选）',
      submitting: '提交中…',
      submit: '提交订单',
      success: '下单成功',
      orderNo: '单号 {no}',
      total: '合计 ¥{amt}',
      viewMy: '查看我的订单',
      continue: '继续点餐',
      myTitle: '我的点餐记录',
      refresh: '刷新',
      historyTip: '仅显示本机下过的订单，可查看状态与时间',
      emptyOrders: '暂无点餐记录',
      orderedAt: '下单 {t}',
      updatedAt: '更新 {t}',
      remarkOf: '备注：{r}',
      close: '关闭',
      open: '营业中',
      paused: '暂停点餐',
      recCat: '推荐',
      loadOrdersFail: '加载订单失败',
      needAddr: '请填写联系人、电话与地址',
      addrSaved: '地址已保存到本机',
      pickDish: '请先选择菜品',
      pickTableWarn: '请选择桌台',
      needShip: '请填写收货信息',
      orderOk: '下单成功',
      orderFail: '下单失败',
      notFoundDesc: '菜单不存在或已删除',
      bannedDesc: '该菜单不可访问',
      disabled: '已停用',
      disabledDesc: '商家已停用此菜单',
      closed: '已打烊',
      closedDesc: '商家已打烊',
      offHours: '非营业时间',
      offHoursDesc: '当前不在营业时间内'
    },
    electric: {
      mark: '电',
      brand: '电费记录',
      make: '制作电房',
      unavailable: '分享不可用',
      protected: '受保护的{type}',
      pwdLead: '输入访问密码后即可查看抄表与用量，内容只读。',
      phPwd: '访问密码',
      pwdHint: '验证通过后，本机 30 天内无需重复输入',
      view: '查看',
      overview: '电房总览 · 只读',
      price: '电价 {n} 元/度',
      months: '展示近 {n} 个月',
      main: '总表',
      sub: '分表',
      priceShort: '{n}元/度',
      compare: '账期对比',
      noData: '暂无抄表数据',
      vsLast: '对比上月',
      subTotal: '分表合计',
      diff: '差额',
      reading: '读数 {n}',
      usage: '用量 {n}',
      mainPreview: '总表预览',
      tenantMeter: '房客电表',
      readonly: '只读',
      ofRoom: '所属电房：{name}',
      monthsOf: '近 {n} 个月',
      colPeriod: '账期',
      colReading: '读数',
      colUsage: '用量',
      colCost: '电费',
      colTime: '时间',
      colRemark: '备注',
      empty: '暂无记录',
      foot: '由 wyqii.cn 电费记录提供',
      typeMeter: '电表',
      typeRoom: '电房',
      titleSuffix: '{name} · 电费记录',
      meterSuffix: '{name} · 电表',
      badPwd: '密码错误'
    },
    task: {
      mark: '任',
      brand: '任务提交',
      make: '制作任务板',
      login: '登录',
      unavailable: '分享不可用',
      protected: '受保护的任务板 · {role}',
      pwdLead: '输入访问密码后继续',
      phPwd: '访问密码',
      pwdHint: '验证通过后，本机 30 天内无需重复输入',
      enter: '进入',
      invite: '{role} · 邀请协作',
      defaultDesc: '协作任务板',
      phSearch: '搜索已提交任务：标题、说明、提交人、执行人…',
      clear: '清除',
      submitTitle: '提交任务',
      submitTip: '填写标题即可提交；可附图说明（自动压缩为 WebP）',
      logged: '已登录 · {name}',
      guestOk: '访客可提交',
      needLoginTag: '需登录提交',
      needLoginStrong: '此任务板需要登录后提交',
      needLoginP: '登录后即可提交任务与上传图片，账号信息会自动作为提交人。',
      loginNow: '立即登录',
      boardTasks: '本板任务',
      unlimited: '不限',
      remain: ' · 还可提交 {n}',
      unlimitedHard: ' · 不限（系统上限 {n}）',
      quotaFull: '任务数已达上限，暂无法提交',
      title: '任务标题',
      phTitle: '例如：首页 Banner 替换',
      desc: '说明（可选）',
      phDesc: '补充需求细节、验收标准…',
      nick: '你的昵称',
      phNick: '方便执行人联系你',
      photos: '附图（可选，最多 9 张）',
      uploadHint: '可点击上传，也可 Ctrl+V 粘贴截图 · 自动转 WebP',
      uploading: '上传中…',
      loginToSubmit: '已有账号？登录后提交',
      list: '任务列表',
      showing: '显示 {a} / {b}',
      noMatch: '没有匹配的任务',
      empty: '暂无任务',
      meta: '提交 {s} · 执行 {a}',
      unassigned: '未指派',
      rejectOf: '驳回：{r}',
      doing: '进行中',
      complete: '完成',
      reject: '驳回',
      loggedUser: '已登录',
      roleView: '只读',
      roleSubmit: '可提交',
      roleExec: '可执行',
      roleAccess: '访问',
      all: '全部',
      stPending: '待处理',
      stDoing: '进行中',
      stDone: '已完成',
      stRejected: '已驳回',
      loginFirst: '请先登录后再{reason}',
      needCode: '缺少分享码',
      defaultBoard: '任务板',
      titleSuffix: '{name} · 任务提交',
      badPwd: '密码错误',
      loginUpload: '上传图片',
      quotaWarn: '任务数已达上限',
      max9: '最多上传 9 张图片',
      uploadFail: '上传失败',
      imgAdded: '图片已添加（WebP）',
      needTitle: '请填写标题',
      needNick: '请填写昵称，或登录后提交',
      submitted: '已提交',
      submitFail: '提交失败',
      updated: '已更新',
      fail: '失败',
      rejectPrompt: '请输入驳回理由',
      rejectTitle: '驳回任务',
      rejectPreset: '无法实现',
      rejectPh: '如：无法实现 / 需要延期'
    },
    live: {
      iframeTitle: '活码页面',
      protected: '受保护的活码',
      pwdLead: '请输入访问密码后继续',
      phPwd: '访问密码',
      pwdHint: '验证通过后，本机 24 小时内无需重复输入',
      view: '查看内容',
      notFoundDesc: '活码不存在或已删除',
      bannedDesc: '该活码已被管理员封禁',
      pending: '审核中',
      pendingDesc: '内容审核通过后即可访问',
      rejected: '未通过审核',
      rejectedDesc: '内容未通过审核，暂不可访问',
      closedDesc: '创建者已关闭访问',
      notStarted: '尚未开始',
      notStartedDesc: '还未到可访问时间',
      expired: '已过期',
      expiredDesc: '访问时间已结束',
      needPwd: '需要密码',
      needPwdDesc: '请输入访问密码',
      needPwdWarn: '请输入密码',
      badPwd: '密码不正确',
      verifyFail: '验证失败'
    }
  },
  tools: {
    badge: '在线工具箱',
    heroTitle: '实用工具，即开即用',
    heroDesc: 'PDF、图片、码制、站长、生活、运维与配置转换 — 全部在浏览器本地处理，安全快捷，无需上传服务器。',
    countTools: '款工具',
    countCats: '大分类',
    localPct: '本地处理',
    searchPlaceholder: '搜索工具，如 PDF 合并、二维码…',
    frequent: '常用工具',
    frequentHintLogin: '按你的使用习惯同步到账号，置顶可优先显示',
    frequentHintGuest: '本机记录最近使用；登录后可跨设备同步',
    clear: '清空',
    clearConfirm: '确定清空常用工具记录？',
    cleared: '已清空',
    pin: '置顶',
    unpin: '取消置顶',
    removeFrequent: '从常用移除',
    frequentEmpty: '使用过的工具会出现在这里，点击即可直达',
    all: '全部',
    toolsInCat: '{n} 个工具',
    empty: '没有找到匹配的工具',
    notFound: '工具不存在',
    backHub: '返回工具箱',
    allTools: '全部工具',
    loginRequired: '登录后使用',
    loginTip: '该工具需要登录账号后才能使用，登录后可在浏览器本地安全处理文件。',
    loginNow: '立即登录',
    tip: '提示',
    onlineTool: '在线工具',
    ui: {
      drop: '点击或拖拽文件到此处',
      localHint: '支持本地处理，文件不会上传到服务器',
      localHintMax: '支持本地处理，单张不超过 {n}MB',
      fileTooLarge: '文件不能超过 {n}MB',
      process: '开始处理',
      convert: '转换',
      copy: '复制',
      copied: '已复制',
      copyManual: '请手动选择复制',
      paste: '粘贴',
      pasted: '已粘贴',
      clipboardFail: '无法读取剪贴板',
      copyFail: '复制失败',
      input: '输入',
      output: '输出',
      encode: '编码',
      decode: '解码',
      escape: '转义',
      unescape: '反转义',
      format: '格式化',
      minify: '压缩',
      lookup: '查询',
      yes: '是',
      no: '否',
      swapIo: '上下交换',
      result: '结果…',
      optional: '可选',
      required: '必填',
      done: '处理完成',
      fail: '处理失败',
      generate: '生成',
      genOk: '生成成功',
      genFail: '生成失败',
      recognize: '识别',
      recOk: '识别成功',
      download: '下载',
      downloadImage: '下载图片',
      preview: '预览',
      empty: '留空',
      refresh: '刷新',
      search: '搜索',
      clear: '清除',
      share: '分享',
      export: '导出',
      manage: '管理',
      add: '添加',
      close: '关闭',
      create: '创建',
      action: '操作',
      remark: '备注',
      loadFail: '加载失败',
      saveFail: '保存失败',
      deleted: '已删除',
      updated: '已更新',
      created: '已创建',
      saved: '已保存',
      exportFail: '导出失败',
      opFail: '操作失败',
      hasPwd: '有密码',
      public: '公开',
      quotaAdmin: '管理员已单独设置',
      needName: '请填写名称',
      unlimited: '不限',
      enabled: '已启用',
      disabled: '未启用',
      memberOnly: '会员专属',
      token: '令牌',
      rotateToken: '轮换令牌',
      enableToken: '启用并生成令牌',
      closeApi: '关闭 API',
      openApi: '开放 API'
    },
    pdf: {
      config: '处理参数',
      dropPdf: '上传 PDF 文件',
      dropPdfs: '上传多个 PDF 文件',
      dropImages: '上传一张或多张图片',
      dropFirst: '上传第一个 PDF',
      dropSecondAlt: '上传第二个 PDF（交替穿插）',
      dropInsert: '上传要插入的 PDF',
      dropLogo: '上传水印 / Logo 图片',
      dropSign: '上传签名图片（可选）',
      splitRange: '拆分范围（如 1-3;5;8-10）',
      splitPh: '留空表示整本一份',
      deletePages: '删除页码（如 1-3,5,8-10）',
      exportFormat: '导出格式',
      page: '页码',
      signText: '签名文字',
      rotateAll: '整本统一旋转',
      rotateHint: '也可在下方缩略图为单页单独设置',
      pageN: '第 {n} 页',
      angle: '角度',
      reorderHint: '拖拽调整顺序（也可点左右箭头）',
      origPage: '#{i} · 原第 {n} 页',
      insertAfter: '插入位置（第几页之后，0=开头）',
      marginTop: '上边距 (pt)',
      marginBottom: '下边距 (pt)',
      marginLeft: '左边距 (pt)',
      marginRight: '右边距 (pt)',
      headerH: '页眉高度 (pt)',
      footerH: '页脚高度 (pt)',
      paper: '目标纸张',
      nup: '拼版',
      wmText: '水印文字',
      wmPh: '支持多行',
      fontSize: '字号',
      opacity: '透明度',
      rotate: '角度',
      color: '颜色',
      mode: '模式',
      tile: '平铺',
      center: '居中',
      qrContent: '二维码内容',
      qrPh: '链接或文本',
      scale: '缩放',
      position: '位置',
      posCenter: '居中',
      posBR: '右下',
      posTR: '右上',
      posBL: '左下',
      posBC: '底部居中',
      posBR2: '底部靠右',
      posTC: '顶部居中',
      pageStart: '起始页码',
      template: '模板',
      header: '页眉',
      footer: '页脚',
      metaTitle: '标题',
      metaAuthor: '作者',
      metaSubject: '主题',
      metaKeywords: '关键词',
      metaCreator: '创建者',
      metaProducer: '制作程序',
      gray: '灰度',
      bw: '黑白',
      format: '格式',
      extract: '提取结果',
      links: '链接列表（{n}）',
      loadMeta: '读取当前元数据',
      preview40: '仅预览前 40 页（共 {n} 页），处理仍作用于全部页面',
      metaLoaded: '已读取元数据（共 {n} 页）',
      readFail: '读取失败',
      pdfReady: 'PDF 已生成并开始下载',
      mergeOk: '合并完成',
      altMergeOk: '交替合并完成',
      exportedImgs: '已导出 {n} 张图片',
      splitOk: '已拆分为 {n} 个文件',
      compressOk: '压缩完成（浏览器端基础优化）',
      optimizeOk: '优化完成',
      unlockOk: '已尝试移除权限限制并重存',
      deletedPages: '已删除 {n} 页',
      blankOk: '已删除空白页：{pages}',
      rotateOk: '旋转完成',
      reverseOk: '逆序完成',
      reorderOk: '重排完成',
      reorderPartial: '重排完成（前 {n} 页已调整，其余保持原序）',
      waitThumbs: '请等待缩略图生成后再排序',
      needPages: '请指定要删除的页码',
      noImages: '未找到可提取的内嵌图片',
      noLinks: '未找到超链接',
      unknown: '未知工具',
      insertOk: '插入完成',
      cropOk: '裁剪完成',
      hfOk: '已按边距裁切页眉页脚区域',
      sizeOk: '统一尺寸完成',
      nupOk: '拼版完成',
      wmTextOk: '文字水印已添加',
      wmLogoOk: 'LOGO 水印已添加',
      wmQrOk: '二维码水印已添加',
      pageNumOk: '页码已添加',
      hfAddOk: '页眉页脚已添加',
      textOk: '文字已提取并下载',
      extractImgs: '已提取 {n} 张图片',
      extractLinks: '已提取 {n} 个链接',
      metaSaved: '元数据已保存',
      metaCleared: '元数据已清除',
      grayOk: '灰度 / 黑白转换完成',
      longOk: '超长图已导出',
      signOk: '签名 PDF 已导出',
      actions: {
        'pdf-to-images': '导出图片',
        'images-to-pdf': '生成 PDF',
        'pdf-split': '拆分 PDF',
        'pdf-merge': '合并 PDF',
        'pdf-merge-alt': '交替合并',
        'pdf-compress': '压缩 PDF',
        'pdf-optimize': '优化并下载',
        'pdf-delete-pages': '删除并导出',
        'pdf-blank-pages': '删除空白页',
        'pdf-rotate': '旋转并下载',
        'pdf-reverse': '逆序并下载',
        'pdf-reorder': '按新顺序导出',
        'pdf-insert': '插入并下载',
        'pdf-crop': '裁剪并下载',
        'pdf-page-size': '统一尺寸并下载',
        'pdf-nup': '拼版并下载',
        'pdf-watermark': '添加水印',
        'pdf-logo-watermark': '添加 LOGO 水印',
        'pdf-qr-watermark': '添加二维码水印',
        'pdf-page-number': '添加页码',
        'pdf-header-footer': '添加页眉页脚',
        'pdf-remove-hf': '裁切并下载',
        'pdf-extract-text': '提取文字',
        'pdf-extract-images': '提取图片',
        'pdf-extract-links': '提取链接',
        'pdf-metadata': '保存元数据',
        'pdf-clear-metadata': '清除并下载',
        'pdf-grayscale': '转换并下载',
        'pdf-long-image': '导出长图',
        'pdf-unlock': '解锁并下载',
        'pdf-sign': '添加签名并导出'
      }
    },
    image: {
      drop: '上传图片',
      dropStitch: '上传多张图片进行拼接',
      dropResize: '上传要缩小的图片',
      srcSize: '原图尺寸',
      resizeMode: '缩放方式',
      custom: '自定义宽高',
      percent: '按比例',
      maxSide: '限制最长边',
      lockRatio: '锁定比例',
      lockTip: '开启后改宽或高，另一边按原图比例自动计算',
      width: '目标宽度',
      height: '目标高度',
      ratioBase: '以谁为准',
      byWidth: '以宽度为准',
      byHeight: '以高度为准',
      scale: '缩放比例',
      scaleTip: '例如 10% 可将 1024px 缩到约 102px',
      maxW: '最大宽度',
      maxH: '最大高度',
      maxTip: '在框内等比缩小，不会放大超过原图',
      exportFmt: '导出格式',
      keepFmt: '原格式',
      quality: '导出质量',
      preview: '预览结果',
      scaleAbout: '（约 {n}）',
      scaleWH: '宽 {w}% / 高 {h}%',
      stitchH: '横向拼接',
      stitchV: '纵向拼接',
      block: '块大小',
      maxBytes: '最大体积',
      qualityShort: '质量',
      wmPh: '水印文字',
      pos: '位置',
      readFail: '无法读取图片尺寸',
      resized: '已缩小为 {w}×{h}，开始下载',
      gridOk: '九宫格图片已打包下载',
      doneDl: '处理完成，已开始下载'
    },
    code: {
      inputPh: '输入文本或链接',
      copybookPh: '输入汉字，如：青苹果博客',
      logo: '上传 Logo 图片',
      uploadCode: '上传含码图片',
      tabFile: '上传图片',
      tabCam: '摄像头扫码',
      stopScan: '停止扫码',
      startCam: '开启摄像头',
      camDefault: '请允许浏览器使用摄像头权限。',
      hintQr: '将二维码对准取景框…',
      hintBar: '将一维条码对准取景框…',
      hintDm: '将 DataMatrix 码对准取景框…',
      hintHx: '将汉信码对准取景框…',
      tipQr: '建议在光线充足处使用后置摄像头，识别成功后会自动停止。',
      tipBar: '条码请尽量水平对准取景框，保持清晰无反光。',
      tipDm: 'DataMatrix 为正方形点阵码，请完整放入取景框。',
      tipHx: '请将完整汉信码放入取景框，保持清晰无反光；识别成功后会自动停止。',
      hintDefault: '将码对准取景框…',
      camDenied: '无法访问摄像头，请检查浏览器权限或使用 HTTPS',
      scanOk: '扫码成功',
      recFail: '识别失败，请换一张清晰的图片',
      camUnsupported: '当前环境不支持摄像头',
      videoNotReady: '视频组件未就绪'
    },
    convert: {
      tip: '粘贴配置规则，点击转换。复杂规则请人工核对后使用。',
      swap: '交换输入/输出',
      copyOut: '复制结果',
      phApache: '粘贴 Apache .htaccess 规则…',
      phNginx: '粘贴 Nginx rewrite 规则…'
    },
    ts: {
      tip: 'Unix 时间戳与日期时间互转，支持秒 / 毫秒；左侧改时间戳、右侧改日期，即时同步。',
      tsToDate: '时间戳 → 日期',
      dateToTs: '日期 → 时间戳',
      tsPh: '如 1704067200 或 1704067200000',
      nowSec: '当前秒',
      nowMs: '当前毫秒',
      local: '本地时间',
      utc: 'UTC',
      iso: 'ISO',
      weekday: '星期',
      weekdayVal: '周{d}',
      seconds: '秒级',
      millis: '毫秒',
      pickDate: '选择日期时间',
      datePh: '或粘贴：2024-01-01 12:00:00',
      secTs: '秒级时间戳',
      msTs: '毫秒时间戳',
      localShort: '本地',
      parseTs: '无法解析时间戳',
      invalidDate: '日期无效',
      parseDate: '无法解析日期',
      days: {
        日: '日',
        一: '一',
        二: '二',
        三: '三',
        四: '四',
        五: '五',
        六: '六'
      }
    },
    wm: {
      urlMode: '编码模式',
      urlAll: '全编码',
      phText: '输入文本',
      phUrl: '输入 URL 或文本',
      phJson: '粘贴 JSON',
      radix: '进制转换',
      radixFrom: '源进制',
      baseN: '{n} 进制',
      autoBase: '自动识别',
      phRadix: '如 255、0xff、0b1010',
      htmlEsc: 'HTML 转义',
      phHtml: '输入 HTML / 文本',
      uuidTip: '生成 RFC4122 UUID v4（随机）。',
      genUuid: '生成 UUID',
      genUuid5: '生成 5 个',
      phUnicode: '输入文本或 \\uXXXX',
      phHash: '输入要哈希的文本',
      encodeFail: '编码失败',
      decodeFail: '解码失败',
      jsonErr: 'JSON 格式错误: {msg}',
      convertFail: '转换失败',
      dec: '十进制',
      bin: '二进制',
      oct: '八进制',
      hex: '十六进制',
      b32: '32 进制',
      b36: '36 进制',
      metaTitle: '标题',
      metaDesc: '描述',
      metaKw: '关键词',
      metaUrl: '链接',
      metaImg: '图片',
      ogImg: 'OG 图片 URL',
      copyCode: '复制代码',
      allowAll: '允许全部',
      disallow: '禁止路径',
      copyRobots: '复制 robots.txt'
    },
    json: {
      tip: 'JSON 格式化、压缩、校验、解析树浏览与搜索；可复制路径 / 键 / 值。超大 JSON 按需加载，本地处理不截断。',
      validate: '校验',
      parse: '解析',
      reparse: '重新解析',
      sortKeys: '键排序',
      escapeStr: '转义为字符串',
      unescape: '去转义',
      indentN: '缩进 {n}',
      phIn: '粘贴 JSON…',
      done: '完成',
      fmtOk: '格式化成功',
      minOk: '压缩成功',
      sorted: '键已排序',
      escaped: '已转义为 JSON 字符串',
      escapeFail: '转义失败',
      unescaped: '已去除转义',
      unescapeFail: '去转义失败',
      parseOk: '解析成功，可在下方树中浏览与搜索（超大 JSON 按需加载，不会截断）',
      parseOkLarge: '解析成功。文档较大，树节点按展开分批加载，数据本身完整未截断',
      parseFail: '解析失败',
      treeTitle: '解析浏览',
      treeEmpty: '输入有效 JSON 后点「解析」，即可树形浏览',
      searchPh: '搜索键、值、路径或类型…',
      hitCount: '命中 {n} 处',
      expandAll: '展开已加载',
      collapseAll: '全部收起',
      expandAllHint: '已展开当前节点，并为每个容器加载一批（每批 {n}）。更大子项请点「加载更多」',
      loadMore: '加载更多（已 {progress}，每批 {n}）',
      loadAllChildren: '加载全部子项',
      path: '路径',
      key: '键名',
      value: '值',
      copyValue: '复制值',
      copyKv: '复制键值',
      copyJson: '复制 JSON',
      copyPathVal: '复制路径+值',
      copyLine: '复制一行',
      useAsInput: '作为新输入',
      usedAsInput: '已将该节点设为输入',
      selectNode: '点击左侧节点查看详情',
      sample: '示例',
      download: '下载',
      downloaded: '已下载 data.json',
      statType: '类型',
      statItems: '顶层项',
      statBytes: '字节',
      statNodes: '节点',
      statLoaded: '已加载',
      statEstimate: '约计节点',
      statDepth: '深度',
      truncated: '节点过多，已截断',
      searchCapped: '搜索已达上限',
      searchCappedHint: '搜索命中 {n} 处（已扫描 {scanned} 个节点）。原始 JSON 完整未截断；树中优先展示部分命中，可缩小关键词精确定位',
      loadAllDone: '该节点子项已全部加载'
    },
    fmt: {
      tip: 'HTML / JS / CSS / XML / PHP 格式化与压缩；支持 XML↔JSON、PHP 源码混淆加密。本地处理，不上传。',
      xmlJson: 'XML ↔ JSON',
      phpEnc: 'PHP 加密',
      copyOut: '复制结果',
      inputLang: '输入 · {lang}',
      phLang: '粘贴 {lang} 代码…',
      xmlRoot: 'JSON→XML 根节点名',
      inXmlJson: '输入（XML 或 JSON）',
      phXmlJson: '粘贴 XML 或 JSON…',
      swap: '交换',
      encMode: '加密方式',
      encrypt: '加密 / 混淆',
      decrypt: '尝试解密',
      phpWarn: '仅做源码混淆，非强加密；可用于简单防直接阅读，不可替代真正的安全方案。',
      phpSrc: 'PHP 源码',
      phPhp: '粘贴 PHP 源码，例如：echo \'hello\';',
      fmtOk: '格式化成功',
      fmtFail: '格式化失败',
      minOk: '压缩成功',
      minFail: '压缩失败',
      xmlOk: 'XML → JSON 成功',
      jsonOk: 'JSON → XML 成功',
      convertFail: '转换失败',
      mixOk: '混淆完成',
      encFail: '加密失败',
      decOk: '解密完成',
      decFail: '解密失败'
    },
    byte: {
      tip: '输入数值并选择单位，换算为各字节单位。小数点按你输入的为准，不会自动补零。可选 1024（KiB/MiB）或 1000（KB/MB）进制。',
      ph: '输入数值，如 1024 或 1.5',
      base1024: '1024 进制',
      base1000: '1000 进制',
      unit: '单位',
      value: '数值',
      action: '操作',
      invalid: '请输入有效非负数字'
    },
    ascii: {
      tip: '输入英文字母、数字或常见符号，选择字体风格即可生成线条字（ASCII 艺术字）。可用 {nl} 或直接回车换行；中文暂不支持；粘贴到别处时请使用等宽字体。',
      ph: '例如：wyqii cn 或 Hello\\nWorld（\\n 表示换行）',
      font: '字体风格',
      layoutDefault: '默认布局',
      layoutFull: '全宽',
      layoutFitted: '适配',
      layoutSmush: '挤压',
      empty: '在上方输入文字后即可预览线条字',
      genFail: '生成失败，请检查输入或换一种字体',
      gallery: '全部风格预览',
      collapse: '收起',
      use: '使用',
      browse: '浏览全部字体效果',
      switched: '已切换为 {name}',
      qClassic: '经典',
      qStandard: '标准',
      qBig: '大号',
      qSlant: '斜体',
      qBanner: '横幅',
      qBlock: '方块',
      qBubble: '气泡',
      qDigital: '数码',
      qStar: '星战'
    },
    whois: {
      tabWhois: '域名 WHOIS',
      tabUa: 'User-Agent',
      tipWhois: '查询域名注册信息（WHOIS）。结果依赖服务器网络与目标注册局策略，部分域名可能受限。',
      domain: '域名：{d}',
      server: 'WHOIS 服务器：{s}',
      copyOut: '复制结果',
      empty: '未返回 WHOIS 内容',
      fail: 'WHOIS 查询失败',
      tipUa: '解析当前或自定义 User-Agent，并提供常用浏览器 / 小程序 / 爬虫预设一键复制。',
      useLocal: '使用本机 UA',
      phUa: '粘贴 User-Agent',
      parse: '解析',
      copyUa: '复制 UA',
      browser: '浏览器',
      os: '系统',
      device: '设备',
      engine: '引擎',
      mobile: '移动端',
      wechat: '微信',
      bot: '爬虫',
      length: '长度',
      presets: '常用预设',
      use: '使用'
    },
    mac: {
      tip: '根据 MAC / OUI 查询网卡厂商。本地收录约 {n} 条常见厂商，未命中时可尝试在线查询。',
      ph: '例如 AA:BB:CC:DD:EE:FF 或 AABBCC',
      online: '在线补查',
      fail: '查询失败',
      onlineFail: '在线查询失败',
      invalid: '请输入至少 6 位十六进制（OUI）或完整 MAC',
      mac: '规范化 MAC',
      oui: 'OUI',
      vendor: '厂商',
      unknown: '未找到',
      localBit: '本地管理位',
      multicast: '组播',
      source: '来源',
      srcLocal: '本地',
      srcNone: '未命中',
      srcOnline: '在线',
      tipHit: '命中本地常见厂商库',
      tipMiss: '本地库未收录，可尝试服务端在线查询',
      tipOnline: '在线查询命中',
      tipOnlineMiss: '在线亦未找到'
    },
    regex: {
      tip: '编写 / 测试正则，支持常用预设与元字符速查；可在线匹配高亮与替换。',
      presets: '常用预设',
      phPattern: '正则表达式',
      insert: '插入：',
      sample: '测试文本',
      phSample: '在此粘贴要匹配的文本',
      replace: '替换为（可选，$1 引用分组）',
      phReplace: '替换内容',
      test: '测试',
      copyRe: '复制正则',
      copyRepl: '复制替换结果',
      matches: '匹配结果',
      hit: '命中 {n} 处',
      none: '无匹配',
      pos: '位置',
      text: '匹配内容',
      groups: '分组',
      preview: '替换预览',
      tokens: '常用元字符',
      escapeSel: '转义选中/剪贴板文本',
      needCopy: '请先复制要转义的文本',
      escaped: '已转义为字面量正则',
      needPattern: '请输入正则表达式',
      invalid: '正则无效',
      replaceFail: '替换失败',
      runFail: '执行失败',
      g: 'g 全局',
      gTip: '匹配全部，而非只找第一个',
      i: 'i 忽略大小写',
      iTip: 'A 与 a 同等匹配',
      m: 'm 多行',
      mTip: '^ $ 匹配每行首尾',
      s: 's 点号通配',
      sTip: '. 可匹配换行',
      u: 'u Unicode',
      uTip: '按 Unicode 码点处理',
      y: 'y 粘滞',
      yTip: '从 lastIndex 位置连续匹配',
      p: {
        email: { name: '邮箱', desc: '常见邮箱格式' },
        'mobile-cn': { name: '中国大陆手机号', desc: '11 位手机号' },
        url: { name: 'URL / 网址', desc: 'http/https 链接' },
        ipv4: { name: 'IPv4', desc: 'IPv4 地址' },
        'id-card': { name: '身份证号', desc: '18 位身份证（结构校验）' },
        'date-ymd': { name: '日期 YYYY-MM-DD', desc: '年月日' },
        'time-hms': { name: '时间 HH:mm:ss', desc: '24 小时制' },
        chinese: { name: '中文字符', desc: '连续汉字' },
        number: { name: '整数 / 小数', desc: '数字' },
        'hex-color': { name: '十六进制颜色', desc: 'CSS 颜色' },
        username: { name: '用户名', desc: '字母开头 4～16 位' },
        password: { name: '强密码', desc: '大小写+数字+特殊字符，≥8' },
        'html-tag': { name: 'HTML 标签', desc: '简易标签匹配' },
        'blank-line': { name: '空行', desc: '空行或仅空白' },
        'trim-spaces': { name: '首尾空白', desc: '行首行尾空格' }
      }
    },
    pixel: {
      tip: '按 DPI 在像素与厘米 / 英寸 / 毫米之间换算；也可上传图片读取像素尺寸与 EXIF DPI。单张图片不超过 50MB。',
      ph: '输入数值',
      custom: '自定义',
      unit: '单位',
      value: '数值',
      action: '操作',
      fromImage: '从图片读取',
      drop: '上传图片读取宽高 / EXIF DPI',
      apply: '填入宽度并换算',
      print: '打印尺寸（{dpi} DPI）',
      px: '像素 (px)',
      inch: '英寸 (in)',
      cm: '厘米 (cm)',
      mm: '毫米 (mm)',
      dpi72: '72（屏幕）',
      dpi96: '96（Windows）',
      dpi150: '150（草稿印刷）',
      dpi300: '300（印刷）',
      readFail: '读取失败',
      invalid: '请输入有效数值'
    },
    net: {
      ipTitle: 'IP 归属地查询',
      ipDesc: '查询 IP 国家 / 省份 / 城市 / 运营商',
      ipPh: '输入 IPv4 地址，如 8.8.8.8',
      quick: '快捷：',
      continent: '大洲',
      country: '国家/地区',
      province: '省份',
      city: '城市',
      isp: '运营商',
      countryCode: '国家代码',
      latlng: '经纬度',
      raw: '原始数据',
      ipEmpty: '未找到此 IP 的归属信息',
      needIp: '请输入 IP 地址',
      domainTitle: '域名 IP 查询',
      domainDesc: '解析域名 A/AAAA 记录，并自动查询每个 IPv4 的离线归属地',
      domainPh: '输入域名，如 github.com 或 https://example.com',
      domainPrepend: '域名',
      resolve: '解析',
      ipCount: '{n} 个 IP',
      engineOff: 'IP 归属地离线库未就绪，仅展示 DNS 解析结果',
      noGeo: '暂无归属地数据',
      dnsRaw: '查看原始 DNS 记录（{n} 条）',
      needDomain: '请输入域名',
      resolveFail: '解析失败',
      speedTitle: '宽带测速',
      speedDesc: '测浏览器到本站的延迟、下载与上传速度。结果受服务器带宽与路径影响，不等于运营商套餐峰值。',
      downSize: '下载包大小',
      upSize: '上传包大小',
      startSpeed: '开始测速',
      stop: '停止',
      speedResult: '测速结果',
      latency: '延迟 (RTT)',
      downSpeed: '下载速度',
      upSpeed: '上传速度',
      downTime: '下载耗时',
      upTime: '上传耗时',
      transfer: '传输量',
      hintStart: '点击开始后将依次测延迟 → 下载 → 上传。',
      hintRun: '正在测速，请勿关闭页面…',
      hintDone: '测速完成。数值为本站路径实测，仅供参考。',
      hintStop: '已停止测速。',
      phasePing: '测延迟中…',
      phaseDown: '下载测速中…',
      phaseUp: '上传测速中…',
      phaseRun: '测速中…',
      speedOk: '测速完成',
      speedFail: '测速失败',
      downFail: '下载测速失败',
      qAliDns: '阿里 DNS',
      qBaidu: '百度',
      qSite: '本站'
    },
    netops: {
      latencyTitle: '主机延迟测试',
      latencyDesc: '对公网域名/IP 做 TCP 建连测速（非 ICMP Ping）。探测由本站服务器发出，禁止内网/回环目标。',
      latencyPh: '例如 1.1.1.1 或 www.baidu.com',
      startTest: '开始测试',
      quick: '快捷',
      target: '目标',
      resolvedIp: '解析 IP',
      port: '端口',
      reachable: '连通',
      ok: '成功',
      fail: '失败',
      avg: '平均延迟',
      minMax: '最小 / 最大',
      okCount: '成功次数',
      noteTcp: 'TCP 建连耗时，非 ICMP Ping',
      needTarget: '请输入域名或 IP',
      probeFail: '探测失败',
      lanTitle: '内网 IP 检查',
      lanDesc: '通过 WebRTC 候选与本站出口对照，查看本机可能的局域网地址与公网 IP（浏览器能力因环境而异）。',
      refresh: '重新检测',
      localIp: '疑似内网 IP',
      publicIp: '公网出口 IP',
      publicLoc: '公网归属',
      status: '状态',
      lanNote: '部分浏览器/公司网络会隐藏 host 候选；完整内网扫描请用小程序「内网 IP / 监控检测」。',
      detected: '已检测',
      undetected: '未检测',
      lanEmpty: '未能读取到地址，可换浏览器或改用小程序',
      lanFail: '检测失败',
      camTitle: '监控摄像头检测',
      camDesc: '同 Wi‑Fi 下严格探测海康 / 大华等监控静态资源（仅资源加载成功才计命中，避免把超时误报成摄像头）。',
      cam1: '通过 WebRTC 识别本机内网 IP，再探测常见 HTTP 端口上的厂商图片/脚本资源',
      cam2: '只有图片或脚本真正加载成功，或可读到厂商特征时才计入；超时/证书失败一律忽略',
      cam3: 'HTTPS 站点访问 http 摄像头可能被混合内容拦截；完整扫描请用小程序',
      cam4: '请仅扫描你有权管理的网络；同 IP 多端口会合并为一条结果',
      camSubnet: '推测网段',
      camRange: '扫描范围',
      camQuick: '快速网段',
      camDefaults: '常见默认',
      camFull: '全网段',
      camManual: '指定 IP',
      camManualPh: '例如 192.168.1.64',
      camStart: '一键检测',
      camScanning: '检测中…',
      camStop: '停止',
      camHintReady: '建议电脑/手机已连摄像头同一 Wi‑Fi，再点「一键检测」。',
      camHintNoIp: '未能读取内网 IP，仍可扫「常见默认」地址，或手动填写 IP。',
      camHintScan: '共 {n} 个探测点，请保持页面开启…',
      camFallbackDefaults: '未获得内网 IP，已改为扫描常见出厂默认地址。',
      camStopped: '已停止扫描。',
      camBadIp: '请输入合法 IPv4',
      camNeedPrivate: '仅支持扫描私网地址',
      camNeedWifi: '未检测到局域网 IP，请确认已连 Wi‑Fi',
      camLikely: '疑似监控设备（{n}）',
      camOther: '其它开放 Web 端口（{n}）',
      camEmpty: '暂无可靠命中。可试「常见默认 / 指定 IP」，或用微信小程序同网扫描。',
      camSuspect: '疑似监控',
      camOpen: '打开设备页',
      camDoneHit: '扫描完成：发现 {n} 个疑似监控设备',
      camDoneMiss: '扫描完成：未命中可靠特征（设备可能关 Web、改端口，或浏览器拦截了内网资源）',
      camFail: '扫描失败',
      camMixedWarn: '当前为 HTTPS 页面，浏览器可能拦截对 http:// 内网资源的加载。完整结果请用小程序「监控摄像头检测」。',
      privA: 'A 类私网 (10.0.0.0/8)',
      privB: 'B 类私网 (172.16.0.0/12)',
      privC: 'C 类私网 (192.168.0.0/16)',
      loopback: '回环',
      other: '疑似公网或其它',
      qBaidu: '百度',
      qAliDns: '阿里 DNS',
      qSite: '本站'
    },
    beian: {
      eyebrow: '站长合规 · 需登录',
      title: '备案信息查询',
      desc: '登录后可查询网站 / APP / 小程序 / 快应用 ICP 备案；会员可创建开放 API，供脚本与系统对接。',
      tabQuery: '在线查询',
      tabApi: '开放 API',
      member: '会员',
      try: '试试：',
      openOfficial: '打开官方查询',
      officialTitle: '前往公安部官方平台查询网安备案',
      keyword: '关键词：',
      copyKw: '复制关键词',
      total: '共 {n} 条',
      officialLink: '官方复核',
      empty: '未查到备案信息',
      apiTitle: '开放 API 开发说明',
      apiDesc: '会员可创建个人令牌，通过 HTTP 调用备案查询接口，适合脚本、运维与内部系统集成。',
      memberOn: '会员已开通',
      needMember: '需会员',
      apiOnlyMember: '开放 API 仅会员可用',
      apiOnlyMemberDesc: '网页查询登录即可；创建/轮换 API 令牌需要会员身份。',
      goMember: '去开通会员',
      goMemberHint: '开通后即可在此生成令牌并查看完整调用文档',
      token: 'API 令牌',
      enabled: '已启用',
      notCreated: '未创建',
      tokenHintOn: '令牌已存在。完整明文仅在创建/轮换时展示一次，遗失请重新轮换。',
      tokenHintOff: '点击下方按钮创建令牌，即可开始调用。',
      rotate: '轮换令牌',
      create: '创建 API 令牌',
      closeApi: '关闭 API',
      authTitle: '1. 鉴权方式',
      authBody: '在请求头携带令牌（推荐）：',
      authCompat: '兼容：',
      queryApiTitle: '2. 查询接口',
      copyUrl: '复制 URL',
      param: '参数',
      explain: '说明',
      fieldsTitle: '3. 返回字段',
      field: '字段',
      curlTitle: '4. cURL 示例',
      jsTitle: '5. JavaScript 示例',
      notesTitle: '6. 注意事项',
      footerTitle: '说明',
      footer1: '网页查询需登录账号；开放 API 需会员令牌。',
      footer2: 'ICP 数据依赖服务器上游；网安默认引导官方查询。',
      footer3: '权威结果以工信部 / 公安部官方平台为准。',
      typeWeb: '网站备案',
      typeApp: 'APP 备案',
      typeMapp: '小程序备案',
      typeKapp: '快应用备案',
      typeWangan: '网安备案',
      phWeb: '输入域名 / 备案号 / 主办单位，如 baidu.com',
      phApp: '输入 APP 名称 / 主办单位 / 备案号',
      phMapp: '输入小程序名称 / 主办单位 / 备案号',
      phKapp: '输入快应用名称 / 主办单位 / 备案号',
      phWangan: '输入域名，将引导至公安官方查询',
      phDefault: '输入查询关键词',
      prependDomain: '域名',
      prependKw: '关键词',
      hintWangan: '网安备案默认打开公安官方查询页；已配置付费上游时将直接返回结果。',
      hintIcp: '支持域名、服务名称、主办单位名称或备案号查询。',
      statusChecking: '正在检测服务…',
      statusApiMember: '会员开放 API',
      statusApiNeed: '开放 API 需会员',
      statusReady: 'ICP 查询已就绪',
      statusNotReady: 'ICP 上游未就绪',
      statusWait: '请稍候',
      statusApiOk: '可创建令牌并调用接口',
      statusApiHint: '请先开通会员',
      statusFail: '无法获取服务状态',
      loadApiFail: '加载开放 API 失败',
      confirmRotate: '轮换后旧令牌立即失效，确认继续？',
      confirmCreate: '将创建备案查询开放 API 令牌，确认？',
      confirmTitle: '开放 API',
      confirmClose: '关闭后令牌立即失效，确认？',
      closeTitle: '关闭开放 API',
      closed: '已关闭',
      record: '备案记录',
      fDomain: '域名',
      fSiteName: '网站名称',
      fOwner: '开办者',
      fOwnerType: '主体类型',
      fBeianCode: '备案号',
      fPolice: '备案机关',
      fBeianDate: '备案时间',
      fSiteType: '网站类型',
      fUnit: '主办单位',
      fService: '服务名称',
      fMainLicence: '主体备案号',
      fServiceLicence: '服务备案号',
      fPassTime: '审核通过',
      fContentType: '前置审批',
      fAddress: '主体地址',
      nothingCopy: '没有可复制内容',
      needKw: '请输入查询关键词',
      wanganMsg: '网安备案暂无长期免费稳定开放接口。请前往公安部官方平台查询。',
      queryFail: '查询失败'
    },
    ico: {
      drop: '拖拽或点击上传图片，本地转码为 ICO',
      clear: '清除',
      unnamed: '未命名图片',
      quickTitle: '快捷方案',
      quickSub: '一键勾选常用组合',
      sizesTitle: '导出尺寸',
      selectAll: '全选',
      faviconOnly: '仅 Favicon',
      clearSel: '清空',
      custom: '自定义',
      addSize: '添加 {n}×{n}',
      extraAdded: '已添加自定义：',
      fitTitle: '适配方式',
      bgTitle: '背景',
      transparent: '透明',
      solid: '纯色',
      bgHint: '适合 PNG 透明图做 Favicon',
      genDownload: '生成并下载 ICO',
      packCount: '将打包 {n} 个尺寸',
      preview: '实时预览',
      tiers: '{n} 档',
      previewEmpty: '上传图片后，这里会按所选尺寸预览图标效果',
      needSize: '请至少选择一个导出尺寸',
      tips: '小提示',
      tip1: '建议使用正方形、透明底 PNG 作为源图',
      tip2: '网站 Favicon 常用 16 / 32 / 48',
      tip3: '文件在浏览器本地生成，不会上传服务器',
      tip4: '生成后可直接命名为 favicon.ico 放到网站根目录',
      customTip: '自定义尺寸',
      genOk: '已生成 {name}（{n} 个尺寸，约 {kb} KB）',
      convertFail: '转换失败',
      fitContain: '完整显示',
      fitContainHint: '等比缩放并居中，不足处留边（推荐）',
      fitCover: '裁切铺满',
      fitCoverHint: '等比放大铺满画布，多余部分居中裁切',
      fitStretch: '拉伸填满',
      fitStretchHint: '强制拉满正方形，可能变形',
      qFavicon: '网站 Favicon',
      qWindows: 'Windows 图标',
      qApp: '应用图标',
      qAll: '全部尺寸',
      tip16: '浏览器标签 / 经典 Favicon',
      tip24: '部分工具栏图标',
      tip32: '高清 Favicon / 任务栏',
      tip48: 'Windows 资源管理器',
      tip64: '桌面快捷方式',
      tip128: '高分屏图标',
      tip256: 'Vista+ 大图标'
    },
    exif: {
      lead: '上传照片读取并编辑完整 EXIF：设备序列号、镜头 / 闪光灯、对比度 / 饱和度 / 清晰度、光源、白平衡、EXIF 版本、详细 GPS 等均可设置。支持设备 / 画质 / 光源 / 闪光灯 / 镜头预设，也可保存自定义预设。导出 JPEG（本地处理）。',
      drop: '选择或拖入照片（JPEG / PNG / WebP，≤50MB）',
      hasExif: '已读到原有 EXIF',
      noExif: '无 EXIF / 非 JPEG，可手动添加',
      stampNow: '时间设为现在',
      justShot: '一键「刚拍」',
      saveCustom: '存为自定义',
      clearFields: '清空字段',
      export: '导出',
      exportHint: '将当前全部字段写入 JPEG EXIF 并下载。原 JPEG 不重编码保真；非 JPEG 会先转 JPEG。',
      jpegQuality: 'JPEG 质量',
      fileName: '文件名',
      exportBtn: '导出带 EXIF 的 JPEG',
      devicePresets: '设备一键预设',
      styleBlock: '画质 · 光源 · 闪光灯 · 镜头',
      style: '画质风格',
      light: '光源',
      flash: '闪光灯',
      lens: '镜头',
      myPresets: '我的自定义预设',
      delete: '删除',
      gpsBlock: 'GPS 城市快捷（含精度 / 状态 / 区域）',
      clearGps: '清除 GPS',
      searchPh: '搜索字段（如 序列号、对比度、GPS）',
      onlyFilled: '仅看已填写',
      select: '选择',
      readFail: '读取失败',
      sizeFail: '无法读取图片尺寸',
      applied: '已套用：{label}',
      appliedDevice: '已套用 {brand} {name}',
      gpsFilled: '已填入 {name} GPS 详情',
      timeSet: '拍摄时间已设为当前',
      justShotOk: '已补全为「刚拍摄」参数',
      saveTitle: '保存自定义预设',
      savePrompt: '为当前字段组合起个名字',
      savePh: '如：街头夜景 / 人像棚拍',
      save: '保存',
      cancel: '取消',
      saved: '已保存自定义预设',
      exported: '已导出',
      exportFail: '导出失败'
    },
    ocr: {
      eyebrow: '阿里云读光 · 文件 OCR',
      title: '图片与文件智能识别',
      desc: '通用文字、卡证、票证发票、车辆物流与试卷识别。支持图片与 PDF；获管理员授权后可使用开放 API 对接业务系统。',
      available: '可用',
      pickScene: '选择场景',
      quota: '额度 {n}/月',
      notReadyEm: '服务未就绪，请联系管理员',
      pausedEm: '当前暂不可用',
      notReady: '服务未就绪',
      notReadyBody: '请管理员在后台「阿里云 OCR」配置 AccessKey 后使用。',
      tabRec: '在线识别',
      tabApi: '开放 API',
      authorized: '已授权',
      replace: '点击或拖拽替换',
      replaceClick: '点击替换',
      dropTitle: '拖拽图片或 PDF 到此处',
      dropHint: 'JPG / PNG / BMP / WebP / GIF / TIFF / PDF / OFD · 约 10MB 内',
      clear: '清除',
      typeLabel: '识别类型',
      typePh: '选择 Type',
      pageLabel: 'PDF / OFD 页码（可选）',
      pageTip: '多页文件可指定页码；不填则识别第一页。',
      keysLabel: '抽取字段（可选，逗号分隔）',
      keysPh: '如：姓名,地址,开票日期；留空由模型自动判断',
      outputTable: '输出表格结构',
      result: '识别结果',
      text: '文本',
      emptyText: '（无纯文本，可切换 JSON 查看）',
      resultEmpty: '选择场景并上传文件后开始识别',
      apiTitle: '开放 API 开发说明',
      apiDesc: '管理员授权后可创建个人令牌，通过 HTTP 调用 OCR 识别接口，适合业务系统与脚本对接。',
      apiOk: '已获授权',
      needAdmin: '需管理员开通',
      apiNeedTitle: '开放 API 需管理员授权',
      apiNeedDesc: '请联系管理员在后台「用户 → 工具配置」开通 OCR API 并设置每月次数。用户不可自行开通。',
      notOpened: '暂未开通',
      notOpenedHint: '网页识别可正常使用；开放接口需单独授权。',
      token: 'API 令牌',
      enabled: '已启用',
      notCreated: '未创建',
      used: '已用 {used} / {limit}',
      remaining: '剩余 {n}',
      tokenHintOn: '令牌已存在。完整明文仅在创建/轮换时展示一次，遗失请重新轮换。',
      tokenHintOff: '点击下方按钮创建令牌，即可开始调用。',
      rotate: '轮换令牌',
      create: '创建 API 令牌',
      closeToken: '关闭令牌',
      authTitle: '1. 鉴权方式',
      authBody: '在请求头携带令牌（推荐）：',
      authCompat: '兼容：',
      queryTitle: '2. 识别接口',
      copyUrl: '复制 URL',
      param: '参数',
      explain: '说明',
      fieldsTitle: '3. 返回字段',
      field: '字段',
      scenesTitle: '4. 场景 ID（sceneId）',
      curlTitle: '5. cURL 示例',
      jsTitle: '6. JavaScript 示例',
      notesTitle: '7. 注意事项',
      btnNotReady: '服务未就绪',
      btnPaused: '暂不可用',
      btnNeedFile: '请先上传文件',
      btnRun: '开始识别',
      loadFail: '加载 OCR 状态失败',
      tooLarge: '文件过大，请控制在约 10MB 内',
      recOk: '识别成功',
      unavailable: '暂不可用',
      recFail: '识别失败',
      loadApiFail: '加载开放 API 失败',
      confirmRotate: '轮换后旧令牌立即失效，确认继续？',
      confirmCreate: '将创建 OCR 开放 API 令牌，确认？',
      confirmTitle: '开放 API',
      tokenCreated: '令牌已生成，请立即复制保存',
      confirmClose: '关闭后令牌立即失效，确认？',
      closeTitle: '关闭开放 API',
      closed: '已关闭令牌'
    },
    localOcr: {
      eyebrow: '浏览器本地 · 隐私 OCR',
      title: '图片文字本地识别',
      desc: '基于 PP-OCRv6 Tiny 与 onnxruntime-web，在浏览器中完成检测与识别。图片不上传服务器，适合截图、文档照片与敏感资料。',
      badgeLocal: '本地处理',
      engineIdle: '引擎待加载',
      engineIdleHint: '选择图片后将自动加载模型（约 6MB，仅首次）',
      engineLoading: '正在加载引擎',
      engineReady: '引擎已就绪',
      engineReadyHint: '可直接选择图片开始识别',
      engineFail: '引擎加载失败，请刷新页面重试',
      dropTitle: '点击或拖拽图片到此处',
      dropHint: 'JPG / PNG / WebP / BMP / GIF · 单张不超过 20MB',
      pasteTip: '支持 Ctrl+V / ⌘+V 粘贴截图',
      replace: '点击或拖拽替换',
      clear: '清除',
      showBoxes: '显示识别框',
      autoRun: '选图后自动识别',
      result: '识别结果',
      resultEmpty: '上传图片后将在此显示识别文字',
      emptyText: '（未识别到文字）',
      confidence: '置信度 {n}%',
      lineCount: '{n} 个文本块',
      btnLoading: '引擎加载中…',
      btnNeedFile: '请先选择图片',
      btnRunning: '识别中…',
      btnRun: '开始识别',
      needImage: '请选择图片文件',
      tooLarge: '图片不能超过 20MB',
      noText: '未识别到文字，可尝试更清晰的图片',
      recFail: '识别失败',
      tipsTitle: '使用说明',
      tip1: '首次使用需下载 PP-OCRv6 Tiny 检测与识别模型，之后会缓存在浏览器中。',
      tip2: '识别在本地完成，图片不会上传到服务器；复杂版式或手写体建议使用「文件 OCR」云端服务。',
      tip3: '支持中英文及多语言混合文本，横排印刷体效果最佳。'
    },
    bgRemove: {
      eyebrow: '浏览器本地 · AI 抠图',
      title: '图片智能抠图',
      desc: '基于 ISNet 模型在本地去除背景。支持透明底棋盘预览、纯色/渐变/自定义图换背景。模型资源由本站托管，图片不上传服务器。',
      badgeLocal: '本地处理',
      badgeFree: '免费最长边 {n}px',
      badgeMember: '会员不限分辨率',
      limitNotice: '免费用户已将 {from} 缩放至 {to}（最长边 {n}px）。开通会员可按原图分辨率抠图。',
      upgrade: '开通会员',
      engineIdle: '引擎待命',
      engineIdleHint: '首次抠图会从本站加载模型（约数十 MB，可缓存）',
      engineDownloading: '正在加载模型资源',
      engineRunning: '正在抠图',
      engineReady: '引擎已就绪',
      engineReadyHint: '可继续选择图片抠图',
      dropTitle: '点击或拖拽图片到此处',
      dropHint: 'JPG / PNG / WebP · 单张不超过 40MB',
      pasteTip: '支持 Ctrl+V / ⌘+V 粘贴截图',
      replace: '点击或拖拽替换',
      clear: '清除',
      model: '模型质量',
      result: '抠图结果',
      resultEmpty: '选择图片并开始抠图后，结果将显示在此处',
      viewResult: '结果',
      viewCompare: '对比',
      original: '原图',
      cutout: '抠图',
      bgTitle: '背景',
      download: '下载',
      copy: '复制',
      copied: '已复制到剪贴板',
      copyUnsupported: '当前浏览器不支持复制图片',
      btnNeedFile: '请先选择图片',
      btnRunning: '抠图中…',
      btnRun: '开始抠图',
      needImage: '请选择图片文件',
      tooLarge: '图片不能超过 {n}MB',
      recFail: '抠图失败，请换图或刷新重试',
      done: '抠图完成',
      tipsTitle: '使用说明',
      tip1: '模型与 WASM 由本站 /bg-removal/ 提供，不依赖第三方 CDN；首次加载后浏览器会缓存。',
      tip2: '免费用户最长边限制 2048px；会员可按原图分辨率处理。大图建议先用「快速」模型预览。',
      tip3: '透明背景请下载 PNG；换纯色/渐变/自定义图后可导出 JPEG 或 WebP。',
      modelFast: '快速',
      modelFastHint: '体积更小，适合预览与普通人像',
      modelStd: '标准',
      modelStdHint: '默认推荐，平衡速度与边缘质量',
      modelFine: '精细',
      modelFineHint: '质量更高，首次下载与推理更慢',
      gpuHint: '当前固定使用 CPU/WASM（与本站自托管模型一致）。首次加载模型后会缓存在浏览器。'
    },
    remoteDesk: {
      eyebrow: '官方远控 · BilldDesk',
      title: '远程控制',
      desc: '本站提供登录入口与使用引导。实际远控由 BilldDesk 官方（desk.hsslive.cn）完成：网页 / 电脑 / 安卓互控，画面与设备码不经过本站服务器。',
      badgeLogin: '需登录',
      badgeNoStore: '本站不存画面',
      statOfficial: '官方服务',
      statOfficialHint: '不消耗本站带宽与算力，会话在 BilldDesk 账号内隔离',
      openOfficial: '打开官方远控',
      download: '下载客户端',
      copyUrl: '复制官网链接',
      faq: '使用帮助',
      stepsTitle: '使用步骤',
      step1: '登录本站后进入本页（已完成）。',
      step2: '点击「打开官方远控」或安装 Windows / macOS / Android 客户端。',
      step3: '在 BilldDesk 注册/登录，用设备码与连接密码发起远程。',
      matrixTitle: '能力一览（以官方为准）',
      matrixHint: '以下能力由 BilldDesk 提供；安卓作为主控端部分场景仍在官方推进中。',
      soon: '官方推进中',
      m1t: '网页 → 电脑',
      m1d: '浏览器控制 Windows / macOS',
      m2t: '网页 → 安卓',
      m2d: '浏览器控制安卓被控端',
      m3t: '网页 → 网页',
      m3d: '仅观看对方屏幕分享',
      m4t: '电脑 → 电脑',
      m4d: '客户端互控',
      m5t: '电脑 → 安卓',
      m5d: '桌面端控制安卓',
      m6t: '电脑 → 网页',
      m6d: '仅观看',
      m7t: '安卓 → 电脑',
      m7d: '手机主控电脑',
      m8t: '安卓 → 安卓',
      m8d: '手机互控',
      m9t: '安卓 → 网页',
      m9d: '仅观看',
      safetyTitle: '安全说明',
      safety1: '设备码、连接密码与远控会话请只在 BilldDesk 官方站使用，本站不会代持。',
      safety2: '本站可记录「谁打开过本工具」，无法查看或管理你在官方站的设备与远控记录。',
      safety3: '若管理员禁用了你的本站访问，将无法通过本入口跳转；与 BilldDesk 账号无关。',
      bannedTitle: '暂不可用',
      bannedBody: '管理员已限制你使用本站远程控制入口，如有疑问请联系站长。',
      disabledTitle: '入口已关闭',
      disabledBody: '管理员暂时关闭了远程控制入口，请稍后再试。',
      loadFail: '加载状态失败'
    },
    battery: {
      tip: '电池容量、串并联、续航与 C 倍率换算。内置佳仕凯 32140 等圆柱动力电芯、储能方壳与数码电芯预设，参数为标称值仅供估算。',
      tabCap: '容量换算',
      tabPack: '串并联',
      tabRuntime: '续航估算',
      tabCrate: 'C 倍率',
      presets: '电芯预设',
      searchCell: '搜索型号 / 品牌 / 容量，如 32140、佳仕凯、280Ah',
      noCell: '没有匹配的电芯，试试其他关键词或分类',
      presetNote: '电压、容量、C 倍率为常见标称参考，实际以厂家规格书为准。选中后会填入单节电压与容量。',
      voltage: '电压 V',
      mah: '容量 mAh',
      orWh: '或能量 Wh',
      cellV: '单节电压 V',
      cellMah: '单节容量 mAh',
      cellWeight: '单节重量 g（估算）',
      harnessPct: '线束/外壳增重 %',
      series: '串联 S',
      parallel: '并联 P',
      loadMa: '负载电流 mA',
      efficiency: '效率 %',
      cRate: 'C 倍率',
      orCurrentA: '或电流 A',
      calc: '计算',
      fail: '计算失败',
      packNote: '电压窗口与 BMS 电流为经验估算（BMS 建议约等于持续电流 ×1.25）；重量含线束/外壳比例，实际以规格书与结构设计为准。',
      errVoltage: '请输入有效标称电压 (V)',
      errMahOrWh: '请填写 mAh 或 Wh 其中一项',
      errCell: '请填写有效的单节电压与容量',
      errRuntime: '请填写容量与负载电流',
      errMah: '请填写电池容量 (mAh)',
      errCrate: '请填写 C 倍率或放电电流',
      r: {
        voltage: '电压 V',
        mAh: '容量 mAh',
        Ah: '容量 Ah',
        Wh: '能量 Wh',
        combo: '组合',
        cells: '节数',
        chemName: '化学体系',
        packV: '标称电压 V',
        packWindow: '电压窗口',
        packChargeV: '满充电压 V',
        packCutoffV: '截止电压 V',
        packMah: '总容量 mAh',
        packAh: '总容量 Ah',
        packWh: '总能量 Wh',
        cellCrate: '参考放电倍率 C',
        packContA: '约持续放电 A',
        bmsSuggest: 'BMS 选型建议',
        bmsContA: '建议 BMS 持续电流 A',
        packWeightKg: '估算重量 kg',
        packWhKg: '能量密度 Wh/kg',
        hours: '续航小时',
        minutes: '续航分钟',
        days: '约合天',
        efficiency: '效率 %',
        cRate: 'C 倍率',
        currentA: '电流 A',
        currentMa: '电流 mA',
        ah: '容量 Ah'
      }
    },
    recording: {
      tabSize: '计算录像大小',
      tabTime: '计算录像时间',
      tabBw: '带宽计算',
      tipSize: '按编码、分辨率（或自定义码率）、路数与存储天数估算连续录像所需硬盘容量。码率为行业常用参考值，实际因场景复杂度而异。',
      tipTime: '已知硬盘总容量时，估算在当前画质与路数下大约可连续存储多久。',
      tipBw: '按摄像机数量与单路码率估算录像/预览所需网络带宽，并给出约 20% 预留建议。',
      conditions: '计算条件',
      byResolution: '分辨率',
      byBitrate: '码率',
      codec: '编码格式',
      resolution: '分辨率',
      fps: '帧率',
      bitrate: '码率',
      recBitrate: '推荐码率',
      cameras: '摄像头数量',
      camerasPh: '例如 16',
      duration: '存储时间',
      durationPh: '例如 30',
      capacity: '硬盘总容量',
      capacityPh: '例如 8',
      reset: '重置',
      calc: '计算',
      result: '计算结果',
      sizeSub: '连续录像约需容量（{cameras} 路 × {bitrate} Kbps × {days} 天）',
      exact: '精确值',
      suggestDisk: '建议硬盘',
      sizeNote: '建议预留约 15% 冗余（格式化损耗、索引与突发码率）。',
      timeSub: '在 {cap} 容量下约可连续存储',
      days: '天数',
      hours: '小时',
      months: '约合月数',
      dayUnit: '天',
      hourUnit: '小时',
      monthUnit: '个月',
      bwSub: '{cameras} 路合计码流（单路 {bitrate} Kbps）',
      totalBw: '总带宽',
      suggestBw: '建议预留',
      bwNote: '建议链路带宽预留约 20%，并考虑交换机背板与录像机接入能力。',
      needBitrate: '请填写有效码率',
      fail: '计算失败',
      errBw: '请填写有效的摄像头数量与码率',
      errSize: '请填写有效的摄像头数量、码率与存储时间',
      errTime: '请填写有效的摄像头数量、码率与硬盘容量',
      uDay: '天',
      uHour: '小时',
      uMonth: '月(30天)',
      aboutDays: '约 {n} GB',
      aboutTb: '约 {n} TB'
    },
    networkCable: {
      tip: '输入目标带宽与布线长度，自动给出详细推荐、省钱/均衡/未来预留多方案对比，并推演未来宽带与内网升级时线材是否够用。结果供布线规划参考。',
      conditions: '计算条件',
      bandwidth: '目标带宽',
      customBw: '自定义',
      customBwValue: '自定义带宽',
      length: '布线长度',
      lengthPh: '例如 30',
      scenario: '使用场景',
      environment: '敷设环境',
      needsPoE: '需要 PoE 供电（摄像头 / AP）',
      preferFiber: '优先考虑光纤',
      quick: '快捷示例',
      quickHome: '家用千兆 20m',
      quickCam: 'PoE 监控 80m',
      quickOffice: '办公万兆 40m',
      quickOutdoor: '楼间 300m',
      reset: '重置',
      calc: '开始计算',
      fail: '计算失败',
      idleTitle: '填写条件后开始计算',
      idleDesc: '可选择带宽、长度与场景，或点下方快捷示例一键试算。',
      result: '推荐方案',
      linkSpeed: '理论链路',
      effectiveSpeed: '估算有效吞吐',
      loss: '协议/线损余量',
      ceiling: '同长度上限',
      years: '预估可撑',
      headroom: '相对目标余量',
      whyTitle: '为什么推荐这条',
      maxEra: '可覆盖时代',
      recommendDetail: '线材与护套',
      cable: '推荐线缆',
      shielding: '屏蔽建议',
      jacket: '护套 / 类型',
      maxChannel: '单段建议上限',
      plansTitle: '三套方案对比',
      plansDesc: '省钱够用、均衡推荐、以及一次布线的未来预留方案，方便按预算与改造难度选择。',
      planCap: '上限',
      planCost: '成本',
      higherTitle: '用更高品类线会更好吗？',
      flagSpeed: '速率上限更高',
      flagYears: '可撑年数更长',
      flagWorth: '建议直接上预留档',
      flagOptional: '非必须，可按预算选',
      compareTitle: '各线材在本长度下的表现',
      compareDesc: '对比 Cat5e～Cat8 与光纤：能否达标、上限速率、成本档与未来余量。',
      roadmapTitle: '未来升级时间线',
      roadmapDesc: '粗略推演：现在 → 近两年多兆 → 五年万兆级 → 十年再布线，看这条线还能跟到哪一步。',
      reserveTitle: '施工预留与扩展建议',
      reserveDesc: '线差价往往小于二次开槽；穿管、双线、牵引绳才是真正的“面向未来”。',
      relayTitle: '中继与设备',
      needRelay: '是否需要中间设备',
      yes: '需要',
      no: '不需要',
      relayDevice: '建议设备',
      relayHops: '中间交换机数量',
      alternatives: '备选方案',
      warnings: '注意事项',
      tips: '布线要点',
      disclaimer: '以上为常见工程经验与标准通道参考（含未来年数粗估），实际以认证线材、现场测试仪与设备协商结果为准。',
      scenarioMap: {
        home: '家庭宽带 / 客厅电脑',
        office: '办公局域网',
        camera: '监控摄像头（PoE）',
        ap: '无线 AP / 弱电箱',
        server: '机房 / 服务器互联',
        outdoor: '楼宇 / 户外远距离'
      },
      envMap: {
        indoor: '室内干燥',
        ceiling: '吊顶 / 桥架',
        outdoor: '室外（防晒防水）',
        buried: '直埋 / 穿管地埋',
        industrial: '强干扰工业环境'
      }
    },
    eng: {
      disclaimer: '结果供参考，重要工程请按规范复核。',
      calc: '计算',
      calcSize: '计算线径',
      fail: '计算失败',
      result: '计算结果',
      byCurrent: '按电流',
      byPower: '按功率',
      singlePhase: '单相',
      threePhase: '三相',
      extraTag: '超大估算',
      dia: '约直径 φ{n} mm',
      ampacity: '载流量约 {n} A',
      drop: '压降约 {n} V（{p}%）',
      limitedBy: '由{what}决定',
      byDrop: '压降',
      byAmpacity: '载流量',
      cableTitle: '线缆选型计算（铜 / 铝 / 金 / 铜包铝）',
      cableTipPower: '输入负载功率与线路长度，自动按载流量与压降推荐截面积。',
      cableTipCurrent: '输入负载电流与线路长度，自动按载流量与压降推荐截面积。',
      mat: { cu: '铜线', al: '铝线', au: '金线', cca: '铜包铝' },
      tip: {
        'cable-size': '按电流或功率与长度推荐铜线、铝线、金线、铜包铝截面积。',
        'electrician-calc': '电工常用计算：电流电压功率、电缆压降、电机、三相、电阻电感等。',
        'room-calc': '房间面积、图形面积、空调选型与涂料地板用量估算。',
        'unit-calc': '长度、面积、温度与百分比折扣换算。',
        'science-calc': '圆柱体、三角形、四边形、圆与球体等数学公式计算。',
        'other-tools': '电工、线缆、房间面积等计算器合集，可从左侧切换。'
      },
      m: {
        'cable-size': { title: '线缆选型', desc: '电流或功率→铜/铝/金/铜包铝线径' },
        electric: { title: '电流电压功率', desc: '电工基础互算' },
        bill: { title: '电费估算', desc: '功率×时间算电量电费' },
        cable: { title: '电缆压降', desc: '已知线径算压降' },
        motor: { title: '电机电流/功率', desc: '电机电流与功率互算' },
        'delta-wye': { title: '三角/星形功率', desc: '三相接法与功率换算' },
        resistance: { title: '电阻计算', desc: '欧姆定律 / LED 限流' },
        inductance: { title: '电感计算', desc: '感抗与串并联' },
        circuit: { title: '经典电路', desc: '功率、RC、容抗' },
        component: { title: '元器件计算', desc: '截止频率 / 谐振 / 分压' },
        cylinder: { title: '气缸压力', desc: '气缸推力与压力计算' },
        room: { title: '房间面积', desc: '长宽面积、体积、多房间' },
        shape: { title: '图形面积', desc: '矩形/三角/圆/梯形' },
        'area-unit': { title: '面积单位', desc: '㎡/亩/公顷/坪互转' },
        ac: { title: '空调选型', desc: '房间面积适配空调匹数' },
        material: { title: '涂料地板', desc: '按面积估算材料用量' },
        length: { title: '长度换算', desc: '毫米/米/英尺等互转' },
        temp: { title: '温度换算', desc: '摄氏/华氏/开尔文' },
        percent: { title: '百分比折扣', desc: '占比、折扣与优惠' },
        'math-rect': { title: '长方形/正方形', desc: '周长、面积、对角线' },
        'math-isosceles': { title: '等腰三角形', desc: '腰底高、面积、角度' },
        'math-triangle': { title: '三角形', desc: '三边/两边夹角/底高' },
        'math-quad': { title: '四边形', desc: '平行四边形/梯形/一般四边形' },
        'math-cylinder': { title: '圆柱体', desc: '底面积、侧面积、体积' },
        'math-circle': { title: '圆', desc: '周长与面积' },
        'math-sphere': { title: '球体', desc: '表面积与体积' },
        'math-cube': { title: '正方体', desc: '表面积、体积、体对角线' },
        'math-pythagoras': { title: '勾股定理', desc: '直角三角形边长' }
      },
      r: {
        drop: '压降 (V)',
        percent: '压降百分比 (%)',
        endVoltage: '末端电压 (V)',
        resistanceOne: '单线电阻 (Ω)',
        tip: '提示',
        current: '电流 (A)',
        inputPowerKw: '输入功率 (kW)',
        apparentKva: '视在功率 (kVA)',
        formula: '公式',
        powerKw: '输出功率 (kW)',
        horsepower: '约合马力 (HP)',
        connection: '接法',
        lineVoltage: '线电压 UL (V)',
        phaseVoltage: '相电压 UP (V)',
        lineCurrent: '线电流 IL (A)',
        phaseCurrent: '相电流 IP (A)',
        activeKw: '有功功率 (kW)',
        reactiveKvar: '无功功率 (kvar)',
        areaMm2: '活塞面积 (mm²)',
        pushForceN: '伸出推力 (N)',
        pushForceKg: '伸出推力 (kgf)',
        pullForceN: '收回拉力 (N)',
        pullForceKg: '收回拉力 (kgf)',
        pressureBar: '压力 (bar)',
        pressureMpa: '压力 (MPa)',
        xl: '感抗 XL (Ω)',
        inductanceMh: '电感 L (mH)',
        totalMh: '等效电感 (mH)',
        resistance: '电阻 (Ω)',
        voltage: '电压 (V)',
        total: '等效电阻 (Ω)',
        powerW: '功率 (W)',
        tauSec: '时间常数 τ (s)',
        tauMs: '时间常数 τ (ms)',
        settle5Tau: '约 5τ (s)',
        xc: '容抗 Xc (Ω)',
        cutoffHz: '截止频率 (Hz)',
        resonateHz: '谐振频率 (Hz)',
        vout: '输出电压 (V)',
        ratio: '分压比',
        coolingW: '制冷量 (W)',
        coolingKw: '制冷量 (kW)',
        coolingBtu: '制冷量 (BTU/h)',
        suggestHp: '建议匹数',
        areaM2: '面积 (m²)',
        m2: '平方米 m²',
        mu: '亩',
        hectare: '公顷',
        ping: '坪',
        sqft: '平方英尺',
        cm2: '平方厘米',
        areaPing: '约合坪',
        areaSqft: '约合平方英尺',
        perimeterM: '周长 (m)',
        volumeM3: '体积 (m³)',
        wallAreaM2: '四面墙面积 (m²)',
        heightM: '层高 (m)',
        roomsDetail: '分项',
        area: '面积',
        circumference: '周长',
        mm: '毫米 mm',
        cm: '厘米 cm',
        m: '米 m',
        km: '千米 km',
        inch: '英寸 inch',
        ft: '英尺 ft',
        celsius: '摄氏 °C',
        fahrenheit: '华氏 °F',
        kelvin: '开尔文 K',
        result: '结果',
        finalPrice: '折后价',
        saved: '立减',
        offPercent: '优惠幅度 (%)',
        netAreaM2: '净面积 (m²)',
        withWasteM2: '含损耗面积 (m²)',
        paintLiters: '涂料约需 (L)',
        pieces: '地板约需 (片)',
        pieceAreaM2: '单片面积 (m²)',
        loadCurrentA: '负载电流 (A)',
        designCurrentA: '设计电流 (A)',
        lengthM: '线路长度 (m)',
        voltageV: '电压 (V)',
        phases: '相数',
        safetyFactor: '安全系数',
        recommendCu: '铜线建议',
        recommendAl: '铝线建议',
        recommendAu: '金线建议',
        recommendCca: '铜包铝建议',
        detailCu: '铜线说明',
        detailAl: '铝线说明',
        detailAu: '金线说明',
        detailCca: '铜包铝说明',
        kwh: '电量 (kWh)',
        cost: '预估电费 (元)',
        dailyKwh: '日用电量 (kWh)',
        inputMode: '输入方式',
        loadPowerW: '负载功率 (W)',
        loadPowerKw: '负载功率 (kW)',
        powerUnit: '功率单位',
        side: '边长 / 棱长',
        length: '长度',
        width: '宽度',
        perimeter: '周长',
        diagonal: '对角线',
        equalSide: '腰长',
        base: '底边',
        height: '高',
        apexAngleDeg: '顶角 (°)',
        baseAngleDeg: '底角 (°)',
        sideC: '第三边 c',
        semiPerimeter: '半周长',
        baseArea: '底面积',
        lateralArea: '侧面积',
        surfaceArea: '表面积',
        volume: '体积',
        radius: '半径',
        diameter: '直径',
        faceArea: '单面面积',
        spaceDiagonal: '体对角线',
        hypotenuse: '斜边',
        otherLeg: '另一直角边'
      },
      convert: '换算',
      estimate: '估算',
      f: {
        inputMode: '输入方式',
        loadCurrentA: '负载电流 (A)',
        loadPower: '负载功率',
        powerUnit: '功率单位',
        lengthM: '线路长度 (m)',
        voltageV: '电压 (V)',
        phases: '相数',
        maxDrop: '允许压降 (%)',
        safety: '安全系数',
        pf: '功率因数',
        mode: '模式',
        powerW: '功率 (W)',
        currentA: '电流 (A)',
        resistance: '电阻 (Ω)',
        power: '功率',
        hoursDay: '每天使用 (h)',
        days: '天数',
        price: '电价 (元/kWh)',
        length: '长度 (m)',
        width: '宽度 (m)',
        heightOpt: '层高 (m，可选)',
        shape: '图形',
        long: '长',
        wide: '宽',
        high: '高',
        base: '底边',
        radius: '半径 r',
        orDia: '或直径',
        top: '上底',
        bottom: '下底',
        value: '数值',
        unit: '单位',
        type: '类型',
        areaM2: '面积 (m²)',
        waste: '损耗 (%)',
        coats: '涂刷遍数',
        coverage: '每升可涂 (m²)',
        plankW: '板宽 (m)',
        plankL: '板长 (m)',
        scale: '温标',
        part: '部分值',
        whole: '整体值',
        percent: '百分比 %',
        original: '原价',
        discount: '折扣',
        lenM: '长度 (m)',
        section: '截面积 (mm²)',
        resistivity: '电阻率',
        goal: '计算目标',
        powerKw: '功率 (kW)',
        eta: '效率 η',
        connection: '接法',
        ul: '线电压 UL (V)',
        il: '线电流 IL (A)',
        up: '相电压 UP (V)',
        ip: '相电流 IP (A)',
        bore: '缸径 (mm)',
        rod: '活塞杆径 (mm)',
        pressure: '压力 (bar)',
        force: '推力 (N)',
        Lmh: '电感 (mH)',
        freq: '频率 (Hz)',
        xl: '感抗 (Ω)',
        voltV: '电压 V',
        ampI: '电流 I (A)',
        resR: '电阻 R (Ω)',
        vs: '电源 Vs (V)',
        vf: 'LED Vf (V)',
        ma: '电流 (mA)',
        ampIplain: '电流 I',
        resRplain: '电阻 R',
        capUf: '电容 C (μF)',
        freqF: '频率 f (Hz)',
        roomArea: '房间面积 (m²)',
        heightM: '层高 (m)',
        roomType: '房间类型',
        sun: '日照情况',
        people: '常住人数',
        side: '边长',
        equalSide: '腰长',
        apex: '顶角 (°)',
        sideA: '边 a',
        sideB: '边 b',
        sideC: '边 c',
        angleC: '夹角 C (°)',
        heightH: '高 h',
        cubeSide: '棱长 a',
        baseNum: '基数',
        sideD: '边 d',
        solve: '求解',
        legA: '直角边 a',
        legB: '直角边 b',
        hypC: '斜边 c',
        diagonal: '对角线'
      },
      h: {
        electric: '电流 / 电压 / 功率计算',
        bill: '用电量 / 电费估算',
        room: '房间面积计算',
        shape: '图形面积计算',
        areaUnit: '面积单位换算',
        ac: '空调大小 / 功率选型',
        material: '涂料 / 地板用量',
        length: '长度单位换算',
        temp: '温度换算',
        percent: '百分比 / 折扣计算',
        cable: '电线电缆压降计算器',
        motor: '电机电流 / 功率计算',
        dw: '三角形 / 星形负载功率',
        cyl: '气缸压力 / 推力计算',
        ind: '电感计算器',
        res: '电阻计算器',
        cir: '经典电路计算器',
        comp: '元器件在线计算',
        mathRect: '长方形 / 正方形',
        mathIso: '等腰三角形',
        mathTri: '三角形',
        mathQuad: '四边形',
        mathCyl: '圆柱体',
        mathCircle: '圆',
        mathSphere: '球体',
        mathCube: '正方体',
        mathPy: '勾股定理'
      },
      sub: {
        mathRect: '计算周长、面积与对角线。',
        mathIso: '由腰底、底高或腰与顶角求面积与角度。',
        mathTri: '三边、两边夹角或底高求面积与周长。',
        mathQuad: '平行四边形、梯形，或四边加对角线求面积。',
        mathCyl: '底面积、侧面积、表面积与体积。',
        mathCircle: '周长与面积；半径与直径填其一即可。',
        mathSphere: '表面积与体积。',
        mathCube: '表面积、体积与体对角线。',
        mathPy: '由两直角边求斜边，或由斜边与一直角边求另一边。'
      },
      o: {
        p2i: '功率→电流',
        i2p: '电流→功率',
        ohm: '欧姆定律',
        oneRoom: '单房间长×宽',
        multi: '多房间合计',
        rect: '矩形',
        triangle: '三角形',
        circle: '圆形',
        trap: '梯形',
        bedroom: '卧室',
        living: '客厅',
        office: '办公室',
        kitchen: '厨房',
        sunN: '一般',
        sunS: '强日照 / 西晒',
        sunW: '较弱 / 背阴',
        paint: '涂料',
        floor: '地板',
        pct: '求占比',
        of: '百分比取值',
        disc: '折扣价',
        discHint: '填 8.5 或 85 均可',
        rhoCu: '铜 0.0175 Ω·mm²/m',
        rhoAl: '铝 0.0283 Ω·mm²/m',
        fromP: '由功率求电流',
        fromI: '由电流求功率',
        star: '星形 (Y)',
        delta: '三角形 (Δ)',
        p2f: '压力 → 推力',
        f2p: '推力 → 压力',
        xl: '求感抗 XL',
        L: '求电感 L',
        comb: '串/并联',
        series: '串联',
        parallel: '并联',
        ohmFill: '填写任意两个，求第三个',
        led: 'LED 限流',
        power: '电功率',
        rc: 'RC 时间常数',
        xc: '容抗 Xc',
        rcCut: 'RC 截止频率',
        lc: 'LC 谐振',
        div: '电阻分压',
        square: '正方形',
        rectShape: '长方形',
        sides: '腰 + 底',
        baseH: '底 + 高',
        apex: '腰 + 顶角',
        sss: '三边',
        sas: '两边夹角',
        bh: '底 × 高',
        para: '平行四边形',
        genQuad: '一般四边形',
        hyp: '求斜边 c',
        leg: '求直角边',
        name: '名称',
        addRoom: '添加房间',
        del: '删除'
      }
    },
    life: {
      disclaimer: '结果仅供生活参考，不构成医疗诊断或专业建议。',
      pickDate: '选择日期',
      start: '开始计算',
      female: '女',
      male: '男',
      fail: '计算失败',
      n: {
        'outfit-customize': '搭配定制',
        'due-date': '预产期',
        ovulation: '排卵期',
        menstrual: '生理期',
        luteal: '黄体期',
        'pregnancy-week': '孕周',
        'lunar-calendar': '万年历',
        'bmi-calc': 'BMI',
        'body-fat': '体脂',
        'ideal-weight': '标准体重',
        'calorie-bmr': '代谢',
        'water-intake': '饮水',
        'sleep-cycle': '睡眠',
        'age-calc': '年龄'
      },
      dueTitle: '预产期计算',
      pregTitle: '孕周计算',
      dueLead: '基于末次月经推算（Naegele 法则），可按周期微调。',
      lmp: '末次月经第一天',
      cycleDays: '月经周期（天）',
      dueDate: '预产期',
      weekday: '星期{d}',
      pregWeek: '孕 {label}',
      trimester: '孕期第',
      stage: '阶段',
      pregnant: '已怀孕',
      remain: '距预产期',
      days: '天',
      ct: {
        ovulation: '排卵期计算',
        menstrual: '生理期计算',
        luteal: '黄体期计算'
      },
      cd: {
        ovulation: '根据月经周期估算排卵日与易孕期窗口。',
        menstrual: '推算月经、排卵、易孕与未来多个周期。',
        luteal: '由排卵日推算黄体期区间与下次月经。'
      },
      periodStart: '月经第一天',
      cycleLen: '周期长度',
      periodDays: '经期天数',
      ovuDay: '排卵日',
      lutealLen: '黄体期长度',
      period: '月经期',
      fertile: '易孕期',
      ovu: '排卵日',
      nextMenses: '下次月经',
      luteal: '黄体期',
      futureCycles: '未来 {n} 个周期',
      colPeriodStart: '月经开始',
      colOvu: '排卵日',
      colFertile: '易孕期',
      colNext: '下次月经',
      lutealRange: '共 {n} 天 · 下次月经 {date}',
      lutealShort: '黄体期偏短，如长期如此建议咨询医生',
      lutealLong: '黄体期偏长，请结合自身情况观察',
      lutealOk: '黄体期长度在常见范围内',
      lunarTitle: '阴阳万年历',
      lunarLead: '公历与农历对照，干支生肖与节气速查（1900–2100）。',
      solarDate: '公历日期',
      today: '今天',
      term: '节气 · {t}',
      gzYear: '干支年',
      animal: '生肖',
      lunarMonth: '农历月',
      lunarDay: '农历日',
      yearMonth: '{y} 年 {m} 月',
      w0: '日',
      w1: '一',
      w2: '二',
      w3: '三',
      w4: '四',
      w5: '五',
      w6: '六',
      ht: {
        'bmi-calc': 'BMI 身体质量指数',
        'body-fat': '体脂率估算',
        'ideal-weight': '标准体重',
        'calorie-bmr': '基础代谢与热量',
        'water-intake': '每日饮水建议',
        'sleep-cycle': '睡眠周期',
        'age-calc': '年龄与生肖星座',
        fallback: '生活计算'
      },
      hd: {
        'bmi-calc': '按中国成人参考标准评估体重状况。',
        'body-fat': '美海军围度法估算体脂率。',
        'ideal-weight': 'Broca 公式与 BMI 健康区间对照。',
        'calorie-bmr': 'Mifflin-St Jeor 估算 BMR / TDEE。',
        'water-intake': '按体重与活动强度估算饮水量。',
        'sleep-cycle': '按 90 分钟睡眠周期倒推入睡时间。',
        'age-calc': '精确年龄、生肖、星座与生日倒计时。'
      },
      heightCm: '身高 (cm)',
      weightKg: '体重 (kg)',
      gender: '性别',
      heightPlain: '身高 cm',
      neck: '颈围 cm',
      waist: '腰围 cm',
      hip: '臀围 cm',
      age: '年龄',
      activity: '活动量',
      weightPlain: '体重 kg',
      waterAct: '活动强度',
      low: '偏低',
      normal: '普通',
      high: '偏高',
      wakePlan: '计划起床',
      wakePh: '起床时间',
      fallAsleep: '入睡耗时（分）',
      birthday: '出生日期',
      under: '偏瘦',
      overweight: '超重',
      obese: '肥胖',
      idealRange: '理想区间',
      bmiMid: 'BMI 中位',
      healthRange: '健康区间',
      bodyFatRate: '体脂率',
      bmr: '基础代谢 BMR',
      tdee: '每日消耗 TDEE',
      cut: '减脂参考',
      bulk: '增肌参考',
      waterSuggest: '建议饮水量',
      waterAbout: '约 {ml} ml · {cups} 杯（250ml）',
      waterTip: '可分多次饮用；运动、高温天气可酌情增加',
      sleepIn: '建议入睡',
      wakeAt: '起床 {t} · {n} 个周期',
      cycleHours: '{n} 周期 · {h} 小时',
      exactAge: '精确年龄',
      yearsOld: '{n} 岁',
      monthsDays: '{m} 个月 {d} 天',
      constellation: '星座',
      nextBirthday: '距下次生日',
      lived: '已生活',
      weekPlus: '{w} 周 + {d} 天',
      phase: {
        period: '月经',
        fertile: '易孕',
        ovulation: '排卵',
        safe: '安全'
      },
      mile: {
        t1: '孕早期结束',
        screen: '中期唐筛参考窗',
        t2: '孕中期结束',
        due: '预产期'
      },
      act: {
        sedentary: '久坐少动',
        light: '轻度活动',
        moderate: '中度运动',
        active: '高强度',
        athlete: '运动员级'
      },
      bmi: {
        under: '偏瘦',
        normal: '正常',
        over: '超重',
        obese: '肥胖'
      },
      bmiTip: {
        under: '可适当增加营养与力量训练',
        normal: '保持均衡饮食与规律运动',
        over: '建议控制热量并增加有氧运动',
        obese: '建议在专业指导下科学减重'
      },
      fat: {
        essential: '必要脂肪',
        athlete: '运动员水平',
        fit: '健康偏瘦',
        average: '平均',
        high: '偏高'
      }
    },
    fengshui: {
      disclaimer: '结果仅供文化趣味与生活参考，不构成专业风水、命理或决策建议。',
      pickDate: '选择日期',
      start: '开始推演',
      fail: '推演失败',
      today: '今天',
      optional: '可选',
      score: '参考分',
      birthDate: '出生日期（公历）',
      birthHour: '出生时辰',
      gender: '性别',
      male: '男',
      female: '女',
      nameOpt: '称呼（可选）',
      namePh: '用于结果标题展示',
      chartTitle: '八字命盘',
      dayMaster: '日主',
      wuxingDist: '五行分布',
      animalA: '生肖甲',
      animalB: '生肖乙',
      facing: '朝向 / 大门方向',
      yearAnimal: '本命生肖',
      purpose: '用途',
      home: '住宅',
      office: '办公',
      shop: '商铺',
      luckyDirs: '喜用方位',
      cautionDirs: '慎用方位',
      rooms: '功能区',
      terrain: '地势形态',
      water: '临水情况',
      waterNone: '无明显水体',
      waterFront: '前方有水',
      waterBack: '后方有水',
      waterSide: '侧旁有水',
      road: '道路形态',
      roadCalm: '平缓顺畅',
      roadCurve: '环抱有情',
      roadRush: '直路冲射',
      shas: '观察到的煞象',
      intensity: '主观感受强度',
      intLow: '轻微',
      intMid: '一般',
      intHigh: '强烈',
      pressure: '煞气压力',
      date: '查询日期',
      yourAnimal: '本命生肖',
      dayPillar: '日柱',
      boost: '宜补',
      ease: '宜疏',
      master: '大师占卜',
      todayLeft: '今日剩余',
      todayUsed: '今日已用',
      dailyLimit: '每日上限',
      timesUnit: '次',
      unlimited: '不限',
      member: '会员',
      freeUser: '免费用户',
      needLoginTitle: '登录后即可请教师傅',
      needLoginDesc: '免费用户每日 1 次，会员每日 10 次；可输入任意想问的事。',
      goLogin: '去登录',
      askLabel: '想占卜什么',
      askPh: '例如：新房大门朝南是否合适？近期工作运势如何？与某某生肖是否合得来？',
      askBtn: '请教师傅',
      askRequired: '请先输入想占卜的事情',
      askOk: '占卜完成',
      myRecords: '我的记录',
      historyTitle: '近期记录',
      masterBadge: '大师批示',
      delete: '删除',
      deleted: '已删除',
      deleteConfirm: '确定删除这条占卜记录？',
      tip: '提示',
      sq1: '新居风水如何布局更旺？',
      sq2: '今年事业运势与方位建议',
      sq3: '与伴侣生肖是否相合？',
      sq4: '卧室床位怎么摆更安稳？',
      n: {
        master: '大师占卜',
        bazi: '八字',
        hehe: '六合三合',
        fs: '风水',
        house: '房屋布局',
        site: '宅基地势',
        posha: '破煞',
        dir: '方位吉凶',
        wx: '五行调衡'
      },
      t: {
        'master-divination': '大师占卜',
        'bazi-divination': '八字占卜',
        'hehe-sanhe': '六合三合占卜',
        'fengshui-divination': '风水占卜',
        'house-layout': '房屋布局占卜',
        'site-terrain': '宅基地势',
        'posha-break': '破煞占卜',
        'direction-luck': '方位吉凶',
        'wuxing-tune': '五行调衡'
      },
      d: {
        'master-divination': '任意提问，由后台配置的 AI 大师给出风水命理参考解读。免费每日 1 次，会员每日 10 次。',
        'bazi-divination': '输入公历生日与时辰，排出年月日时四柱，并给出五行强弱与日常调补参考。',
        'hehe-sanhe': '选择两个生肖，查看六合、三合、相冲与相害关系，评估相处契合度。',
        'fengshui-divination': '按大门朝向与住宅用途，推演喜方、忌方与软装五行建议。',
        'house-layout': '勾选客厅、卧室、厨房等功能区，快速获得宜忌方位提示。',
        'site-terrain': '结合地势高低、临水与道路形态，评估宅基地势与改善方向。',
        'posha-break': '勾选路冲、尖角、梁压等常见煞象，生成压力指数与化解步骤。',
        'direction-luck': '按日期推演八方吉凶，适合出门、会客或调整桌位时参考。',
        'wuxing-tune': '据八字五行分布，给出色彩、方位与器物的补弱疏强建议。'
      }
    },
    lookup: {
      n: {
        'phone-location': '手机归属地',
        'common-phones': '常用电话',
        'area-zip': '区号邮编',
        'idcard-area': '身份证地区',
        'university-search': '高校查询',
        'country-code': '国家代码',
        'blood-type': '血型遗传'
      },
      tip: {
        'phone-location': '查询中国大陆手机号运营商；若服务端号段库可用，将补充省市信息。',
        'common-phones': '紧急、政务、银行、快递等常用电话一览，支持搜索复制。',
        'area-zip': '国内主要城市长途区号与邮政编码速查。',
        'idcard-area': '根据身份证前 6 位解析行政区划，并提取出生日期与性别。',
        'university-search': '全国部分重点高校信息检索（可持续扩充）。',
        'country-code': '国家/地区中英文名、ISO 代码与国际电话区号。',
        'blood-type': '根据父母 ABO 血型推算子女可能血型。'
      },
      phMobile: '11 位手机号',
      number: '号码',
      carrier: '运营商',
      prefix: '号段',
      province: '省份',
      city: '城市',
      phPhone: '搜索名称 / 号码 / 分类',
      phZip: '城市 / 区号 / 邮编',
      areaCode: '区号',
      zip: '邮编',
      phId: '15/18 位身份证号',
      region: '行政区划',
      regionCode: '地区码',
      birthday: '出生日期',
      gender: '性别',
      ageAbout: '年龄约',
      years: '{n} 岁',
      phUni: '校名 / 省份 / 类型',
      school: '学校',
      type: '类型',
      level: '层次',
      phCountry: '国家 / ISO / 电话区号',
      zhName: '中文',
      dial: '电话区号',
      father: '父亲血型',
      mother: '母亲血型',
      bloodBtn: '查询可能血型',
      possible: '子女可能血型',
      impossible: '不可能出现',
      none: '无',
      fail: '查询失败',
      male: '男',
      female: '女',
      bloodNote: '仅基于 ABO 遗传规律估算，不含 Rh 及其他亚型，结果仅供参考。'
    },
    lan: {
      badge: '局域网 P2P',
      title: '内网速率测试',
      lead: '两台设备打开本工具，一台做{host}、一台做{client}，通过房间码配对后直连测延迟与上下行。信令经本站中转，测速流量走设备间 WebRTC（同 Wi‑Fi 最佳）。',
      host: '服务端',
      client: '客户端',
      asHost: '作为服务端',
      asHostDesc: '创建房间，生成房间码，等待另一台加入并响应测速请求',
      asClient: '作为客户端',
      asClientDesc: '输入房间码加入，发起测速，查看延迟与上下行速率',
      leave: '退出会话',
      roomCode: '房间码',
      copyInvite: '复制邀请链接',
      rewait: '重新等待加入',
      hostHint: '把房间码或链接发给同一局域网的另一台设备，选择「客户端」加入。服务端请保持本页打开，不要中途退出。',
      phCode: '输入 6 位房间码',
      joined: '已连接',
      join: '加入',
      dlAmt: '下载量',
      ulAmt: '上传量',
      unit: '速率单位',
      testing: '测速中…',
      start: '开始测速',
      rtt: '延迟 RTT',
      jitter: '抖动 {n}',
      dl: '下载（对端→本机）',
      ul: '上传（本机→对端）',
      finished: '完成时间',
      how: '使用说明',
      tip1: '两台电脑/手机浏览器打开本页，尽量处在{lan}。',
      lanSame: '同一 Wi‑Fi / 有线局域网',
      tip2: '一端点「服务端」拿到房间码，另一端选「客户端」输入后加入，任一方点「开始测速」。',
      tip3: '结果反映设备间链路能力，不是运营商宽带套餐峰值；跨网段或防火墙可能无法直连。',
      tip4: '小程序内请用「复制网页链接」在系统浏览器打开，以获得完整 WebRTC 能力。',
      livePing: '测延迟',
      liveDl: '下载中',
      liveUl: '上传中',
      liveDone: '完成',
      liveTesting: '测速中',
      liveRate: '实时速率',
      st: {
        idle: '未连接',
        enterCode: '请输入房间码加入',
        creating: '正在创建房间…',
        createFail: '创建房间失败',
        createFailShort: '创建失败',
        connected: '已连接，可开始测速',
        roomReadyRetry: '房间已创建，可点下方重试等待对端，或退出后重建',
        rewait: '重新等待对端…',
        waitFail: '等待失败',
        needCode: '请输入 6 位房间码',
        joinFail: '加入失败',
        testOk: '测速完成',
        testFail: '测速失败',
        codeCopied: '房间码已复制',
        linkCopied: '邀请链接已复制',
        roomGone: '房间不存在或已关闭。请让服务端重新点「作为服务端」生成新房间码后再加入',
        waitPeer: '创建房间并等待对端…',
        published: '已发布会话，等待客户端加入…',
        joining: '正在加入房间…',
        pinging: '测量延迟…',
        dl: '下载测速中…',
        ul: '上传测速中…',
        done: '测速完成',
        connFail: '连接失败，请确认两台设备同一局域网',
        disconnected: '连接已断开',
        dcClosed: '数据通道已关闭',
        waitTimeout: '等待对端超时，请检查房间码与网络',
        answering: '已应答，正在建立直连…',
        clientJoined: '客户端已加入，正在建立直连…',
        sdpBad: '会话描述不兼容，请两端使用较新的 Chrome / Edge，或两边都刷新后重试',
        peerDl: '对端下载测速中，本机发送数据…',
        peerUl: '对端上传测速中，本机接收数据…',
        noWebrtc: '当前浏览器不支持 WebRTC',
        dcNotReady: '数据通道未就绪',
        cancelled: '已取消',
        dcNotOpen: '数据通道未打开',
        waitType: '等待 {type} 超时',
        dlTimeout: '下载测速超时',
        ulTimeout: '上传测速超时'
      }
    },
    xfer: {
      eyebrow: '局域网 · P2P',
      title: '内网传输',
      lead: '打开房间码或扫二维码，多人同进一间房即可聊天、互传文件。文件走设备直连（不过服务器）；点选同伴可私聊/私发（参考 {link} ）。',
      leadLink: '发个东西',
      createRoom: '创建房间',
      createDesc: '生成房间码与二维码，发给同一局域网的同伴。',
      phNick: '你的昵称',
      createEnter: '创建并进入',
      joinRoom: '加入房间',
      joinDesc: '输入 6 位房间码，或扫描对方二维码打开本页。',
      phCode: '房间码',
      join: '加入',
      room: '房间',
      copyCode: '复制码',
      copyLink: '复制链接',
      altQr: '房间二维码',
      scanJoin: '手机扫码加入',
      myNick: '我的昵称',
      online: '在线 {n}',
      guest: '访客',
      me: '（我）',
      leave: '离开房间',
      chatHint: '点左侧同伴可选{priv}（仅对方可见）；未选择时消息与文件发给所有已直连同伴。文件走设备直连，不过服务器。',
      privStrong: '私聊 / 私发文件',
      sendTo: '发送给',
      phBroadcast: '所有已直连同伴（广播）',
      modePriv: '私发',
      modeBroadcast: '广播',
      feedEmpty: '还没有消息。先等同伴状态变为「可传输」，再发文字或文件。',
      dm: '私信',
      download: '下载',
      sendFilePriv: '私发文件',
      sendFile: '发送文件',
      sendingN: '正在发送 {i}/{total}…',
      dropTip: '可多选 · 拖放多个文件 · 内网直传不过服务器',
      phDm: '私信内容，仅对方可见…',
      phChat: '输入消息，Enter 发送（Shift+Enter 换行）',
      send: '发送',
      how: '使用说明',
      tip1: '文件只在设备之间直连传输，不经过本站服务器；双方请用浏览器并尽量同一 Wi‑Fi。',
      tip2: '多人房间可点选同伴私聊/私发文件，未选中则广播给所有已直连同伴；私发内容其他人看不到。',
      tip3: '可一次多选或拖入多个文件，将按顺序直传；手机浏览器也可多选。',
      tip4: '等同伴状态变为「可传输」再发文件；关闭页面即离开房间。',
      ready: '就绪',
      roomBroadcast: '房间广播',
      dmTitle: '私聊 · {name}',
      peer: '同伴',
      createFail: '创建失败',
      needCode: '请输入 6 位房间码',
      joinFail: '加入失败',
      connErr: '连接异常',
      entered: '已进入房间',
      self: '本机',
      relayTextOnly: '中继·仅文字',
      connecting: '连接中',
      connected: '已连通',
      canSend: '可传输',
      left: '已离开',
      failed: '失败',
      disconnected: '断开',
      dcClosed: '通道关闭',
      dcError: '通道错误',
      waitDirect: '等待直连',
      peerRelay: '{name}（小程序·仅文字）',
      peerReady: '{name}（可传输）',
      peerConnecting: '{name}（连接中）',
      codeCopied: '房间码已复制',
      linkCopied: '邀请链接已复制',
      copyFail: '复制失败',
      sendFail: '发送失败',
      broadcastConfirmMulti: '将把 {n} 个文件分别发给所有已直连同伴。若要私发，请先选择接收人。',
      broadcastConfirm: '当前未选择同伴，将把文件分别发给所有已直连同伴。若要私发，请先在上方选择接收人。',
      broadcastTitle: '广播发送文件？',
      broadcastOk: '广播发送',
      goPick: '去选人',
      file: '文件',
      fileFail: '{name}：{err}',
      sentN: '已发送 {n} 个文件',
      sentOne: '文件已发送',
      donePartial: '完成：成功 {ok}，失败 {fail}',
      phSendStart: '开始发送',
      phSendProgress: '发送中',
      phSendDone: '已发送',
      phSendFail: '发送失败',
      phRecvStart: '开始接收',
      phRecvProgress: '接收中',
      phRecvDone: '可下载',
      st: {
        creating: '正在创建房间…',
        createFail: '创建房间失败',
        joining: '正在加入房间…',
        joinedRelay: '已加入（中继模式）',
        joinedWait: '已加入房间，等待连接同伴…',
        left: '已离开房间',
        punching: '正在打洞连接同伴…',
        timeoutRetry: '直连超时：网络可能拦截 P2P，将自动重试…',
        iceRetry: 'ICE 打洞失败，正在重试…',
        failRetry: '直连失败，正在重试…',
        punchFailMany: '多次打洞失败：请双方改用同一 Wi‑Fi，或关闭 VPN/公司防火墙后点「重新连接」。对称 NAT 下纯直连可能无法打通。',
        rePunch: '正在重新打洞…',
        readyDirect: '已与同伴建立直连，可传文件'
      },
      err: {
        noPeerId: '加入失败：无 peerId',
        noMsg: '当前环境不支持发消息',
        peerNotReady: '对方尚未直连就绪，请稍候再发（状态变为「可传输」）',
        noPeers: '暂无已直连的同伴，请稍候再试',
        dcClosed: '发送失败：直连通道未打开',
        noFile: '未选择文件',
        relayNoFile: '当前为中继端，无法内网直传文件，请使用浏览器打开本工具',
        miniNoFile: '对方为小程序端，无法内网直传文件；请双方使用浏览器',
        peerNotReadyFile: '对方尚未直连就绪，请等状态变为「可传输」后再发文件，或开启「跨网临时中继」',
        noPeersRelay: '暂无已直连同伴。跨网可开启「跨网临时中继」，或配置 TURN 后重试',
        noRelayEnv: '当前环境不支持中继传文件',
        unnamed: '未命名文件',
        noWebrtc: '当前浏览器不支持 WebRTC（需 HTTPS 或 localhost）',
        insecure: '当前页面非安全上下文，WebRTC 不可用，请使用 HTTPS 打开',
        disconnected: '连接已断开',
        peerNotReadyShort: '对端尚未就绪',
        xferAbort: '传输中断：连接已断开',
        sendNat: '直连发送失败：可能被对称 NAT 拦截，请换网络或双方同 Wi‑Fi 后重试'
      }
    },
    p2p: {
      eyebrow: 'WebRTC · 浏览器直传',
      title: '点对点文件直传',
      lead: '双方用浏览器打开本页，用房间码或链接配对后互传文件。{strong}，不经过本站业务服务器；服务器仅交换极小的信令。',
      leadStrong: '文件内容只在设备之间直连',
      point1: '优先设备直连；跨省/不同运营商可能打不通',
      point2: '可开「跨网临时中继」经本站转发（上限约 100MB）',
      point3: '若已配置 TURN，失败时自动经 TURN 转发（不落盘）',
      inRoom: '房间 {code}',
      notInRoom: '未进入房间',
      createRoom: '创建房间',
      createDesc: '生成 6 位房间码与邀请链接，发给对方。',
      phNick: '你的昵称',
      createEnter: '创建并进入',
      joinRoom: '加入房间',
      joinDesc: '输入对方房间码，或扫码/打开邀请链接自动加入。',
      phCode: '6 位房间码',
      joinAction: '加入直传',
      roomCode: '房间码',
      copyCode: '复制码',
      copyLink: '复制链接',
      altQr: '邀请二维码',
      scanJoin: '对方扫码加入',
      peers: '同伴 {n}',
      waitPeer: '等待对方加入…',
      peer: '同伴',
      reconnect: '重新连接',
      natTip: '跨省/不同运营商时纯打洞常失败。请开启下方「跨网临时中继」，或让站长配置 TURN 后重试。',
      relayTitle: '跨网临时中继',
      relayDesc: '直连失败时经本站临时转发（约 {n}MB 上限，会占带宽）',
      myNick: '我的昵称',
      leave: '离开房间',
      xferTitle: '文件直传',
      xferLead: '选中同伴后发送；文件经 WebRTC DataChannel 直连，{strong}。',
      xferStrong: '内容不经过本站',
      phTarget: '选择接收方（可直连同伴）',
      peerReadyOpt: '{name} · 可直传',
      feedEmpty: '还没有传输记录。对方状态变为「可直传」后即可发送。',
      save: '保存',
      how: '说明',
      tip1Strong: '优先直连',
      tip1: '：同网/弱 NAT 时文件只在设备间传输，不经本站。',
      tip2Strong: '跨省跨运营商',
      tip2: '：纯 STUN 打洞经常失败。请开「跨网临时中继」，或部署 TURN（环境变量 LAN_TRANSFER_TURN_*）。',
      tip3Strong: 'TURN vs 临时中继',
      tip3: '：TURN 只转发字节、不落盘；临时中继会短暂落在本站磁盘（与「内网传输」相同机制）。',
      tip4: '请使用 HTTPS 现代浏览器；需要聊天+多人请用「内网传输」。',
      ready: '就绪',
      shortReady: '可直传',
      shortRelay: '中继可传',
      shortFail: '打洞失败',
      shortConnecting: '连接中',
      shortWait: '等待同伴',
      shortIdle: '空闲',
      sendingN: '正在发送 {i}/{total}',
      sendingRelay: '正在经中继发送…',
      sendingDirect: '正在直传…',
      pickPeerFirst: '先选择同伴',
      peerNotReady: '对方直连尚未就绪，或开启跨网临时中继',
      dropRelay: '点击或拖放文件（将走临时中继）',
      dropSend: '点击或拖放文件发送',
      hintRelay: '经本站临时转发，传完可删',
      hintDirect: '文件经设备直连传输',
      hintTurn: '已配置 TURN：打洞失败时会自动尝试 TURN 路径',
      hintRelayPending: '直连未通，发送将走本站临时中继',
      hintWait: '等待打洞；跨网请开启「跨网临时中继」',
      hintMulti: '支持多选；大文件分块传输',
      guest: '访客',
      peerInitial: '同',
      relayOnTip: '已开启跨网临时中继：直连不通时经本站转发',
      punchFailTip: '直连失败：可开启「跨网临时中继」继续传文件',
      connErr: '连接异常',
      noRelayPeer: '不支持（中继端）',
      stReady: '可直传',
      stConnected: '已连通',
      stConnecting: '打洞连接中…',
      stDisc: '短暂断开…',
      stFailed: '打洞失败，可点重连',
      stLeft: '已离开',
      stDcClosed: '通道已关闭',
      stDcError: '通道错误',
      stClosed: '连接已关闭',
      createFail: '创建失败',
      needCode: '请输入 6 位房间码',
      joinFail: '加入失败',
      entered: '已进入直传房间',
      codeCopied: '房间码已复制',
      linkCopied: '邀请链接已复制',
      copied: '已复制',
      copyFail: '复制失败',
      pickReadyPeer: '请先选择可直传的同伴',
      peerNotDirect: '对方尚未完成直连',
      pickConnected: '请先选择已直连的同伴',
      sentN: '已发送 {n} 个文件',
      sentOne: '文件已发送',
      sendFail: '发送失败',
      phXfer: '传输中',
      phStart: '开始',
      phProgress: '直传中',
      phSent: '已发出',
      phRecv: '已接收',
      file: '文件',
      leftOk: '已离开房间',
      rePunchOk: '已发起重新打洞',
      reFail: '重连失败'
    },
    optical: {
      eyebrow: '本站自研 · 喷泉码光传',
      title: '光传文件',
      lead: '发送端屏幕播放动态二维码流，接收端用摄像头对准即可还原文件。{noCable}，数据不经本站服务器中转。',
      noCable: '无需 Wi‑Fi、蓝牙、数据线',
      pillSha: 'SHA-256 校验',
      pillLocal: '纯浏览器 · 不跳转',
      pillBrowser: '纯浏览器',
      maxHint: '建议 ≤ {n}',
      send: '发送',
      recv: '接收',
      sendTitle: '发送文件',
      sendLead: '选择文件或粘贴文本，屏幕开始播放喷泉码动态二维码。请用另一台设备打开本页「接收」对准屏幕。',
      pickFile: '选择文件',
      orPaste: '或粘贴文本',
      phPaste: '粘贴要传输的文本（将保存为 .txt）',
      fps: '闪码帧率',
      fps8: '8 FPS（更稳）',
      fps10: '10 FPS（推荐）',
      fps12: '12 FPS',
      fps15: '15 FPS（更快）',
      ecl: '纠错等级',
      eclL: 'L · 容量优先',
      eclM: 'M · 均衡',
      file: '文件',
      size: '大小',
      blocks: '块数',
      eta: '预计',
      etaSec: '约 {n} 秒起',
      start: '开始闪码',
      stop: '停止',
      sendHint: '单文件建议不超过 {max}；更大请压缩或分卷。传输未加密，勿传绝密。',
      readyFlash: '准备就绪后在此闪码',
      sending: '正在发送 · 第 {n} 帧 · 请保持屏幕亮起',
      recvTitle: '接收文件',
      recvLead: '授权摄像头，对准发送端屏幕。需 HTTPS 或 localhost。光线适中、减少抖动可提高成功率。',
      camPreview: '摄像头预览',
      camOn: '开启摄像头',
      camOff: '关闭摄像头',
      reset: '重置进度',
      unique: '已收唯一帧：{n}',
      rank: '已解块 / 总块：{a} / {b}',
      fileMeta: '文件：{name}（{size}）',
      scan: '扫码状态：{s}',
      recvOk: '接收成功',
      download: '下载文件',
      tips: '使用小贴士',
      tip1: '两台设备：一屏闪码、一机扫码；也可同机双窗口（一屏一摄）。',
      tip2: '距离约 20–40 cm，二维码尽量占满取景框；发送端可调低帧率更稳。',
      tip3: '若一直「等待头帧」：确认两端都打开本站本页，且发送端已开始闪码。',
      tip4: '摄像头仅在 HTTPS / localhost 可用。',
      privacy: '隐私说明',
      priv1: '靠「光」传输，两端无需互通网络。',
      priv2a: '未加密',
      priv2b: '：对准屏幕的摄像头都能读到码流，勿传绝密。',
      priv3: '编解码均在本地完成，文件不经本站服务器。',
      credit: '灵感来自光学喷泉码开源项目 · 本页为站点自研实现，不捆绑其代码',
      textChars: '文本 {n} 字',
      done: '已完成',
      waitMeta: '等待头帧…',
      collecting: '收集喷泉帧…',
      fileTooBig: '文件过大（最大 {max}），请压缩或拆分后再传',
      textTooBig: '文本过大（最大 {max}）',
      prepFail: '准备失败',
      qrFail: '绘制二维码失败：{m}',
      unknown: '未知错误',
      needHttps: '当前页面非 HTTPS，多数浏览器无法使用摄像头。请使用 HTTPS 或 localhost。',
      noCam: '当前环境不支持摄像头',
      aiming: '取景中，请对准发送端闪码…',
      camFail: '无法打开摄像头：请检查权限，或换用 HTTPS / 另一台设备。',
      notOurFrame: '识别到码但不是本站光传帧（已扫 {n} 次）',
      dupFrame: '已对准 · 重复帧（唯一 {n}）',
      gotHeader: '已收到头帧，继续收集数据…',
      waitHeader: '已收到数据帧，等待头帧…（缓存中）',
      receiving: '收包中 · 唯一帧 {n}',
      recvDone: '文件接收完成，可下载',
      restoreFail: '还原失败，请重置后重试',
      hashFail: '校验失败：文件可能传输出错，已重置，请重新对准屏幕',
      noQr: '尚未识别到二维码',
      fallbackTitle: '光传文件',
      fallbackDesc: '本站喷泉码光传'
    },
    vocal: {
      badge: 'AI 分离',
      title: '人声分离',
      lead: '上传音频或视频，将人声与背景音乐分开。默认输出「人声 + 伴奏」；会员可选四轨（人声 / 鼓 / 贝斯 / 其它）。提交后请稍候，处理完成即可下载。',
      daily: '今日额度',
      unlimited: '不限',
      remain: '剩余 {a} / {b}',
      maxLen: '单次最长',
      hardCap: '（档位不限，受硬顶）',
      uploadCap: '上传上限',
      outMode: '输出模式',
      modeMember: '两轨 / 四轨（会员）',
      mode2: '两轨（人声+伴奏）',
      keep: '文件保留',
      days: '{n} 天',
      hours: '{n} 小时',
      minSec: '{m} 分 {s} 秒',
      sec: '{n} 秒',
      cannot: '暂不可提交',
      submit: '提交任务',
      twoStem: '人声 + 伴奏',
      fourStem: '四轨（会员）',
      drop: '拖拽文件到此处，或',
      pick: '选择音频 / 视频',
      formats: '支持 mp3 / wav / flac / m4a / mp4 / mkv 等',
      change: '更换文件',
      clear: '清空',
      start: '开始分离',
      job: '当前任务 #{id}',
      dl: '下载{name}',
      cancel: '终止转换',
      del: '删除任务',
      recent: '最近任务',
      empty: '暂无记录',
      four: '四轨',
      two: '两轨',
      stop: '终止',
      remove: '删除',
      waitDone: '处理完成，请下载结果（过期后将自动删除）',
      waitFail: '处理失败，可更换文件后重新提交',
      waitCancel: '任务已终止',
      waitSlow: '正在分离中（{p}%）。CPU 分离较慢，进度接近完成时仍可能再跑几分钟，请勿关闭页面',
      waitRun: '正在分离中（{p}%），CPU 处理约需数分钟，完成后可在此下载',
      waitQueue: '已提交，正在排队等待处理，请勿关闭页面',
      st: {
        pending: '等待中',
        queued: '排队中',
        processing: '处理中',
        done: '已完成',
        failed: '失败',
        cancelled: '已终止',
        expired: '已过期',
        deleted: '已删除'
      },
      loadFail: '加载失败',
      queuedOk: '已提交，正在排队处理，请稍候',
      submitFail: '提交失败',
      cancelAsk: '确定终止该转换任务？',
      cancelTitle: '终止确认',
      cancelOk: '已终止',
      cancelFail: '终止失败',
      delAsk: '删除后文件不可恢复，确定删除？',
      delTitle: '删除确认',
      delOk: '已删除',
      delFail: '删除失败',
      dlFail: '下载失败'
    },
    md: {
      open: '打开 Markdown 文件',
      lead: '拖拽 .md 到此处，或点击选择。本地解析，不上传服务器。',
      pick: '选择文件',
      sample: '示例文档',
      paste: '从剪贴板粘贴',
      tip1: '支持 .md / .markdown / .mdx / .txt',
      tip2: '单文件 ≤ {n}MB',
      tip3: '源码 · 预览 · 分栏',
      source: '源码',
      preview: '预览',
      split: '分栏',
      openFile: '打开文件',
      copyMd: '复制 Markdown',
      dlMd: '下载 .md',
      exportHtml: '导出 HTML',
      close: '关闭文档',
      lines: '{n} 行',
      words: '{n} 词',
      chars: '{n} 字符',
      headings: '{n} 标题',
      codes: '{n} 代码块',
      images: '{n} 图片',
      toc: '目录',
      wrap: '自动换行',
      phEdit: '在此编辑 Markdown…',
      gfm: 'GFM · 本地渲染',
      modeSource: '源码模式',
      modeSplit: '分栏对照',
      modePreview: '预览模式',
      opened: '已打开文件',
      openFail: '打开失败',
      sampleOk: '已加载示例',
      noClip: '当前浏览器不支持读取剪贴板，请直接粘贴到源码区',
      clipEmpty: '剪贴板为空',
      pasted: '已从剪贴板粘贴',
      pasteFail: '粘贴失败',
      copied: '已复制 Markdown',
      copyFail: '复制失败，请手动选择源码复制',
      downloading: '已开始下载',
      exported: '已导出 HTML',
      sampleDoc: '# Markdown 查看器\n\n本地打开 `.md` 文件，**源码**与**预览**随时切换，文件不会上传到服务器。\n\n## 功能一览\n\n- 拖拽或点击打开 Markdown\n- 源码 / 预览 / 分栏对照\n- 目录跳转、字数统计\n- 复制、下载、导出 HTML\n'
    },
    anydoc: {
      maxFile: '单文件 ≤ {n}MB',
      local: '本地处理，不上传',
      try: '快速试用',
      sampleRtf: '示例 RTF',
      sampleCsv: '示例 CSV',
      feat1: '隐私本地',
      feat2: '即拖即转',
      feat3: '14 种格式',
      chars: '{n} 字',
      source: '源码',
      preview: '预览',
      guide: '支持格式与说明',
      guideSub: '按文件内容识别格式，扩展名写错也能转',
      tip1: '文本型 PDF 可直接转换；纯扫描/纯图片 PDF 需要 OCR，暂不支持',
      tip2: '文档内嵌图片会以文字说明形式出现在 Markdown 中',
      tip3: '首次打开会加载转换引擎，之后可复用浏览器缓存',
      other: '其他',
      titleLoad: '正在准备转换引擎…',
      titleRun: '正在转换为 Markdown…',
      titleDrop: '松开鼠标，开始转换',
      titleIdle: '拖拽文档到此处，或点击上传',
      hintLoad: '首次加载稍等片刻，完成后即可本地转换',
      hintRun: '请稍候，大文件可能需要更长时间',
      engLoad: '引擎加载中',
      engReady: '引擎已就绪',
      engOff: '引擎未就绪',
      engFail: '转换引擎加载失败：{m}',
      convFail: '转换失败',
      copyFail: '复制失败，请手动选择文本'
    },
    gift: {
      "eyebrow": "人情往来 · 清晰可查",
      "title": "礼薄工具",
      "lead": "记录随礼姓名、金额与备注。支持多本礼薄、组合分享、访问密码，可导出 Excel / CSV。",
      "quota": "礼薄配额",
      "quotaDefault": "使用站点默认配额",
      "remain": "还可创建 {n} 本",
      "phGlobal": "跨礼薄搜索：姓名 / 备注",
      "searchAll": "搜索全部",
      "globalTip": "可在全部礼薄中查找随礼人；结果会标注所属礼薄。",
      "results": "搜索结果",
      "resultMeta": "「{q}」· {n} 笔 · ¥{amt} · 涉及 {books} 本",
      "noMatch": "没有匹配记录",
      "book": "礼薄",
      "myBooks": "我的礼薄",
      "newBook": "新建礼薄",
      "emptyBooks": "还没有礼薄，点上方新建",
      "shareOne": "单独分享",
      "exportExcel": "导出 Excel",
      "nEntries": "笔",
      "datePrefix": "日期 {d}",
      "myShares": "我的分享",
      "shareTip": "链接固定不变；可改密码、增减礼薄。礼薄内增删记录会同步到访客页。",
      "newShare": "新建分享",
      "emptyShares": "还没有分享，点上方新建",
      "shareFallback": "礼薄分享",
      "unbound": "未绑定礼薄",
      "web": "网页",
      "mini": "小程序",
      "unshare": "取消分享",
      "emptyMain": "选择或新建一本礼薄开始记录",
      "orderAscShow": "正序显示",
      "orderDescShow": "倒序显示",
      "orderTip": "设置后分享页也按此顺序显示",
      "orderAsc": "正序",
      "orderDesc": "倒序",
      "excelFilter": "Excel（当前筛选）",
      "csvFilter": "CSV（当前筛选）",
      "count": "笔数",
      "countFiltered": "筛选笔数",
      "total": "合计",
      "totalFiltered": "筛选合计",
      "avg": "均额",
      "max": "最高",
      "phSearch": "搜索姓名 / 备注",
      "moreFilters": "更多筛选",
      "phExactName": "精确姓名",
      "phAmtMin": "金额≥",
      "phAmtMax": "金额≤",
      "sort": "排序",
      "sortDefault": "礼薄默认顺序",
      "sortAmtDesc": "金额从高到低",
      "sortAmtAsc": "金额从低到高",
      "sortName": "姓名",
      "apply": "应用",
      "reset": "重置",
      "emptyTable": "暂无记录，点击「添加」开始录入",
      "colName": "姓名",
      "colAmt": "金额",
      "colGiftDate": "随礼日期",
      "colCreated": "录入时间",
      "dlgEditBook": "编辑礼薄",
      "dlgNewBook": "新建礼薄",
      "bookName": "礼薄名称",
      "phBookTitle": "如：婚礼礼薄、满月礼薄",
      "eventDate": "活动日期（可选）",
      "phEventDate": "如婚礼、满月当天",
      "entryOrder": "条目显示顺序",
      "orderHint": "正序：先录的在前；倒序：后录的在前。分享打开也按此顺序。",
      "descOpt": "说明（可选）",
      "phDesc": "便于自己标注",
      "dlgEditEntry": "编辑记录",
      "dlgAddEntry": "添加记录",
      "continueHint": "保存后弹窗保留，可连续录入",
      "onceHint": "保存后关闭弹窗",
      "roundCount": "本轮已录 {n} 笔",
      "continueMode": "连续录入",
      "onceMode": "单次添加",
      "phGuest": "随礼人姓名",
      "amount": "金额",
      "amountCN": "大写：{t}",
      "giftDateOpt": "随礼日期（可选）",
      "phGiftDate": "默认可不填",
      "phRemark": "可选，如礼金、红包",
      "saveEdit": "保存修改",
      "saveClose": "保存并关闭",
      "saveContinue": "保存并继续",
      "dlgEditShare": "编辑分享",
      "dlgCreateShare": "创建分享",
      "linkStable": "分享链接保持不变",
      "linkStableDesc": "可修改标题、包含的礼薄与访问密码；已发出的链接与小程序码仍然有效。",
      "shareTitle": "分享标题",
      "phShareTitle": "如：婚礼礼薄分享",
      "pickBooks": "选择要分享的礼薄",
      "selectedN": "已选 {n} / {total}",
      "selectAll": "全选",
      "shareBooksTip": "可增减礼薄组合；访客始终只读。礼薄里增删记录会实时反映到分享页。",
      "accessPwd": "访问密码",
      "accessPwdOpt": "访问密码（可选）",
      "pwdSet": "当前已设密码",
      "clearPwd": "清除密码（改为公开）",
      "pwdKeepHint": "留空且不勾选清除 → 保持原密码；填写新密码 → 覆盖原密码。",
      "pwdNewHint": "留空则任何人可直接查看；设置后需输入密码才能打开。",
      "genShare": "生成分享",
      "resultBadge": "链接固定 · 访客只读 · 可在「我的分享」中随时编辑",
      "webShare": "网页分享",
      "miniShare": "小程序分享",
      "h5Title": "浏览器 H5 打开",
      "h5Desc": "复制网页链接发给好友，用手机或电脑浏览器即可查看礼薄明细。",
      "copyWebLink": "复制网页链接",
      "openWindow": "新窗口打开",
      "copyCopy": "复制文案",
      "miniTitle": "微信小程序打开",
      "miniDesc": "扫码进入小程序查看；也可复制直达链接，在微信内打开小程序。",
      "miniAlt": "礼薄小程序码",
      "miniLoading": "小程序码加载中…",
      "miniLink": "打开小程序链接",
      "dlMiniQr": "下载小程序码",
      "copyOpenLink": "复制打开链接",
      "miniFooter": "优先使用小程序码；若已开通微信 URL Link，则「打开链接」可在微信内直达小程序。网页 H5 也可跳转小程序。",
      "shareAs": "分享「{t}」",
      "pwdPhNew": "留空则任何人可直接查看",
      "pwdPhClear": "将清除访问密码",
      "pwdPhKeep": "留空则保持原密码；填写即为新密码",
      "pwdPhSet": "设置访问密码（可选）",
      "exportedFilter": "已按当前筛选导出 {label}",
      "exported": "已导出 {label}",
      "needKeyword": "请输入姓名或备注关键词",
      "searchFail": "搜索失败",
      "shareSuffix": "{t}分享",
      "confirmDelBook": "确定删除礼薄「{t}」？条目将一并不可见。",
      "needBookName": "请填写礼薄名称",
      "orderSetAsc": "已设为正序显示",
      "orderSetDesc": "已设为倒序显示",
      "setFail": "设置失败",
      "needGuest": "请填写姓名",
      "addedNth": "已添加第 {n} 笔",
      "added": "已添加",
      "bookHash": "礼薄#{id}",
      "confirmDelEntry": "删除「{n}」的记录？",
      "needBook": "请选择至少一本礼薄",
      "pwdLen": "访问密码长度需为 4–32 位",
      "shareUpdated": "分享已更新（链接未变）",
      "shareCreated": "分享已创建",
      "generating": "生成中…",
      "genFail": "生成失败",
      "copiedLink": "链接已复制",
      "copiedWeb": "网页链接已复制",
      "copiedShare": "分享文案已复制",
      "copiedMini": "小程序链接已复制",
      "copiedText": "文案已复制",
      "confirmUnshare": "取消后该分享链接将失效（码不变也无法再打开）。确定取消？",
      "unshareTitle": "取消分享",
      "unshared": "已取消分享"
    },
    om: {
      "eyebrow": "电子菜单 · 桌台点餐",
      "title": "点餐菜单",
      "lead": "制作菜单与菜品，生成桌台码；顾客扫码点餐或填写地址外卖下单。可设营业时间，打烊后不可下单。",
      "quota": "菜单配额",
      "quotaMember": "会员档 · 默认可建 {n} 个",
      "quotaFree": "免费档 · 默认可建 {n} 个",
      "remain": "还可创建 {n} 个",
      "newMenu": "新建菜单",
      "pendingN": "待确认 {n}",
      "orderAlert": "订单提醒",
      "alertBanner": "有 {n} 笔待确认订单，点击处理，避免遗漏",
      "unmute": "开启提示音",
      "mute": "暂时静音",
      "empty": "还没有菜单，先创建一个吧",
      "pendingBadge": "{n} 待确认",
      "noDesc": "暂无简介",
      "nDishes": "{n} 道菜",
      "nTables": "{n} 桌",
      "nOrders": "{n} 单",
      "dlgEdit": "编辑菜单",
      "dlgNew": "新建菜单",
      "shopName": "店名",
      "phShop": "如：青苹果小馆",
      "shopLogo": "店铺 Logo",
      "changeLogo": "更换 Logo",
      "uploadLogo": "上传 Logo",
      "logoHint": "建议正方形图片，上传后自动转为 WebP；小程序端不展示",
      "intro": "简介",
      "phone": "电话",
      "address": "地址",
      "notice": "公告",
      "phNotice": "如：满 50 减 5",
      "orderWays": "点餐方式",
      "dineIn": "堂食桌台",
      "takeaway": "外卖配送",
      "detail": "菜单详情",
      "pendingBar": "当前有 {n} 笔待确认 · 自动刷新中",
      "goHandle": "去处理",
      "orderPage": "点餐页",
      "shareMini": "分享 / 小程序码",
      "editInfo": "编辑信息",
      "openNow": "开始营业",
      "closeNow": "打烊",
      "hours": "营业时间",
      "delMenu": "删除菜单",
      "tabDishes": "菜品",
      "addDish": "添加菜品",
      "colImg": "图",
      "colName": "名称",
      "colCat": "分类",
      "colPrice": "价格",
      "colStatus": "状态",
      "onSale": "在售",
      "offSale": "下架",
      "onShelf": "上架",
      "delShort": "删",
      "tabTables": "桌台",
      "addTable": "添加桌台",
      "batchCreate": "批量创建",
      "tableCode": "桌台码",
      "copyLink": "复制链接",
      "copyText": "文案",
      "miniQr": "小程序码",
      "orders": "订单",
      "ordersPending": "订单({n}待确认)",
      "ordersN": "订单({n})",
      "st": {
        "pending": "待确认",
        "confirmed": "已确认",
        "preparing": "制作中",
        "done": "已完成",
        "cancelled": "已取消",
        "complete": "完成",
        "cancel": "取消"
      },
      "menuSt": {
        "active": "营业",
        "closed": "打烊",
        "disabled": "停用",
        "banned": "封禁"
      },
      "typeTakeaway": "外卖",
      "typeDine": "堂食",
      "liveWatch": "实时监听",
      "noOrders": "暂无订单",
      "orderedAt": "下单 {t}",
      "updatedAt": " · 更新 {t}",
      "tableOf": "桌台：{n}",
      "remarkOf": "备注：{t}",
      "print": "打小票",
      "tabNotify": "提醒/打印",
      "autoPoll": "自动轮询",
      "pollHint": "打开本页时自动拉取新订单",
      "pollInterval": "轮询间隔",
      "seconds": "秒",
      "beep": "提示音",
      "previewBeep": "试听",
      "titleFlash": "标题闪烁",
      "pendingOnly": "仅待确认提醒",
      "printer": "小票打印机",
      "enablePrint": "启用打印",
      "autoPrint": "新单自动打",
      "printerType": "打印机类型",
      "gCloud": "联网云打印",
      "gLan": "无公网 / 店内",
      "gOther": "其他",
      "brandFeie": "飞鹅云",
      "brandYly": "易联云",
      "brandXinye": "芯烨云",
      "brandPoscom": "佳博云",
      "brandShangpeng": "商鹏云",
      "brandDaqu": "大趋智能",
      "brandHprt": "汉印云",
      "brandJolimark": "映美云",
      "brandGeneric": "通用联网（任意品牌开放API）",
      "brandLan": "局域网 ESC/POS（IP:9100）",
      "brandAgent": "本地打印助手",
      "brandQueue": "离线队列（助手拉取）",
      "brandWebhook": "自定义 Webhook",
      "brandNone": "未配置",
      "deviceName": "备注名",
      "phDevice": "如：吧台飞鹅 / 后厨芯烨",
      "receiptStyle": "小票样式",
      "styleClassic": "经典顾客联",
      "styleCompact": "紧凑联",
      "styleKitchen": "厨房联",
      "paperWidth": "纸宽",
      "showPrice": "显示价格",
      "footer": "页脚文案",
      "phFooter": "感谢惠顾",
      "copies": "份数",
      "devAccount": "开发者/账号",
      "savedSecret": "已保存，留空不改",
      "phPlatform": "平台账号或开发者 ID",
      "ukey": "密钥 UKEY",
      "printerSn": "打印机编号",
      "phSn": "SN / 设备号",
      "appId": "应用 ID",
      "appSecret": "应用密钥",
      "terminal": "终端号",
      "terminalKey": "终端密钥",
      "merchant": "商户编码",
      "apiKey": "API密钥",
      "deviceSn": "设备编号",
      "phOrAccount": "或填在账号栏",
      "backupUser": "备用账号",
      "phUserField": "部分品牌用 user 字段",
      "backupKey": "备用密钥",
      "apiUrl": "接口地址",
      "phApiOverride": "可覆盖品牌默认开放 API URL",
      "appLikeTip": "大趋 / 汉印 / 映美等按开放平台文档填写；接口地址可按厂商最新文档修改。",
      "preset": {
        "custom": "自定义填写",
        "feie_compat": "飞鹅兼容协议",
        "xinye_compat": "芯烨兼容协议",
        "poscom_compat": "佳博兼容协议",
        "shangpeng": "商鹏开放平台",
        "daqu": "大趋开放平台",
        "hprt": "汉印开放平台",
        "jolimark": "映美开放平台",
        "bearer_json": "Bearer + JSON",
        "webhook_json": "纯 JSON Webhook"
      },
      "cloudPreset": "协议预设",
      "apiAddr": "API 地址",
      "phVendorApi": "https://厂商开放平台/print",
      "authMode": "鉴权方式",
      "signFeie": "飞鹅签名",
      "signXinye": "芯烨签名",
      "signPoscom": "佳博签名",
      "signNone": "无签名",
      "body": "请求体",
      "contentFmt": "内容格式",
      "fmtPlain": "纯文本",
      "fmtFeie": "飞鹅标签",
      "successCode": "成功码",
      "phSuccess": "默认 0",
      "userAppId": "账号/AppId",
      "phUser": "user / 账号",
      "appIdAlt": "AppId(备)",
      "secret": "密钥",
      "genericTip": "没有内置品牌时选「通用联网」：按厂商文档选鉴权/格式，填 API 即可对接绝大多数开放平台。",
      "printerIp": "打印机IP",
      "port": "端口",
      "lanHint": "默认 9100 · API 服务器须与打印机同局域网",
      "agentUrl": "助手地址",
      "agentToken": "助手令牌",
      "phCustomKey": "自定义密钥",
      "agentTip": "适合 USB/网口小票机：把 api/scripts/order-menu-local-agent.js 拷到店内电脑运行。",
      "pullToken": "拉取令牌",
      "phQueueKey": "助手轮询用的密钥",
      "queueTip": "离线队列：GET /api/tools/order-menus/{id}/print-queue/pull?token=令牌",
      "saveSettings": "保存设置",
      "previewReceipt": "查看小票样式",
      "testPrint": "测试打印",
      "cloudTip": "联网打印机需在对应云平台绑定设备；「通用联网」可对接文档中提供开放 API 的其他品牌。",
      "previewDlg": "小票样式预览",
      "styleShortClassic": "经典",
      "styleShortCompact": "紧凑",
      "styleShortKitchen": "厨房",
      "plainContent": "纯文本内容",
      "refreshPreview": "刷新预览",
      "dishDlg": "菜品",
      "phCat": "推荐 / 热菜 / 饮品",
      "phUnit": "份",
      "catRecommend": "推荐",
      "unitPortion": "份",
      "uploadImg": "上传图片",
      "batchDlg": "批量创建桌台",
      "count": "数量",
      "namePrefix": "名前缀",
      "phPrefix": "可空，默认生成 1号桌…",
      "hoursEnabled": "启用限制",
      "hoursHint": "关闭后全天可点；开启后仅营业时段可下单",
      "start": "开始",
      "end": "结束",
      "openDays": "营业日",
      "dow": {
        "0": "日",
        "1": "一",
        "2": "二",
        "3": "三",
        "4": "四",
        "5": "五",
        "6": "六"
      },
      "shareTable": "分享桌台 · {n}",
      "shareMenu": "分享菜单 · {n}",
      "qrLoading": "小程序码加载中…",
      "orderLink": "点餐链接",
      "webBackup": "网页备用",
      "copyShareText": "复制分享文案",
      "shareTip": "发给顾客请用上方「点餐链接」（浏览器/微信可直接打开）。进小程序请扫左侧小程序码。「小程序路径」不能当网址打开，仅供开发跳转。",
      "advPath": "高级：小程序内路径",
      "path": "路径",
      "today": "今天 {t}",
      "yesterday": "昨天 {t}",
      "previewFail": "预览失败",
      "newOrderTitle": "新点餐订单",
      "newOrderMsg": "有 {n} 笔新订单，请及时处理",
      "newOrderNotify": "点餐新订单",
      "newOrderBody": "有 {n} 笔新订单待处理",
      "flashTitle": "【新订单×{n}】",
      "needShop": "请填写店名",
      "notifySaved": "提醒与打印设置已保存",
      "testSent": "测试小票已发送",
      "testFail": "测试失败",
      "printed": "已发送打印",
      "printFail": "打印失败",
      "closedOk": "已打烊",
      "openedOk": "已开业",
      "hoursSaved": "营业时间已保存",
      "confirmDelMenu": "删除后不可恢复，确定删除该菜单？",
      "imgUploaded": "图片已上传",
      "uploadFail": "上传失败",
      "logoUploaded": "Logo 已上传（WebP）",
      "needDish": "请填写菜名",
      "confirmDelDish": "确定删除该菜品？",
      "tableName": "桌台名称",
      "tableDefault": "{n}号桌",
      "tablesCreated": "桌台已创建",
      "createFail": "创建失败",
      "confirmDelTable": "删除桌台「{n}」？",
      "loadOrdersFail": "加载订单失败",
      "orderUpdated": "订单已更新",
      "updateFail": "更新失败",
      "copiedOrder": "点餐链接已复制",
      "copiedPath": "路径已复制",
      "qrNameTable": "桌台-{n}-小程序码.png",
      "qrNameMenu": "菜单-{n}-小程序码.png"
    },
    er: {
      "eyebrow": "抄表 · 对比 · 分享",
      "title": "电费记录",
      "lead": "管理电房与多电表，记录抄表读数，总表与分表相加对比上月。可设密码分享给房客（本机 30 天）；也可为电表开启开放 API，由设备/脚本直接上报读数并同步展示。",
      "quota": "电房配额",
      "remain": "还可创建 {n} 间",
      "monthsFree": "免费可见近 {n} 个月",
      "monthsMember": "会员可看全部账期",
      "myRooms": "我的电房",
      "newRoom": "新建电房",
      "emptyRooms": "还没有电房",
      "shareRoom": "分享电房",
      "metersMeta": "{n} 块电表 · {pwd}",
      "defaultPrice": "默认电价 {p} 元/度",
      "noPrice": "未设置电价（预览不显示金额）",
      "hideCost": " · 分享隐藏金额",
      "fromYm": " · 展示自 {ym} 起",
      "exportTable": "导出表格",
      "expCurrent": "导出本月电房数据",
      "expPrev": "导出本月 + 上月",
      "expCompare": "导出对比上月",
      "expCsv": "导出本月 CSV",
      "tabSummary": "账期汇总",
      "emptySummary": "暂无抄表，先添加读数",
      "vsYm": "对比 {ym}",
      "expMonth": "该月电房",
      "expMonthPrev": "该月 + 上月",
      "expMonthCmp": "对比上月",
      "mainUsage": "总表用量",
      "vsLast": "较上月 {d}",
      "subTotal": "分表合计",
      "mainMinus": "总表 − 分表",
      "gapHint": "差额可作公共用电参考",
      "kindMain": "总表",
      "kindSub": "分表",
      "readingOf": "读数 {v}",
      "usageOf": "用量 {v}",
      "tabMeters": "电表与抄表",
      "addMeter": "添加房客电表",
      "ownPwd": "独立密码",
      "ownPrice": "专属 {p} 元/度",
      "inheritPrice": "继承 {p} 元/度",
      "noBill": "不计费",
      "reading": "抄表",
      "emptyReadings": "暂无抄表",
      "colPeriod": "账期",
      "colReading": "读数",
      "colUsage": "用量",
      "colCost": "电费",
      "colAt": "抄表时间",
      "emptyMain": "选择左侧电房，或新建一间开始抄表",
      "dlgEditRoom": "编辑电房",
      "dlgNewRoom": "新建电房",
      "name": "名称",
      "phRoom": "如：幸福里 3 号楼",
      "address": "地址",
      "defaultTariff": "默认电价",
      "yuanKwh": "元/度（0=不计价，预览不显示金额）",
      "shareCost": "分享金额",
      "showFee": "展示电费",
      "usageOnly": "仅用量",
      "accessPwd": "访问密码",
      "phPwd": "留空表示不改；新建留空=公开",
      "clearPwd": "清除密码",
      "dlgEditMeter": "编辑电表",
      "dlgAddMeter": "添加电表",
      "phMeter": "如：101 室 / 一楼商铺",
      "tariff": "电价",
      "inheritRoom": "用电房默认",
      "customTariff": "单独电价",
      "meterPriceTip": "单独电价仅影响该房客；不计费时预览也不显示金额",
      "followRoom": "跟随电房",
      "show": "展示",
      "hide": "隐藏",
      "ownPwdPh": "留空则用电房密码",
      "clearOwnPwd": "清除独立密码",
      "dlgReading": "抄表 · {n}",
      "readingValue": "表读数",
      "readingAt": "抄表时间",
      "period": "账期",
      "phPeriod": "YYYY-MM，可按抄表时间自动",
      "shareDlg": "分享",
      "shareTip": "复制链接发给房客；也可生成小程序码扫码打开预览页。验证密码后本机 30 天免再输入。",
      "qrAlt": "小程序码",
      "genMini": "生成小程序码",
      "apiDlg": "开放 API · {n}",
      "apiLeadStrong": "仅会员可用。",
      "apiLead": "智能电表、脚本或第三方可凭令牌直接提交读数；写入后立刻出现在本页汇总、抄表列表与分享预览中。鉴权头：X-Electric-Token（也可用 query/body 的 token）。",
      "apiFreeTitle": "免费用户无法使用开放 API",
      "apiFreeDesc": "请先开通会员后再启用令牌。会员过期后已启用的令牌会自动失效。",
      "meterCode": "电表码 {c}",
      "tokenOnce": "仅在启用/轮换时显示一次，请妥善保存；泄露请立即轮换。",
      "submitReading": "提交读数",
      "queryLatest": "查询最新 / 列表",
      "tierCustomAdmin": "管理员单独配额",
      "tierMember": "会员配额",
      "tierCustom": "自定义配额",
      "tierFree": "免费配额",
      "loadDetailFail": "加载详情失败",
      "confirmDelRoom": "确定删除电房「{n}」？",
      "needMeterName": "请填写电表名称",
      "confirmDelMeter": "删除电表「{n}」？抄表记录将保留在库中但不再展示。",
      "needReading": "请填写读数",
      "readingSaved": "抄表已记录",
      "confirmDelReading": "删除这条抄表记录？",
      "expMode": {
        "current": "本月",
        "current_prev": "本月+上月",
        "compare": "对比上月",
        "meter": "电表本月+上月"
      },
      "exported": "已导出{m}表格",
      "qrUnavailable": "小程序码暂不可用，请先用链接分享",
      "loadApiFail": "加载 API 信息失败",
      "apiMemberOnly": "开放 API 仅会员可用，请先开通会员",
      "rotateConfirm": "轮换后旧令牌立即失效，确认继续？",
      "enableConfirm": "启用后可用令牌向本电表提交抄表，确认生成？",
      "tokenOk": "令牌已生成",
      "closeApiConfirm": "关闭后第三方将无法再提交，确认？",
      "closeApiTitle": "关闭开放 API",
      "closed": "已关闭"
    },
    tb: {
      "eyebrow": "协作 · 指派 · 留痕",
      "title": "任务提交",
      "lead": "创建任务板，授权成员或生成邀请链接；提交任务可附图（自动 WebP），指派执行、驳回留理由。会员可开启开放 API 由脚本提交任务。",
      "boards": "任务板",
      "quotaFreeMember": "免费 {free} · 会员 {member}",
      "remain": "还可创建 {n} 个",
      "perBoard": "每板任务",
      "quotaTaskFree": "免费 {n} · 会员不限",
      "byOwner": "按板主会员身份计",
      "myBoards": "我的任务板",
      "newBoard": "新建任务板",
      "phBoardSearch": "搜索项目名称、描述…",
      "nTasks": "{n} 任务",
      "noMatchBoard": "没有匹配的项目",
      "emptyBoards": "还没有任务板",
      "noDesc": "暂无描述",
      "boardTasks": "本板任务",
      "remainSubmit": " · 还可提交 {n}",
      "memberUnlimited": " · 会员不限（系统上限 {n}）",
      "copyReadonly": "复制只读链接",
      "tabTasks": "任务",
      "phTaskSearch": "搜索任务标题、说明、提交人、执行人…",
      "submitTask": "提交任务",
      "showing": "显示 {n} 条",
      "noMatchTask": "没有匹配的任务",
      "emptyTasks": "暂无任务",
      "submittedBy": "提交 {n}",
      "executor": "执行 {n}",
      "unassigned": "未指派",
      "due": " · 截止 {d}",
      "rejectOf": "驳回：{r}",
      "doing": "进行中",
      "complete": "完成",
      "reject": "驳回",
      "reopen": "重开",
      "assign": "指派",
      "tabMembers": "成员",
      "phUsername": "用户名",
      "tabInvites": "邀请分享",
      "phLabel": "备注名",
      "phOptPwd": "可选密码",
      "genInvite": "生成邀请",
      "colUser": "用户",
      "colRole": "角色",
      "colLink": "链接",
      "pwdDot": " · 有密码",
      "disabledDot": " · 已作废",
      "revoke": "作废",
      "tabLogs": "日志",
      "system": "系统",
      "emptyLogs": "暂无日志",
      "emptyMain": "选择左侧任务板，或新建一个开始协作",
      "dlgEdit": "编辑任务板",
      "dlgNew": "新建任务板",
      "name": "名称",
      "desc": "描述",
      "accessPwd": "访问密码",
      "phReadonlyPwd": "只读分享可选",
      "clearPwd": "清除密码",
      "anon": "匿名提交",
      "anonOn": "邀请链接可免登录提交",
      "mustLogin": "必须登录",
      "anonTip": "关闭后，打开邀请链接的访客需先登录网站账号才能提交任务与上传图片。",
      "hideSubmitter": "隐藏提交人",
      "hideViewer": "对只读隐藏",
      "notifyTitle": "新任务通知",
      "notifyLead": "可添加多个邮箱与多个小程序订阅；有新任务时会全部通知。保存后生效。",
      "emailNotify": "邮箱通知",
      "emailCount": "最多 10 个 · 已添加 {n}",
      "addEmail": "添加邮箱",
      "emptyEmail": "暂无邮箱，点击右上角添加",
      "phEmail": "邮箱地址",
      "phLabelOpt": "备注（可选）",
      "mailOff": "服务器邮件服务未启用时，邮件通知可能无法送达。",
      "miniNotify": "小程序订阅消息",
      "miniTpl": "任务工单提醒",
      "miniCount": "{title} · 已添加 {n}/{total}",
      "saveFirst": "请先创建并保存任务板，再添加小程序通知人。",
      "noTpl": "未配置订阅模板。请在 api/config/wechat.php 填写 mini_subscribe_task_submit。",
      "addMyself": "添加我自己",
      "phSiteUser": "网站用户名",
      "addUser": "添加用户",
      "wxUnbound": "你尚未绑定微信：请用小程序登录，或在网站个人中心扫码绑定后再添加自己。",
      "miniTip": "微信订阅消息为一次性：请在小程序详情页勾选「总是保持以上选择」，并使用「一次囤积多次」或每次打开自动续订。长期稳定请优先用邮箱通知。",
      "emptyMini": "暂无小程序通知人",
      "wxUser": "微信用户",
      "joinedAt": "加入 {t}",
      "lastAuth": "最近授权 {t} · 约剩 {n} 次",
      "notAuth": "尚未在小程序内授权订阅",
      "remove": "移除",
      "dlgTask": "提交任务",
      "taskTitle": "标题",
      "taskBody": "说明",
      "priority": "优先级",
      "priLow": "低",
      "priNormal": "普通",
      "priHigh": "高",
      "assignTo": "指派",
      "phAssignee": "执行人昵称（可选）",
      "images": "图片",
      "imgHint": "支持点击上传，也可直接 Ctrl + V 粘贴截图 · 自动转为 WebP",
      "uploading": "上传中…",
      "submit": "提交",
      "dlgReject": "驳回任务",
      "rCannot": "无法实现",
      "rDelay": "需要延期",
      "rInfo": "信息不足",
      "rCustom": "自定义",
      "phReject": "请填写驳回理由",
      "confirmReject": "确认驳回",
      "dlgAssign": "指派执行人",
      "pickMember": "选择成员",
      "orNick": "或填写昵称",
      "apiDlg": "开放 API · {n}",
      "apiLeadStrong": "仅会员板主可用。",
      "apiLead": "脚本或第三方可凭令牌提交/查询任务。鉴权头：X-Task-Token（也可用 query/body 的 token）。",
      "apiFreeTitle": "免费用户无法使用开放 API",
      "apiFreeDesc": "请先开通会员后再启用令牌。会员过期后已启用的令牌会自动失效。",
      "boardCode": "板码 {c}",
      "tokenOnce": "仅在启用/轮换时显示一次，请妥善保存；泄露请立即轮换。",
      "submitApi": "提交任务",
      "queryApi": "查询任务",
      "tierCustom": "专属配额",
      "tierMember": "会员配额",
      "tierFree": "免费配额",
      "taskTierCustom": "专属任务额度",
      "taskTierMember": "会员任务额度",
      "taskTierFree": "免费任务额度",
      "all": "全部",
      "st": {
        "pending": "待处理",
        "doing": "进行中",
        "done": "已完成",
        "rejected": "已驳回"
      },
      "role": {
        "owner": "板主",
        "submitter": "可提交",
        "executor": "可执行",
        "viewer": "只读"
      },
      "shareRole": {
        "view": "只读",
        "submit": "可提交",
        "execute": "可执行"
      },
      "log": {
        "board_create": "创建任务板",
        "board_update": "更新任务板",
        "board_delete": "删除任务板",
        "member_add": "添加成员",
        "member_update": "更新成员",
        "member_remove": "移除成员",
        "share_create": "创建邀请",
        "share_disable": "作废邀请",
        "task_create": "提交任务",
        "task_update": "更新任务",
        "task_status": "变更状态",
        "task_reject": "驳回任务",
        "task_delete": "删除任务",
        "admin_status": "管理员改状态",
        "admin_update": "管理员修改",
        "admin_delete": "管理员删除"
      },
      "maxEmail": "最多添加 10 个邮箱",
      "miniAdded": "已添加；请打开小程序完成订阅授权",
      "addFail": "添加失败",
      "needUsername": "请输入网站用户名",
      "userAdded": "已添加用户",
      "copiedCode": "已复制口令",
      "maxOa": "最多绑定 8 个公众号用户",
      "followOa": "请关注公众号后发送口令：{c}",
      "bindFail": "生成绑定信息失败",
      "oaBound": "公众号绑定成功，可继续添加其他人",
      "codeExpired": "绑定口令已过期，请重新生成",
      "qrExpired": "二维码已过期，请重新生成",
      "confirmUnbindOne": "确定移除该公众号通知对象？",
      "confirmUnbindAll": "确定解绑全部公众号？",
      "unbindTitle": "移除绑定",
      "removed": "已移除",
      "unbindFail": "解绑失败",
      "loadDetailFail": "加载详情失败",
      "needEmail": "请填写邮箱地址，或关闭该项开关",
      "badEmail": "邮箱格式不正确：{m}",
      "createdOa": "已创建；如需公众号通知，请再次编辑并添加绑定",
      "confirmDelBoard": "确定删除「{n}」？",
      "taskFull": "该任务板任务数已达上限",
      "loadApiFail": "加载 API 信息失败",
      "apiMemberOnly": "开放 API 仅会员可用，请先开通会员",
      "rotateConfirm": "轮换后旧令牌立即失效，确认继续？",
      "enableConfirm": "启用后可用令牌提交任务，确认生成？",
      "enabledOk": "已启用",
      "closeApiConfirm": "关闭后第三方将无法再提交，确认？",
      "closeApiTitle": "关闭开放 API",
      "closed": "已关闭",
      "maxImg": "最多上传 9 张图片",
      "imgAdded": "图片已添加（WebP）",
      "uploadFail": "上传失败",
      "needTitle": "请填写标题",
      "submitted": "已提交",
      "submitFail": "提交失败",
      "fail": "失败",
      "needReject": "请填写驳回理由",
      "rejected": "已驳回",
      "assigned": "已指派",
      "confirmDelTask": "删除该任务？",
      "needUser": "请填写用户名",
      "added": "已添加",
      "confirmRemoveMember": "移除成员 {n}？",
      "inviteOk": "邀请已生成",
      "confirmRevoke": "作废该邀请链接？",
      "revoked": "已作废"
    },
    live: {
      "eyebrow": "内容可变 · 码永不换",
      "title": "活码生成",
      "lead": "编辑富文本，或用 AI 描述生成精美 HTML 页面/表单；设置访问时效与密码后生成固定二维码。推荐分享小程序码。",
      "quota": "制作配额",
      "quotaDefault": "可保存的活码数量",
      "remain": "剩余 {n} 个",
      "today": "今日",
      "aiQuota": "AI 生成次数",
      "editLive": "编辑活码",
      "newLive": "新建活码",
      "cancelEdit": "取消编辑",
      "liveTitle": "标题",
      "phTitle": "扫码后显示的标题",
      "contentMode": "内容模式",
      "richtext": "富文本",
      "aiPage": "AI 页面",
      "body": "正文",
      "phBody": "编写内容，可插入图片…",
      "kind": "制作类型",
      "kindMini": "小程序直开",
      "kindMiniDesc": "扫小程序码即可看；推荐",
      "kindPage": "网页展示",
      "kindPageDesc": "完整 H5；请用网页链接打开",
      "kindForm": "网页表单",
      "kindFormDesc": "报名登记；请用网页链接打开",
      "kindTip": "个人主体小程序不能内嵌完整网页。「小程序直开」会生成富文本正文，保存后扫小程序码可直接查看；「网页展示/表单」请分享网页码或链接。",
      "describe": "描述你想要的页面",
      "formLimit": "表单访客上传限额",
      "off": "已关闭",
      "formLimitHint": "保存活码后生效；按当前账号规则（站点普通/会员或管理员单独配置）。",
      "prepImgs": "准备图片（可选）",
      "prepImgsDesc": "生成后自动插入指定位置：顶部 / 标题后 / 表单前 / 底部。转 WebP，最多 12 张。",
      "uploading": "上传中…",
      "uploadImg": "上传图片",
      "pickedImgs": "已选 {n}/12",
      "uploadingN": " · 上传中 {n}",
      "failN": " · 失败 {n}",
      "uploadingShort": "上传中",
      "failed": "失败",
      "imgName": "配图",
      "phImgCaption": "图片说明（可选）",
      "pos": "位置",
      "posTop": "页面最上部",
      "posAfterTitle": "主标题之后",
      "posBeforeForm": "表单之前",
      "posBottom": "页面最下部",
      "uploadFailRetry": "上传失败，请移除后重试",
      "uploaded": "已上传",
      "remove": "移除",
      "emptyImgs": "还没有图片，点「上传图片」后会立刻出现在这里",
      "docs": "附件文档（可选）",
      "docsDesc": "发给 AI 作参考，不是访客上传。支持 PDF / Office / WPS / TXT；禁音视频。",
      "uploadDoc": "上传文档",
      "docLimit": "单文件上限 {limit} · 已选 {n}/12",
      "uploadingSize": "正在上传… {s}",
      "uploadFail": "上传失败",
      "uploadedSize": "已上传 · {s}",
      "emptyDocs": "还没有文档，点「上传文档」后会立刻出现在这里",
      "todayChip": "今日 {n}",
      "totalChip": "累计 {n}",
      "aiWorking": "AI 生成中…",
      "regen": "重新生成",
      "genPage": "生成页面",
      "fullPreview": "全屏预览",
      "htmlReady": "已就绪，可保存活码",
      "aiShort": "AI 生成次数不足",
      "formNote": "表单会提交到本站接口，保存后可在列表「表单数据」中查看/导出。不支持生成音视频内容。",
      "visitorUpload": "访客上传：{h}",
      "livePreview": "实时预览",
      "formMode": "表单模式",
      "pageMode": "展示页",
      "htmlPreview": "HTML 预览",
      "startDate": "开始日期（可选）",
      "phStart": "不填则立即生效",
      "endDate": "结束日期（可选）",
      "phEnd": "不填则长期有效",
      "accessPwd": "访问密码（可选）",
      "phPwdEdit": "留空保持原密码；输入新密码则更新；点清除可去掉密码",
      "phPwdNew": "留空则公开访问",
      "clearPwd": "清除密码",
      "saveEdit": "保存修改",
      "genLive": "生成活码",
      "auditTip": "新建或修改正文后需后台审核通过，扫码方可访问；二维码本身不变。",
      "myLives": "我的活码（{n}）",
      "empty": "还没有活码，左侧创建第一个吧",
      "accessOn": "访问开启",
      "accessOff": "已关闭",
      "banned": "已封禁",
      "noPreview": "（无文字预览）点击查看页面",
      "views": "浏览 {n}",
      "formsN": "表单 {n} 条",
      "view": "查看",
      "qr": "二维码",
      "formData": "表单数据",
      "copyLink": "复制链接",
      "pagePreview": "页面预览",
      "formTotal": "共 {n} 条提交",
      "expSplitXlsx": "Excel · 字段分列",
      "expMergeXlsx": "Excel · 内容合并",
      "expSplitCsv": "CSV · 字段分列",
      "expMergeCsv": "CSV · 内容合并",
      "emptySubs": "暂无表单提交",
      "colAt": "提交时间",
      "colFields": "表单内容",
      "downloadFile": "下载文件",
      "liveFallback": "活码",
      "resultTip": "推荐发「小程序码」：微信扫码可直接进小程序。网页码仅适合浏览器打开 H5。若是「完整网页/表单」活码，个人主体小程序无法内嵌网页，请同时发网页链接。",
      "miniRecommend": "小程序码（推荐）",
      "webQr": "网页二维码",
      "copyWeb": "复制网页链接",
      "webQrAlt": "网页二维码",
      "miniQrAlt": "小程序码",
      "loading": "加载中…",
      "scanMini": "微信扫一扫 · 直接打开小程序",
      "copyWebFallback": "复制网页链接作兜底",
      "audit": "审核：{s}",
      "auditSt": {
        "pending": "待审核",
        "approved": "已通过",
        "rejected": "未通过"
      },
      "phForm": "例如：做一个活动报名表，包含姓名、手机号、人数、备注；风格简洁，主色青绿，适合手机填写…",
      "phPage": "例如：做一个咖啡店今日菜单页，含店名、三款推荐饮品、营业时间与地址；清新卡片风格，适合手机浏览…",
      "formDataOf": "表单数据 · {t}",
      "aiTotalUnlim": "累计已用 {n} 次（不限）",
      "aiTotal": "累计 {used}/{limit} · 剩 {left}",
      "aiHint": "描述需求即可生成页面",
      "docMember": "会员 30MB",
      "docFree": "免费 10MB",
      "formOff": "已关闭",
      "formCustom": "（单独配置）",
      "formRule": "单文件 {size} · 最多 {n} 个{custom}",
      "maxImgs": "最多 12 张图片",
      "qtyLimit": "数量上限",
      "noImgUrl": "未返回图片地址",
      "imgUploaded": "图片已上传",
      "imgUploadFail": "图片上传失败",
      "maxDocs": "最多 12 个文档",
      "noAv": "不允许上传音频或视频",
      "typeDeny": "类型不允许",
      "docName": "文档",
      "noDocUrl": "未返回文档地址",
      "docUploaded": "文档已上传",
      "docUploadFail": "文档上传失败",
      "needPrompt": "请先描述要生成的页面内容",
      "waitUpload": "还有文件正在上传，请稍候再生成",
      "dropFailed": "有文件上传失败，请移除失败项后再生成",
      "miniGenOk": "已生成小程序正文，保存后扫小程序码即可打开",
      "pageBound": "页面已生成（已绑定提交接口）",
      "pageForm": "页面已生成；保存活码后表单即可正式接收数据。请用网页链接分享。",
      "pageOk": "页面已生成。完整网页请用网页链接/网页码打开。",
      "genFailDs": "生成失败，请检查 DeepSeek 配置",
      "needTitle": "请填写标题",
      "needHtml": "请先生成 HTML 页面",
      "savedForm": "已保存；访客提交的表单可在「表单数据」查看",
      "loadFormFail": "加载表单数据失败",
      "layoutMerge": "合并",
      "layoutSplit": "分列",
      "exported": "已导出 {label}（{layout}）",
      "confirmDelSub": "确定删除这条提交？",
      "confirmClear": "确定清空该活码下全部表单提交？不可恢复。",
      "warn": "警告",
      "cleared": "已清空",
      "clearFail": "清空失败",
      "accessEnabled": "已开启访问",
      "accessDisabled": "已关闭访问",
      "confirmDelLive": "确定删除「{t}」？二维码将无法访问。",
      "delLive": "删除活码",
      "copiedLink": "链接已复制",
      "cannotOpen": "无法打开该活码",
      "bannedView": "该活码已被封禁，无法查看",
      "closedAsk": "访问已关闭，访客无法打开。是否先开启访问并查看真实落地页？",
      "viewLive": "查看活码",
      "openAndView": "开启并查看",
      "opened": "已开启访问",
      "openFail": "开启失败",
      "miniLoading": "小程序码加载中…",
      "miniFail": "小程序码生成失败",
      "genFail": "生成失败"
    },
    wifi: {
      "eyebrow": "安全分享 · 扫码即连",
      "title": "WiFi 链接",
      "lead": "保存 WiFi 名称与密码，生成专属小程序码。访客微信扫码后可一键连接，无需口头报密码。",
      "quota": "制作配额",
      "quotaDefault": "使用站点默认配额",
      "remain": "剩余 {n} 条",
      "edit": "编辑 WiFi",
      "add": "添加 WiFi",
      "cancelEdit": "取消编辑",
      "ssid": "网络名称（SSID）",
      "phSsid": "例如 Home-5G",
      "security": "加密方式",
      "securityHint": "可多选，与路由器设置一致即可；选「无密码」时不能与其他项同选。",
      "nopass": "无密码",
      "password": "WiFi 密码",
      "phPassword": "输入 WiFi 密码",
      "remarkOpt": "备注（可选）",
      "phRemark": "如：客厅路由器",
      "hidden": "隐藏网络",
      "saveEdit": "保存修改",
      "genCode": "生成分享码",
      "myList": "我的 WiFi（{n}）",
      "empty": "还没有 WiFi，右侧添加第一条吧",
      "viewQr": "查看小程序码",
      "copyOpen": "复制打开链接",
      "scanN": "扫码 {n} 次",
      "miniQr": "小程序码",
      "copyLink": "复制链接",
      "stdQr": "标准二维码",
      "miniAlt": "WiFi 小程序码",
      "qrLoading": "小程序码加载中…",
      "qrTip": "微信扫一扫即可进入连接页；也可复制下方链接发给好友。",
      "openLink": "打开链接",
      "dlMini": "下载小程序码",
      "copyOpenBtn": "复制打开链接",
      "copyShare": "复制分享文案",
      "footerTip": "「打开链接」可直接打开分享页并展示小程序码；若已开通微信 URL Link，则会优先复制可在微信内直达小程序的链接。",
      "shareOf": "「{ssid}」分享",
      "openNet": "开放网络",
      "needSsid": "请填写 WiFi 名称",
      "needPwd": "请填写密码，或选择「无密码」",
      "copiedOpen": "打开链接已复制",
      "noOpenLink": "暂无法生成打开链接",
      "confirmDel": "确定删除「{ssid}」？删除后原小程序码将失效。",
      "delTitle": "删除确认",
      "qrFail": "小程序码生成失败，请检查微信配置后重试",
      "copiedOpenShare": "打开链接已复制，可发给好友",
      "copiedShare": "分享文案已复制",
      "noStdQr": "无法生成标准二维码",
      "stdQrFail": "生成标准二维码失败"
    },
    epub: {
      "badge": "DeepSeek · EPUB",
      "title": "外文 EPUB 译成电子书",
      "leadBefore": "上传外文小说 EPUB，保留版式，导出可阅读的目标语言电子书。",
      "leadAfter": "请仅翻译您有权处理的内容。",
      "daily": "累计额度",
      "lifetime": "累计额度",
      "uploadMax": "上传上限",
      "identity": "身份",
      "member": "会员",
      "free": "免费用户",
      "keep": "结果保留",
      "hours": "{n} 小时",
      "keepHint": "到期后停止下载，文件由管理员在后台删除。相同书籍译文可秒传复用，不另计次数。",
      "cannot": "暂不可提交",
      "blockDisabled": "EPUB 翻译功能未开启",
      "blockBanned": "您的账号已被限制使用本工具",
      "blockEngine": "翻译引擎未就绪，请稍后或联系管理员",
      "blockExhausted": "翻译次数已用完（共 {n} 次）",
      "newJob": "新建翻译",
      "targetLang": "目标语言",
      "phLang": "选择目标语言",
      "drop": "拖拽 EPUB 到此处，或点击选择",
      "dropHint": "仅 .epub · 最大 {n} MB · 不修改图片资源",
      "changeFile": "更换文件",
      "clear": "清空",
      "jobN": "任务 #{id}",
      "chapterProg": "章节进度 {done} / {total}",
      "dlEpub": "下载 EPUB",
      "abort": "终止",
      "refreshProg": "刷新进度",
      "myJobs": "我的任务",
      "loading": "加载中…",
      "empty": "暂无任务，上传一本 EPUB 开始翻译",
      "remain": "剩余 {left} / {limit}",
      "supportBoth": "当前支持文字版与图片版小说翻译。",
      "supportText": "当前支持文字版小说翻译。",
      "tipOcr": "已开启图片 OCR：支持文字版与图片扫描版（正文在 JPG/PNG 内）EPUB。",
      "tipText": "当前支持文字版小说翻译（HTML/XHTML 内含可读文本）。",
      "waitExpired": "已过期，无法下载。文件仍由管理员保管。",
      "waitFail": "翻译失败，请查看错误信息后重试",
      "waitCancel": "任务已终止",
      "waitRun": "正在按章节翻译，页面会自动刷新进度；长书可能需要较长时间",
      "start": "开始翻译",
      "hashing": "校验文件中…",
      "reuseHit": "秒传命中…",
      "creating": "提交任务…",
      "uploadingPct": "上传中 {n}%",
      "processing": "处理中…",
      "phaseHash": "正在计算文件指纹（用于秒传）…",
      "phaseReuse": "发现相同译文，正在秒传…",
      "phaseCreate": "源文件已存在，正在创建任务…",
      "phaseUpload": "正在分块上传 {n}%",
      "phaseWait": "正在处理，请稍候…",
      "refreshFail": "刷新失败",
      "needEpub": "请上传 .epub 文件",
      "tooLarge": "文件超过 {n} MB 上限",
      "reusedOk": "秒传成功，已加入任务列表",
      "submitted": "已提交，任务列表已更新",
      "submitFail": "提交失败",
      "doneOk": "翻译完成，可以下载",
      "aborted": "已终止",
      "abortFail": "终止失败",
      "confirmDel": "将从你的任务列表移除（次数不退还）。文件仍保留，需管理员在后台删除。",
      "dlFail": "下载失败",
      "st": {
        "pending": "等待中",
        "queued": "排队中",
        "processing": "翻译中",
        "done": "已完成",
        "failed": "失败",
        "cancelled": "已终止",
        "expired": "已过期",
        "deleted": "已删除"
      },
      "langZhCN": "简体中文",
      "langZhTW": "繁体中文"
    },
    doc: {
      "quota": "制作配额",
      "sharing": "分享中",
      "closed": "已关闭",
      "views": "浏览 {n}",
      "recent": " · 最近 {t}",
      "more": "更多",
      "viewsLog": "访问记录",
      "closeShare": "关闭分享",
      "openShare": "开启分享",
      "sealUpload": "上传印章",
      "sealTip": "自动转 WebP 内嵌展示；相同文件按哈希复用，无需重复上传",
      "sealReused": "已复用已有印章",
      "sealOk": "印章已上传",
      "shareClosed": "已关闭分享",
      "shareOpened": "已开启分享",
      "delConfirm": "删除确认",
      "viewsOk": "成功浏览",
      "prints": "打印",
      "exports": "导出",
      "total": "总记录",
      "emptyViews": "暂无访问",
      "colTime": "时间",
      "colFrom": "来源",
      "colStatus": "状态",
      "qrLoading": "小程序码加载中…",
      "print": "打印",
      "dlPdf": "下载 / 导出 PDF",
      "layout": "版式",
      "classic": "经典票据",
      "modern": "现代简洁",
      "cornerCode": "右上角码",
      "codeNone": "不显示",
      "codeH5": "仅网页二维码",
      "codeMini": "仅小程序码",
      "codeBoth": "都显示",
      "autoNo": "留空自动生成",
      "seal": "印章",
      "contact": "联系方式",
      "remark": "备注",
      "operator": "经办人",
      "title": "单据标题",
      "quotaAdminYou": "管理员已为你单独设置"
    },
    receipt: {
      "eyebrow": "正式单据 · 可打印可分享",
      "title": "收据工具",
      "lead": "填写收款信息、上传印章，导出打印或分享 H5 / 小程序查看。会员制作默认不显示底部署名。",
      "remain": "剩余 {n} 张",
      "phSearch": "搜索编号 / 交款人 / 抬头 / 事由",
      "newItem": "新建收据",
      "empty": "暂无收据，点击「新建收据」开始制作",
      "dlgEdit": "编辑收据",
      "dlgNew": "新建收据",
      "receiptNo": "收据编号",
      "issuer": "收款单位",
      "phIssuer": "抬头 / 收款单位",
      "payer": "交款人",
      "amount": "金额",
      "payMethod": "付款方式",
      "issueDate": "开具日期",
      "reason": "收款事由",
      "address": "单位地址",
      "headerNote": "抬头说明",
      "phHeader": "可选副标题",
      "footerNote": "底部说明",
      "phFooter": "如：本收据手写无效",
      "cornerTip": "打印 / 分享页右上角可扫码再次打开本收据",
      "shareTitle": "分享收据",
      "shareTip": "请扫「小程序码」在微信内打开；「网页码 / 链接」仅适合浏览器。二者勿混用。打开与打印会记入访问记录。",
      "viewsOf": "访问记录 · {no}",
      "defaultTitle": "收款收据",
      "cash": "现金",
      "wechat": "微信",
      "alipay": "支付宝",
      "transfer": "银行转账",
      "check": "支票",
      "other": "其他",
      "tierMember": "会员期间默认 1000 张",
      "tierExpired": "会员到期后恢复为 50 张",
      "tierFree": "普通用户默认 30 张",
      "needParties": "请填写收款单位与交款人",
      "confirmDel": "确定删除收据「{no}」？",
      "loadViewsFail": "加载访问记录失败",
      "popup": "请允许弹出窗口后重试"
    },
    quote: {
      "eyebrow": "商务报价 · 可打印可分享",
      "title": "报价单工具",
      "defaultTitle": "报价单",
      "lead": "填写明细与条款，导出打印或分享 H5 / 小程序查看。会员制作默认不显示底部署名。",
      "remain": "剩余 {n} 张",
      "phSearch": "搜索编号 / 客户 / 报价方 / 标题",
      "newItem": "新建报价单",
      "verify": "编号验真",
      "empty": "暂无报价单，点击「新建报价单」开始制作",
      "validUntilOf": "有效期至 {d}",
      "dlgEdit": "编辑报价单",
      "dlgNew": "新建报价单",
      "quoteNo": "报价编号",
      "seller": "报价方",
      "phSeller": "卖方 / 报价单位",
      "customer": "客户",
      "quoteDate": "报价日期",
      "validUntil": "有效期至",
      "currency": "币种",
      "cny": "人民币 CNY",
      "usd": "美元 USD",
      "eur": "欧元 EUR",
      "hkd": "港币 HKD",
      "discount": "折扣",
      "tax": "税费",
      "lines": "明细行",
      "linesTip": "品名、规格、数量与单价；金额自动汇总",
      "addRow": "添加行",
      "colName": "品名",
      "colSpec": "规格",
      "colQty": "数量",
      "colUnit": "单位",
      "colPrice": "单价",
      "colAmt": "金额",
      "phName": "品名 / 服务",
      "phSpec": "规格型号",
      "phUnit": "单位",
      "gCommon": "常用",
      "gMeasure": "计量",
      "gTime": "时间 / 次数",
      "delRow": "删除此行",
      "subtotal": "小计",
      "total": "合计",
      "terms": "条款说明",
      "phTerms": "付款方式、交付周期等",
      "address": "地址",
      "cornerTip": "打印 / 分享页右上角可扫码再次打开本报价单",
      "shareTitle": "分享报价单",
      "shareTip": "请扫「小程序码」在微信内打开；「网页码 / 链接」仅适合浏览器。二者勿混用。打开与打印会记入访问记录。",
      "viewsOf": "访问记录 · {no}",
      "keepOne": "至少保留一行明细",
      "needParties": "请填写报价方与客户",
      "needLine": "请至少添加一条明细",
      "confirmDel": "确定删除报价单「{no}」？"
    },
    contract: {
      "eyebrow": "电子签署 · 可打印可分享",
      "title": "电子合同工具",
      "lead": "填写甲乙双方与正文条款；可设需要签署或无需签署。会员制作默认不显示底部署名。",
      "remain": "剩余 {n} 份",
      "phSearch": "搜索编号 / 甲方 / 乙方 / 标题",
      "newItem": "新建合同",
      "empty": "暂无合同，点击「新建合同」开始制作",
      "dlgEdit": "编辑合同",
      "dlgNew": "新建合同",
      "contractTitle": "合同标题",
      "contractNo": "合同编号",
      "partyA": "甲方",
      "phPartyA": "甲方名称",
      "partyB": "乙方",
      "phPartyB": "乙方名称",
      "partyAId": "甲方证件",
      "partyBId": "乙方证件",
      "phId": "身份证 / 统一社会信用代码",
      "partyAContact": "甲方联系",
      "partyBContact": "乙方联系",
      "signDate": "签订日期",
      "signPlace": "签订地点",
      "amount": "合同金额",
      "amountCn": "金额大写",
      "autoCn": "自动生成",
      "body": "合同正文",
      "phBody": "编写合同正文，可插入表格、标题与列表…",
      "bodyTip": "支持插入表格（工具栏「表格」按钮）；图文复杂版式建议在电脑端编辑",
      "clauses": "附加条款",
      "clausesTip": "可选；标题 + 正文，便于分条列出",
      "addClause": "添加条款",
      "emptyClauses": "暂无条款，可跳过或点击添加",
      "phClauseTitle": "条款标题",
      "phClauseBody": "条款内容",
      "classicDoc": "经典文书",
      "cornerTip": "打印 / 分享页右上角可扫码再次打开本合同",
      "shareTitle": "分享电子合同",
      "shareTip": "请扫「小程序码」在微信内打开签署；「网页码 / 链接」仅适合浏览器打开。二者勿混用。",
      "viewsOf": "访问记录 · {no}",
      "signs": "签署",
      "defaultTitle": "电子合同",
      "tierMember": "会员期间默认 1000 份",
      "tierExpired": "会员到期后恢复为 20 份",
      "tierFree": "普通用户默认 10 份",
      "noImg": "合同正文请用表格与文字；插图可选用活码工具",
      "stPending": "待签署",
      "stPartial": "部分签署",
      "stDone": "已完成",
      "stNoSign": "无需签署",
      "colGps": "定位",
      "openMap": "打开地图",
      "copyCoords": "复制坐标",
      "coordsCopied": "坐标已复制",
      "noGps": "该访问暂无有效坐标",
      "mapCoordTip": "国内位置已按坐标系校正：预览/谷歌转 WGS-84，高德/腾讯用 GCJ-02。开发者工具模拟定位常不准，请用真机验证。",
      "visitLoc": "访问位置",
      "locOk": "已定位",
      "locDenied": "用户拒绝",
      "locUnavailable": "不可用",
      "locTimeout": "超时",
      "locError": "失败",
      "locUnsupported": "不支持",
      "signMode": "签署设置",
      "locCollect": "访客定位",
      "locCollectOn": "开启定位",
      "locCollectOff": "关闭定位",
      "locCollectOnTip": "打开分享页时请求定位权限并记录位置",
      "locCollectOffTip": "不采集访客地理位置，更注重隐私",
      "locGateTitle": "需要位置权限",
      "locGateDesc": "本合同已开启访问定位。请先授权位置权限，通过后即可查看合同内容。",
      "locGateBtn": "申请权限以查看合同",
      "locGateRetry": "重新申请权限",
      "locGateRetryAfterAllow": "我已开启，继续查看",
      "locGateSettings": "打开系统设置",
      "locGateHowTo": "查看开启步骤",
      "locGateHowToHide": "收起开启步骤",
      "locGateLocating": "正在获取定位…",
      "locGateHint": "授权后仅用于记录本次查阅位置，不会用于其他用途。",
      "locGateDeniedToast": "你已拒绝过定位，浏览器不会再次弹窗。请按下方步骤开启后点「我已开启，继续查看」。",
      "locGateStep1": "点击地址栏左侧的锁标 / 信息图标（微信内可点右上角「···」→ 设置）",
      "locGateStep2": "将「位置 / 定位」改为「允许」",
      "locGateStep3": "返回本页，点击「我已开启，继续查看」",
      "locAskTitle": "需要位置权限",
      "locAskDesc": "本合同已开启访问定位，用于记录本次查阅位置。请允许后继续。",
      "locAskAllow": "允许定位",
      "locAskDeny": "拒绝",
      "locGuideTitle": "需要位置权限",
      "locGuideDesc": "本合同已开启访问定位。请点击下方按钮授权，系统会弹出位置权限确认。",
      "locGuideAllow": "允许定位",
      "locGuideRetry": "重新授权",
      "locGuideLater": "暂不开启",
      "locGuideBrowser": "若未弹出系统提示，请点击地址栏锁标/信息图标，将「位置」设为允许后重试。",
      "locGuideDenied": "定位权限已被拒绝，浏览器不会再次弹出提示。请先按步骤开启位置权限。",
      "locGuideLocating": "正在获取位置…",
      "locGuideDone": "位置已记录",
      "locGuideUnsupported": "当前浏览器不支持定位，请换用 Chrome / Edge / Safari 并使用 HTTPS 打开。",
      "signRequired": "需要签署",
      "signRequiredTip": "分享后甲乙双方可手写签名，签署区会出现在合同底部",
      "signOptional": "无需签署",
      "signOptionalTip": "仅作查阅与打印，页面不显示签字区域，也无法再签署",
      "noSignNeeded": "无需签署",
      "noSignHint": "本合同仅供查阅与存档，不需要甲乙双方手写签名。",
      "viewOnlyTip": "本合同设置为无需签署，可直接查阅或导出打印。",
      "needParties": "请填写甲方与乙方",
      "needBody": "请填写合同正文（可插入表格）",
      "confirmDel": "确定删除合同「{no}」？"
    },
    card: {
      "eyebrow": "多模板 · 可分享",
      "title": "电子名片",
      "lead": "填写资料、选模板，一键生成 H5 链接与小程序分享；支持电话、微信、地图导航与导出图片。",
      "quota": "制作配额",
      "remain": "剩余 {n} 张",
      "editCard": "编辑名片",
      "newCard": "新建名片",
      "cancelEdit": "取消编辑",
      "cardTitle": "名片标题",
      "phTitle": "如：张三的名片",
      "themeColor": "主题色",
      "name": "姓名",
      "required": "必填",
      "jobTitle": "职位",
      "phJob": "如：产品经理",
      "company": "公司 / 组织",
      "mobile": "手机",
      "phone": "座机",
      "email": "邮箱",
      "wechat": "微信号",
      "website": "官网",
      "intro": "简介",
      "phIntro": "一句话介绍自己",
      "avatar": "头像",
      "notUploaded": "未上传",
      "clear": "清除",
      "wechatQr": "微信二维码",
      "qrUploadHint": "上传原图将自动解码重绘",
      "regenQr": "生成/重绘",
      "qrFieldHint": "上传微信「我的二维码」原图即可；系统会自动识别并重绘。识别失败时可选择保留原图。",
      "address": "地址",
      "phAddress": "展示用地址文案",
      "mapLoc": "地图定位",
      "altPicked": "已选位置",
      "pickOnMap": "在地图上选择办公地址或门店",
      "located": "已定位",
      "pickedPoint": "已选坐标点",
      "noLocYet": "尚未选择位置",
      "mapUnavailable": "暂不可用",
      "mapPickHint": "打开地图搜索、点选后确认",
      "needMapKey": "请管理员配置腾讯或高德地图 Key",
      "rePick": "重新选点",
      "pickMap": "地图选点",
      "coordTip": "访客页将展示位置预览，并支持唤起高德 / 腾讯 App 导航。",
      "quickActions": "快捷操作",
      "actCall": "打电话",
      "actSms": "发短信",
      "actWechat": "加微信",
      "actMap": "导航",
      "actEmail": "发邮件",
      "actCopy": "复制信息",
      "actWebsite": "官网",
      "saveEdit": "保存修改",
      "createCard": "创建名片",
      "livePreview": "实时预览",
      "myCards": "我的名片（{n}）",
      "empty": "还没有名片，左侧创建第一张吧",
      "viewsMeta": "· 浏览 {n} · {t}",
      "pendingTip": "审核通过后才可公开分享",
      "bannedTip": "已被管理员封禁，无法分享",
      "shareOn": "分享开",
      "shareOff": "已关",
      "share": "分享",
      "edit": "编辑",
      "exportImg": "导出图",
      "delete": "删除",
      "altMiniQr": "小程序码",
      "scanOpen": "微信扫一扫打开名片",
      "h5Link": "H5 链接",
      "copy": "复制",
      "shareText": "分享文案",
      "openH5": "打开 H5",
      "exportImage": "导出图片",
      "dlMiniQr": "下载小程序码",
      "tierAdmin": "管理员已为你单独设置",
      "tierMember": "会员配额",
      "tierExpired": "会员到期配额",
      "tierFree": "普通用户默认配额",
      "shareOf": "「{name}」分享",
      "shareCard": "分享名片",
      "uploadOk": "上传成功",
      "uploadFail": "上传失败",
      "qrRedrawOk": "已识别微信码并重绘为干净二维码",
      "qrDecodeFailMsg": "未能自动识别码内容（微信原图常含头像与装饰）。可保留原图上传，或换一张更清晰、裁掉边框的二维码区域再试。",
      "qrDecodeFailTitle": "识别未成功",
      "keepOriginal": "保留原图上传",
      "cancel": "取消",
      "keptOriginal": "已上传原图（未重绘）",
      "processFail": "处理失败",
      "needWechatSource": "请先上传可识别的微信码，或填写微信号后再生成",
      "qrGenOk": "二维码已生成",
      "genFail": "生成失败",
      "noMapKey": "未配置地图 Key",
      "locConfirmed": "位置已确认",
      "needName": "请填写姓名",
      "saved": "已保存",
      "created": "名片已创建",
      "shareOpened": "已开启分享",
      "shareClosed": "已关闭分享",
      "confirmDel": "确定删除「{name}」？",
      "delTitle": "删除名片",
      "deleted": "已删除",
      "miniQrFallback": "小程序码暂不可用，可先复制 H5 链接",
      "copied": "已复制",
      "linkCopied": "链接已复制",
      "textCopied": "文案已复制",
      "copyFail": "复制失败",
      "noPhone": "未填写电话",
      "noMobile": "未填写手机号",
      "noEmail": "未填写邮箱",
      "noWebsite": "未填写官网",
      "wechatCopied": "微信号已复制",
      "scanWechat": "请扫码添加微信",
      "noWechat": "未填写微信",
      "wechatLine": "微信 {id}",
      "infoCopied": "名片信息已复制",
      "noAddress": "未设置地址",
      "destination": "目的地",
      "exportBrand": "青苹果 · 电子名片",
      "exportOk": "图片已导出"
    },
    comment: {
      "eyebrow": "班主任 · AI 评语",
      "title": "学生评语",
      "lead": "按班级导入学生、打上个性标签，一键生成期末 / 期中 / 学期评语。支持表格导入，评语可分享给家长手机查看。",
      "desc": "按班级导入学生、用标签与 AI 生成评语，可分享给家长。",
      "classQuota": "班级配额",
      "remainClasses": "还可创建 {n} 个班级",
      "perClass": "人 / 班",
      "studentCap": "每班人数上限",
      "aiBanner": "管理员尚未配置智谱 API，暂时无法生成评语。仍可建班、导入学生与手写评语。",
      "aiBannerShort": "智谱 API 未就绪，无法自动生成评语。",
      "newClass": "新建班级",
      "newClassTip": "填写班级信息后即可导入学生",
      "className": "班级名称",
      "phClassName": "如：三年二班",
      "school": "学校",
      "phSchool": "学校全称",
      "grade": "年级",
      "phGrade": "如：三年级",
      "location": "班级位置",
      "phLocation": "如：教学楼 3 楼东侧 / 一班",
      "phLocationShort": "如：三楼东侧",
      "semester": "学期",
      "phSemester": "如：2025–2026 学年第一学期",
      "commentDate": "评语日期",
      "phCommentDate": "全班默认日期，可稍后改",
      "phCommentDateClass": "全班默认，学生可单独覆盖",
      "commentType": "评语类型",
      "brandCredit": "平台署名",
      "hideBrand": "分享页隐藏署名",
      "brandHint": "免费用户分享页默认展示平台署名；会员创建的班级不会显示。",
      "createClass": "创建班级",
      "myClasses": "我的班级",
      "emptyClasses": "还没有班级，先在上方创建一个",
      "noPlace": "未填写学校 / 年级",
      "people": "{n} 人",
      "commented": "{n} 已写评语",
      "enter": "进入",
      "delete": "删除",
      "backList": "返回班级列表",
      "previewPrompt": "预览指令",
      "exportExcel": "导出 Excel",
      "batchGen": "批量生成",
      "classSettings": "班级设置",
      "saveSettings": "保存设置",
      "extraReq": "补充要求",
      "phExtra": "可选：希望评语更口语化、多鼓励阅读等",
      "customTags": "本班自定义标签",
      "phNewTag": "新增标签",
      "add": "添加",
      "importStudents": "导入 / 添加学生",
      "importCap": "每班最多 {limit} 人 · 当前 {n} 人",
      "excelImport": "表格导入",
      "excelTip": "下载模板后，一行一个学生。支持 xlsx / csv。",
      "dlTemplate": "下载模板",
      "uploadSheet": "上传表格",
      "phPasteNames": "也可以直接粘贴名单：每行一个姓名。支持逗号、分号分隔；行首序号会自动去掉。",
      "importNames": "导入名单",
      "phOneName": "单个姓名",
      "studentList": "学生列表",
      "phSearchName": "搜索姓名",
      "genPending": "生成未写 {n}",
      "overwriteAll": "覆盖全部重写",
      "batchProgress": "已完成 {done} / {total}",
      "batchFailed": " · 失败 {n}",
      "emptyStudents": "还没有学生",
      "colName": "姓名",
      "colGender": "性别",
      "genderEmpty": "未填",
      "genderMale": "男",
      "genderFemale": "女",
      "colTags": "标签",
      "clickAdd": "点击添加",
      "colRemark": "备注",
      "phRemark": "课堂观察",
      "colDate": "日期",
      "phClassDate": "班级日期",
      "colComment": "评语预览",
      "notGenerated": "尚未生成",
      "chars": "{n} 字",
      "colShare": "分享",
      "preview": "预览",
      "copyLink": "复制链接",
      "colAction": "操作",
      "rewrite": "重写",
      "generate": "生成",
      "prompt": "指令",
      "dlgTags": "选择个性标签",
      "dlgTagsTip": "可多选，最多 20 个。生成评语时会依据这些标签来写，不会编造成绩或具体事件。",
      "dlgSelected": "已选 {n} / 20",
      "classCustom": "本班自定义",
      "cancel": "取消",
      "saveTags": "保存标签",
      "dlgPrompt": "AI 指令预览",
      "typeFinal": "期末评语",
      "typeMid": "期中评语",
      "typeTerm": "学期评语",
      "typeDaily": "日常评语",
      "quotaAdmin": "管理员已单独设置",
      "quotaMember": "会员档",
      "quotaFree": "免费档 · 使用站点默认配额",
      "studentAdmin": "管理员已单独设置每班人数",
      "studentMember": "会员可导入更多学生",
      "studentFree": "免费档每班人数上限",
      "memberOk": "会员身份有效",
      "memberUpsell": "开通会员可提升班级数与每班人数",
      "needClassName": "请填写班级名称",
      "classCreated": "班级已创建",
      "createFail": "创建失败",
      "openFail": "打开失败",
      "saved": "已保存",
      "tagExists": "标签已存在",
      "tagLimit": "自定义标签最多 {n} 个",
      "addFail": "添加失败",
      "imported": "已导入 {n} 人",
      "skipped": "，跳过 {n} 人（已达上限）",
      "importFail": "导入失败",
      "tplDownloaded": "模板已下载，一行填写一名学生",
      "tplFail": "模板下载失败",
      "readFail": "读取文件失败",
      "noNamesInSheet": "表格里没有读到姓名",
      "sheetFail": "表格导入失败",
      "added": "已添加",
      "tagsSaved": "标签已保存",
      "overwriteConfirm": "「{name}」已有评语，确定覆盖重写？",
      "overwriteTitle": "覆盖评语",
      "generated": "已生成",
      "genFail": "生成失败",
      "noStudents": "没有学生",
      "noPending": "没有尚未生成评语的学生",
      "batchOverwriteConfirm": "将覆盖 {n} 名学生的已有评语，确定继续？",
      "batchOverwriteTitle": "批量覆盖",
      "batchDone": "批量完成 {n} 条",
      "batchFailPart": "，失败 {n}",
      "batchFail": "批量生成失败",
      "needStudents": "请先添加学生",
      "previewFail": "预览失败",
      "exported": "已导出 Excel",
      "exportFail": "导出失败",
      "noShare": "暂无分享链接",
      "enableShareFirst": "请先开启该生分享",
      "shareCopied": "分享链接已复制",
      "copied": "已复制",
      "delStudentConfirm": "删除学生「{name}」及其评语？",
      "delTitle": "删除",
      "deleted": "已删除",
      "delClassConfirm": "删除班级「{name}」及全部学生评语？不可恢复。",
      "delClassTitle": "删除班级"
    },
  },
  about: {
    browseArticles: '浏览文章',
    contactMe: '联系我',
    role: '前端开发者 · 技术写作者',
    bio1: '一名热爱技术的前端开发者，专注于 Web 前端工程化与用户体验设计。这个博客是我记录学习笔记、技术思考、软件推荐与项目经验的地方。',
    bio2: '希望把复杂的技术问题讲清楚，把好用的工具分享给大家，让每一次阅读都有所收获。',
    online: '在线创作中',
    focusEyebrow: 'FOCUS',
    focusTitle: '我在做什么',
    focusSub: '用写作沉淀经验，用分享连接更多开发者',
    focusWrite: '技术写作',
    focusWriteDesc: '分享前端开发经验、工程化实践与性能优化思路，把复杂问题讲清楚。',
    focusTools: '工具推荐',
    focusToolsDesc: '精选实用软件与小工具，提升日常开发与学习效率。',
    focusTutorial: '教程实战',
    focusTutorialDesc: '从入门到进阶的项目教程，帮助读者建立完整的知识体系。',
    contentEyebrow: 'CONTENT',
    contentTitle: '博客内容方向',
    contentSub: '四大栏目，覆盖从入门到进阶的学习路径',
    techDesc: '前端开发、性能优化、工程实践',
    softwareDesc: '小工具、办公与开发效率软件',
    tutorialDesc: '入门到进阶的系统化学习',
    resourceDesc: '学习资料、开源项目与书籍',
    statArticles: '文章总数',
    statTech: '技术文章',
    statSoftware: '软件推荐',
    statTutorialResource: '教程 & 资源',
    techGroupFront: '前端框架',
    techGroupLang: '语言与样式',
    techGroupEng: '工程化',
    techGroupOther: '其他',
    tagEng: '工程化',
    tagUx: '用户体验',
    articleCount: '{n} 篇文章',
    stackTitle: '技术栈',
    stackSub: '日常开发与技术写作中频繁使用的工具与框架',
    ctaTitle: '一起交流，共同进步',
    ctaDesc: '欢迎通过邮件交流技术问题、合作事宜或内容建议。也欢迎关注与支持本站持续创作。',
    sponsorSupport: '赞助支持'
  },
  sponsor: {
    badge: '赞助会员',
    title: '支持{name}，解锁更多优质内容',
    desc: '您的赞助将帮助站点持续更新教程、软件推荐与技术文章。选择合适方式开通或续费会员。',
    memberUntil: '当前赞助有效期至',
    renewNote: '续费将在到期日基础上延长',
    plansRenew: '续费套餐',
    plansBuy: '会员套餐',
    plansDirectTip: '选择套餐完成赞助，支付成功后自动开通会员',
    plansExternalTip: '选择合适套餐前往发卡平台购买，购买后返回本站兑换 CDK 激活',
    plansIntroTip: '以下为会员套餐介绍，购买后请使用兑换码激活',
    originalPrice: '原价 ¥{price}',
    unitPrice: '折合 {unit}',
    renew: '续费',
    sponsorNow: '立即赞助',
    payNow: '支付宝支付',
    payRenew: '支付宝续费',
    alipayTitle: '支付宝安全支付',
    alipayTip: '支付完成后会员自动开通，可在个人中心查看订单',
    payDialogTitle: '支付宝付款',
    payCreating: '正在创建支付订单…',
    payWaiting: '请在新打开的支付宝页面完成付款，本页将自动确认结果',
    payPolling: '等待支付结果中，请勿关闭',
    scanAlipay: '打开支付宝扫一扫完成支付',
    openAlipayPage: '打开支付宝收银台',
    reopenPay: '重新打开支付页',
    retryPay: '重新发起支付',
    payNoForm: '支付表单生成失败，请重试或联系管理员',
    paySuccess: '支付成功，会员已开通',
    paySuccessUntil: '支付成功，有效期至 {date}',
    payFailed: '支付未完成或已取消',
    payTimeout: '等待超时，若已付款请稍后刷新或在个人中心查看订单',
    payNotReady: '支付宝尚未配置完成，请稍后再试或联系管理员',
    payDone: '完成',
    close: '关闭',
    confirmPay: '去支付宝支付',
    goBuy: '前往购买',
    onlineBuy: '在线购买会员',
    empty: '会员购买功能暂未开放，请联系管理员',
    faqTitle: '常见问题',
    faq1q: '赞助后可以使用哪些权益？',
    faq1a: '可阅读全站标注为「会员专享」的文章与章节，并在个人中心查看赞助订单记录。',
    faq2q: '续费如何计算有效期？',
    faq2a: '若当前赞助未过期，新套餐时长将在原到期日基础上叠加；若已过期，则从激活日起算。',
    faq3q: 'CDK 兑换码如何使用？',
    faq3a: '在发卡平台购买会员后获得兑换码，登录本站后在上方输入框填写并点击「立即兑换」即可激活对应套餐时长。',
    faq4q: '购买后如何激活？',
    faq4a: '在发卡平台完成购买后，返回本页输入收到的 CDK 兑换码即可自动激活会员。',
    faqPayQ: '支付宝支付安全吗？如何开通？',
    faqPayA: '支付跳转至支付宝官方收银台完成。付款成功后系统会自动开通或续费会员，一般几秒内生效。',
    cdkReturnHint: '购买后请返回此页输入兑换码完成激活',
    confirmRenew: '续费',
    confirmSponsor: '赞助',
    confirmTitle: '{action}赞助会员',
    confirmMsg: '确认{action}「{name}」？（¥{price}，{duration}）',
    confirmOk: '确认{action}',
    cancel: '取消'
  },
  profile: {
    member: '赞助会员',
    normalUser: '普通用户',
    joinedAt: '加入于 {date}',
    memberUntil: '赞助至 {date}',
    changeAvatar: '更换头像',
    admin: '系统后台',
    renew: '续费赞助',
    openSponsor: '开通赞助',
    history: '浏览记录',
    orders: '订单',
    unlocked: '已解锁',
    sideLabel: '账户中心',
    navAria: '个人中心导航',
    tabInfo: '个人信息',
    tabInfoShort: '资料',
    tabSecurity: '账号安全',
    tabSecurityShort: '安全',
    tabHistory: '浏览历史',
    tabHistoryShort: '历史',
    tabPoints: '我的积分',
    tabPointsShort: '积分',
    tabMember: '赞助会员',
    tabMemberShort: '会员',
    tabOrders: '赞助订单',
    tabOrdersShort: '订单',
    guestTitle: '登录后管理个人中心',
    guestDesc: '同步浏览历史、积分签到、赞助会员与订单记录',
    loginNow: '立即登录'
  },
  copyright: {
    backHome: '返回首页',
    title: '版权声明',
    desc: '欢迎访问「{name}」网站。请仔细阅读以下条款，使用本站即表示您已阅读并同意本声明的全部内容。',
    updated: '最后更新：2026 年 3 月 10 日',
    effective: '生效日期：2026 年 1 月 1 日',
    toc: '目录',
    contactPrefix: '如您对本声明有任何疑问，请通过邮箱',
    contactSuffix: '与我们联系。我们将在合理期限内予以回复。',
    enNotice: '英文版本仅供参考；如与中文内容不一致，以中文为准。'
  },
  redirect: {
    back: '返回上一页',
    leaving: '即将离开本站',
    invalid: '链接无效',
    leavingDesc: '您即将访问第三方网站，请确认目标地址后再继续。',
    invalidDesc: '无法识别或解析该链接，请检查地址是否正确。',
    targetSite: '目标网站',
    copy: '复制',
    copied: '已复制',
    linkName: '链接名称',
    fromArticle: '来源文章',
    safety: '安全提示',
    tip1: '第三方网站的内容、隐私政策与安全措施由该网站自行负责。',
    tip2: '请勿在未知页面输入账号、密码或支付信息。',
    tip3: '如遇可疑页面，请立即关闭并返回本站。',
    cancel: '取消返回',
    confirm: '确认前往',
    countdown: '点击确认后将在新标签页打开目标链接，本站页面保持不变',
    invalidReason: '可能原因：链接格式错误、协议不受支持，或缺少跳转参数。',
    backHome: '返回首页',
    footerTip: '{name} 对外链访问进行安全提示，保护您的浏览体验'
  },
  common: {
    langSwitched: '已切换语言',
    tip: '提示',
    backTop: '回到顶部',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    reply: '回复'
  },
  comments: {
    title: '评论',
    approvalTip: '评论需审核后公开显示，您自己的待审评论会标注「审核中」',
    placeholder: '写下你的想法，支持插入图片与链接…',
    submit: '发表评论',
    loading: '加载评论中…',
    empty: '还没有评论，来抢沙发吧',
    pending: '审核中',
    hidden: '已隐藏',
    replyTo: '回复',
    editPh: '编辑评论…',
    replyPh: '回复 @{name}…',
    submitReply: '发表回复',
    loadFailed: '加载评论失败',
    pickImage: '请选择图片文件',
    imageInserted: '图片已插入',
    uploadFailed: '图片上传失败',
    needContent: '请输入评论内容',
    needReply: '请输入回复内容',
    posted: '发表成功',
    postFailed: '发表失败',
    replied: '回复成功',
    replyFailed: '回复失败',
    emptyContent: '评论内容不能为空',
    updated: '评论已更新',
    updateFailed: '更新失败',
    deleteConfirm: '确定删除这条评论吗？',
    deleted: '评论已删除',
    deleteFailed: '删除失败'
  },
  auth: {
    login: '登录',
    logout: '退出登录',
    loggedOut: '已退出登录',
    register: '注册',
    createAccount: '创建账号',
    welcomeBack: '欢迎回来',
    joinUs: '加入我们',
    forgotTitle: '找回密码',
    welcomeDesc: '登录账号，继续你的阅读之旅',
    registerDesc: '创建账号，探索更多优质内容',
    qrDesc: '微信扫码，安全快捷登录网站',
    qrPending: '请使用微信扫一扫打开小程序并确认登录',
    qrPendingMobile: '同机无法扫码时，可打开小程序输入下方验证码确认',
    qrShortLabel: '网页登录验证码',
    qrShortTip: '打开「文雅琪工具」小程序 → 我的 → 网页登录，输入此验证码',
    openMiniLogin: '打开小程序确认登录',
    openMiniTip: '将跳转到微信小程序完成确认；若未跳转请改用验证码',
    openMiniFail: '无法直接打开小程序，请使用验证码登录',
    samePhoneTip: '手机无法扫本机二维码时：打开小程序「我的 → 网页登录」，输入上方 6 位验证码即可',
    forgotDesc1: '通过注册邮箱验证身份，安全重置您的密码',
    forgotDesc2: '设置新密码后即可重新登录账号',
    featCollect: '收藏喜欢的文章',
    featHistory: '同步浏览历史记录',
    featPersonal: '个性化阅读体验',
    featEmail: '邮箱验证保障账号安全',
    featCode: '验证码 10 分钟内有效',
    featReset: '重置后可立即登录',
    passwordLogin: '账号登录',
    qrLogin: '小程序扫码',
    account: '账号',
    accountPh: '用户名或邮箱',
    password: '密码',
    passwordPh: '请输入密码',
    forgot: '忘记密码？',
    noAccount: '还没有账号？',
    registerNow: '立即注册',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    backLogin: '返回登录',
    username: '用户名',
    usernamePh: '须大于 5 位',
    email: '邮箱',
    emailCode: '邮箱验证码',
    codePh: '6 位验证码',
    getCode: '获取验证码',
    resendIn: '{n}s 后重发',
    resend: '重新发送',
    passwordRule: '须大于 8 位',
    confirmPassword: '确认密码',
    confirmPh: '再次输入密码',
    forgotHint1: '输入注册邮箱，获取验证码',
    forgotHint2: '设置您的新密码',
    registeredEmail: '注册邮箱',
    registeredEmailPh: '请输入注册时使用的邮箱',
    sendCode: '发送验证码',
    code: '验证码',
    newPassword: '新密码',
    newPasswordPh: '至少 6 位',
    qrAlt: '扫码登录',
    qrLoading: '二维码加载中…',
    qrExpired: '已过期，点击刷新',
    qrRefresh: '刷新二维码',
    qrExpiredHint: '二维码已过期，请刷新',
    qrCancelled: '已取消，可刷新后重试',
    qrError: '二维码加载失败',
    qrIdle: '请选择小程序扫码登录',
    rememberPassword: '想起密码了？',
    resetPassword: '重置密码',
    confirmNewPassword: '确认新密码',
    confirmNewPh: '再次输入新密码'
  },
  user: {
    menu: '用户菜单',
    member: '赞助会员',
    normal: '普通用户',
    expireUntil: '有效期至 {date}',
    openHint: '开通赞助解锁更多内容',
    checkin: '签到',
    checkinDaily: '每日签到',
    checkedIn: '已签到',
    checkedInToday: '今日已签到',
    checkinReward: '签到可得 +{n} {name}',
    profile: '个人中心',
    myPoints: '我的积分',
    history: '浏览历史',
    recent: '最近浏览',
    viewAll: '查看全部',
    noHistory: '还没有浏览记录',
    justNow: '刚刚',
    minutesAgo: '{n} 分钟前',
    hoursAgo: '{n} 小时前',
    streak: '已连续 {n} 天'
  }
}
